webpackJsonp([0],Array(380).concat([
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_home_vue__ = __webpack_require__(381);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65768a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_home_vue__ = __webpack_require__(479);
function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65768a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_app_footer__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_app_header__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_banner__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_section_about__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_section_addresses__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_section_app__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_home_section_banner__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_home_section_benefits__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_home_section_brand__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_home_section_faq__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_home_section_features__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_home_section_mobile__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_home_section_how_it_work__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_home_section_how_to_use__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_home_section_slider__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_home_section_how_it_work_slider__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_home_section_our_plans__ = __webpack_require__(475);



var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response, countryCode, codeByCountry;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return this.$httpGeoLocation.get();

					case 3:
						response = _context.sent;
						countryCode = response.data.countryCode;

						this.countryCode = response.data.countryCode;
						this.lat = response.data.lat;
						this.lon = response.data.lon;
						codeByCountry = {
							PE: '' + 'https://registro.casamarket.la/',
							EC: '' + 'https://registro-ec.casamarket.la/'
						};

						this.landingLink = codeByCountry[countryCode];
						_context.next = 15;
						break;

					case 12:
						_context.prev = 12;
						_context.t0 = _context['catch'](0);

						this.showGenericError();

					case 15:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 12]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















function created() {
	this.loadData();
}

function openModal(action) {
	var _this = this;

	this.linkPageIFrame = action.linkPage;
	this.dialog = true;
	setTimeout(function () {
		_this.loading = false;
	}, 3000);
}

function closeModal() {
	this.dialog = false;
	this.loading = true;
	this.linkPageIFrame = '';
}

function numberMoney() {
	return this.countryCode === 'EC' ? '$150' : 'S/500';
}

function discountMoney() {
	return this.countryCode === 'EC' ? 'S/300' : 'S/300';
}

function openRegister() {
	var _this2 = this;

	this.linkPageIFrame = 'https://casamarket.la/activa-tu-app?plan=true&code=' + this.countryCode + '&lat=' + this.lat + '&lon=' + this.lon + '#formulario';
	this.dialog = true;
	setTimeout(function () {
		_this2.loading = false;
	}, 3000);
}

function openRegisterBanner(flag) {
	var _this3 = this;

	var url = 'https://casamarket.la/activa-tu-app?code=' + this.countryCode + '&lat=' + this.lat + '&lon=' + this.lon + '#formulario';
	if (flag) {
		url = 'https://casamarket.la/activa-tu-app?plan=true&code=' + this.countryCode + '&lat=' + this.lat + '&lon=' + this.lon + '#formulario';
	}
	this.linkPageIFrame = url;
	this.dialog = true;
	setTimeout(function () {
		_this3.loading = false;
	}, 3000);
}

function data() {
	return {
		landingLink: '',
		dialog: false,
		linkPageIFrame: '',
		loading: true,
		countryCode: '',
		lat: null,
		lon: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-home',
	components: {
		appFooter: __WEBPACK_IMPORTED_MODULE_2__components_home_app_footer__["a" /* default */],
		appHeader: __WEBPACK_IMPORTED_MODULE_3__components_home_app_header__["a" /* default */],
		banner: __WEBPACK_IMPORTED_MODULE_4__components_home_banner__["a" /* default */],
		sectionAbout: __WEBPACK_IMPORTED_MODULE_5__components_home_section_about__["a" /* default */],
		sectionAddresses: __WEBPACK_IMPORTED_MODULE_6__components_home_section_addresses__["a" /* default */],
		sectionApp: __WEBPACK_IMPORTED_MODULE_7__components_home_section_app__["a" /* default */],
		sectionBanner: __WEBPACK_IMPORTED_MODULE_8__components_home_section_banner__["a" /* default */],
		sectionBenefits: __WEBPACK_IMPORTED_MODULE_9__components_home_section_benefits__["a" /* default */],
		sectionBrand: __WEBPACK_IMPORTED_MODULE_10__components_home_section_brand__["a" /* default */],
		sectionFaq: __WEBPACK_IMPORTED_MODULE_11__components_home_section_faq__["a" /* default */],
		sectionFeatures: __WEBPACK_IMPORTED_MODULE_12__components_home_section_features__["a" /* default */],
		sectionHowItWork: __WEBPACK_IMPORTED_MODULE_14__components_home_section_how_it_work__["a" /* default */],
		sectionHowToUse: __WEBPACK_IMPORTED_MODULE_15__components_home_section_how_to_use__["a" /* default */],
		sectionSlider: __WEBPACK_IMPORTED_MODULE_16__components_home_section_slider__["a" /* default */],
		sectionHowItWorkSlider: __WEBPACK_IMPORTED_MODULE_17__components_home_section_how_it_work_slider__["a" /* default */],
		sectionOurPlans: __WEBPACK_IMPORTED_MODULE_18__components_home_section_our_plans__["a" /* default */],
		sectionMobile: __WEBPACK_IMPORTED_MODULE_13__components_home_section_mobile__["a" /* default */]
	},
	computed: {
		numberMoney: numberMoney,
		discountMoney: discountMoney
	},
	methods: {
		openModal: openModal,
		closeModal: closeModal,
		openRegister: openRegister,
		loadData: loadData,
		openRegisterBanner: openRegisterBanner
	},
	created: created,
	data: data
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-footer'
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function created() {
	window.addEventListener('scroll', this.handleScroll);
}

function destroyed() {
	window.removeEventListener('scroll', this.handleScroll);
}

function handleScroll() {
	this.scrolled = window.scrollY > 30;
}

function openMenuMobile() {
	this.openMobile = true;
}

function closeMenuMobile() {
	this.openMobile = false;
}

function data() {
	return {
		menu: [{
			id: 1,
			href: '#about',
			title: 'CasaMarket'
		}, {
			id: 2,
			href: '#stepbystep',
			title: 'Cómo Funciona'
		}, {
			id: 4,
			href: '#features',
			title: 'Beneficios'
		}, {
			id: 7,
			title: 'Nuestros Planes',
			href: '#plans'
		}, {
			id: 8,
			href: '#section-banner',
			title: 'Preguntas Frecuentes'
		}],
		scrolled: false,
		openMobile: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-header',
	data: data,
	created: created,
	destroyed: destroyed,
	methods: {
		handleScroll: handleScroll,
		openMenuMobile: openMenuMobile,
		closeMenuMobile: closeMenuMobile
	},
	props: {
		link: [String]
	}
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_btn_action__ = __webpack_require__(414);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function openModal(_ref) {
	var plan = _ref.plan;

	this.$emit('open-modal', plan);
}

function openPlans() {
	this.dialog = true;
}

function closeModal() {
	this.dialog = false;
}

function data() {
	return {
		actions: [{
			id: 1,
			title: 'QUIERO MI APLICATIVO MÓVIL PERSONALIZADO',
			image: '/static/images/sections/action-1.svg',
			text: 'TU APP PERSONALIZADA',
			link: '#stepbystep',
			outside: false,
			green: true,
			linkPage: 'https://casamarket.la/activa-tu-app?plan=true&code=' + this.countryCode + '&lat=' + this.lat + '&lon=' + this.lon + '#formulario',
			plan: true
		}, {
			id: 2,
			title: 'QUIERO RECIBIR PEDIDOS POR CASAMARKET',
			image: '/static/images/sections/action-2.svg',
			text: 'RECIBE PEDIDOS POR CASA MARKET',
			link: 'https://casamarket.la/',
			outside: true,
			green: false,
			linkPage: 'https://casamarket.la/activa-tu-app?code=' + this.countryCode + '&lat=' + this.lat + '&lon=' + this.lon + '#formulario',
			plan: false
		}],
		dialog: false
	};
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'banner',
	data: data,
	components: {
		btnAction: __WEBPACK_IMPORTED_MODULE_0__components_shared_btn_action__["a" /* default */]
	},
	methods: {
		closeModal: closeModal,
		openModal: openModal,
		openPlans: openPlans
	},
	props: {
		numberMoney: String,
		code: String,
		link: String,
		lat: [String, Number],
		lon: [String, Number]
	}
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'btn-action',
	props: {
		action: {
			type: Object,
			default: function _default() {}
		}
	}
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_card_icon__ = __webpack_require__(422);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function data() {
	return {
		cards: [{
			id: 1,
			alt: 'aumentar ventas, fidelizar clientes, evitar contagios',
			icon: '/static/images/icons/icon-1-CM.svg',
			text: 'Ayudamos a incrementar tus ventas y fidelizar a tus clientes.'
		}, {
			id: 2,
			alt: 'tu propia marca y logo',
			icon: '/static/images/icons/icon-2-CM.svg',
			text: 'App 100% personalizada a tu negocio: con tu marca y logo.'
		}, {
			id: 3,
			alt: 'sencillo de usar',
			icon: '/static/images/icons/icon-3-CM.svg',
			text: 'Muy sencillo de usar para ti y tus clientes de siempre.'
		}, {
			id: 4,
			alt: 'Somos una comunidad de comercios locales',
			icon: '/static/images/icons/icon-4-CM.svg',
			text: 'Somos una comunidad de comercios locales.'
		}, {
			id: 5,
			alt: 'Promovemos el distanciamiento social.',
			icon: '/static/images/icons/icon-4-CM.svg',
			text: 'Promovemos el distanciamiento social.'
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-about',
	components: {
		cardIcon: __WEBPACK_IMPORTED_MODULE_0__components_shared_card_icon__["a" /* default */]
	},
	data: data
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'card-icon',
	props: {
		card: {
			default: function _default() {},
			type: Object
		}
	}
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		phone: '+51 940 637 220',
		phoneEcu: 'PBX (03) 3730500 / +593998514801'
	};
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-addresses',
	data: data
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		reasons: [{
			id: 1,
			title: 'Conveniencia y mayores beneficios para tus clientes',
			text: 'Podrás ofrecer a tus clientes un aplicativo móvil a través del cual pueden hacer y recibir pedidos 24/7, de manera más sencilla, segura y organizada.'
		}, {
			id: 2,
			title: 'Promover que se tenga menos contacto',
			text: 'Los hábitos de consumo ya cambiaron, y hoy en día cuidar la salud es lo primero. Con tu aplicativo CasaMarket te cuidas tú y cuidas a tus clientes.'
		}, {
			id: 3,
			title: 'Innovar, darle tecnología a tu negocio',
			text: 'Tendrás una herramienta muy potente para generar mayores ventas. Olvídate de hacer las cosas de manera manual, y apóyate de CasaMarket para gestionar mejor tu negocio'
		}, {
			id: 4,
			title: 'Tener un ticket promedio más alto',
			text: 'Las ventas a través de un aplicativo móvil significan aproximadamente un 50% de incremento, lo cual va a ayudarte a generar mayores ingresos.'
		}, {
			id: 5,
			title: 'Diferenciarte de tu competencia',
			text: 'Con CasaMarket tendrás una propuesta de valor diferenciada, y vas a destacar sobre tu competencia para tener nuevos y más fieles clientes.'
		}, {
			id: 6,
			title: 'Gestionar mejor tu tiempo',
			text: 'Al recibir tus pedidos de manera ordenada, vas a organizar mejor tu tiempo, y así hacer crecer tu negocio. Recuerda que los clientes pueden ir a recoger sus pedidos en el momento que estén listos o esperar el delivery en la comodidad de su casa.'
		}, {
			id: 7,
			title: 'Publicidad',
			text: 'Vas a poder publicitar mejor tu negocio con CasaMarket, ya que tienes una herramienta muy atractiva con este nuevo canal de ventas.'
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-app',
	data: data
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function data() {
	return {
		list: ['Promoción de lanzamiento. Pago único para implementación']
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-banner',
	data: data,
	props: {
		link: [String],
		numberMoney: String,
		discountMoney: String
	}
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function data() {
	return {
		benefitsLeft: [{
			id: 1,
			number: 1,
			text: 'Tus clientes se descargarán tu APP de Google play.'
		}, {
			id: 2,
			number: 2,
			text: 'Tendrás tu usuario y contraseña secreta para que puedas ingresar al administrador web.'
		}, {
			id: 3,
			number: 3,
			text: 'Podrás realizar dos tipos de entrega: El recojo en tienda y la entrega de pedidos a domicilio (delivery).'
		}, {
			id: 4,
			number: 4,
			text: 'Podrás administrar todo desde tu computadora o celular.'
		}, {
			id: 5,
			number: 5,
			text: 'Podrás gestionar tus productos, cambiar precios, agregar un nuevo producto o modificarlo.'
		}],
		benefitsRight: [{
			id: 6,
			number: 6,
			text: 'El servicio de implementación incluye:',
			list: ['3 horas de soporte por voz.', 'La carga de la base de datos de tus productos a la plataforma.', 'Soporte por correo, ilimitado.']
		}, {
			id: 7,
			number: 7,
			text: 'Acceder a nuestra promoción desde'
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-benefits',
	data: data,
	props: {
		link: [String]
	}
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		landingLink: 'https://registro.casamarket.la/',
		facebookUrl: 'https://www.facebook.com/Mi-bodega--107633674246248/',
		instagramUrl: 'https://instagram.com/casamarketapp?igshid=g4odcggvrd0w'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-brand',
	data: data
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function money() {
	return this.code === 'PE' ? 'céntimos' : 'centavos';
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-faq',
	computed: {
		money: money
	},
	props: {
		landingLink: [String],
		code: String
	}
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-features',
	props: {
		link: [String]
	}
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-mobile',
	props: {
		link: [String]
	}
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		landingLink: 'https://registro.casamarket.la/',
		steps: [{
			id: 1,
			class: 'step-image-1',
			gif: 'https://media.giphy.com/media/ZBKbRBelpwg9LGlZAf/giphy.gif',
			image: '/static/images/sections/step-1.png',
			number: 1,
			position: true,
			text: 'A través de tu aplicativo tus clientes podrán hacer sus pedidos: así de fácil.',
			title: 'Tu cliente realiza el pedido'
		}, {
			id: 2,
			class: 'step-image-2',
			gif: 'https://media.giphy.com/media/PhBSL6TvxLb9dqiltL/giphy.gif',
			image: '/static/images/sections/step-2.png',
			list: ['Por entregar', 'Listo para entrega', 'Entregado'],
			number: 2,
			position: false,
			text: 'Puedes recibir tus pedidos y filtrarlos:',
			title: 'Recibes el pedido de inmediato'
		}, {
			id: 3,
			class: 'step-image-3',
			gif: 'https://media.giphy.com/media/dsv0eAsC1naOjnc8Aj/giphy.gif',
			image: '/static/images/sections/step-3.png',
			list: ['Alistar tu pedido y lo pones en cola de entrega para que el usuario solo tenga que recoger su pedido o esperarlo en su domicilio.', 'Aquí no te preocupes por el pago porque el usuario puede efectuar su pago a través de distintas plataformas online, o hace el pago efectivo. Como mejor te acomode.'],
			number: 3,
			position: true,
			title: 'Preparas tu pedido'
		}, {
			id: 4,
			class: 'step-image-4',
			gif: 'https://media.giphy.com/media/SXIW01sfEu953X6FD6/giphy.gif',
			image: '/static/images/sections/step-4.png',
			number: 4,
			position: false,
			text: 'Pedido listo para entrega en la modalidad que el cliente elija. Cliente Satisfecho.',
			title: 'Listo, confirmar para entrega'
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-how-ir-work',
	data: data
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function created() {
	this.active = this.items.find(function (item) {
		return item.code === 'registerActive';
	});
}

function activeStep(step) {
	this[step] = true;
	this.active = this.items.find(function (item) {
		return item.code === step;
	});
	if (step === 'customActive') {
		this.shareActive = false;
		this.sellActive = false;
	} else if (step === 'shareActive') {
		this.customActive = true;
		this.sellActive = false;
	} else {
		this.customActive = true;
		this.shareActive = true;
	}
}

function restoreAll() {
	this.active = this.items.find(function (item) {
		return item.code === 'registerActive';
	});
	this.customActive = false;
	this.shareActive = false;
	this.sellActive = false;
}

function data() {
	return {
		active: {
			paragraphs: []
		},
		items: [{
			id: 1,
			code: 'registerActive',
			image: '/static/images/sections/feature-1.png',
			title: 'Regístrate',
			paragraphs: [{
				id: 1,
				text: 'Inscríbete en <a href="https://www.casamarket.la" target="_blank">casamarket.la</a> y uno de nuestros asesores se comunicará contigo para hacerte una presentación detallada de servicio.'
			}, {
				id: 2,
				text: 'Al registrarte nos ayudas a que nos comuniquemos contigo y validemos tu información.Además, te mantendremos informados sobre mejoras y actualizaciones de tu app.'
			}]
		}, {
			id: 2,
			code: 'customActive',
			image: '/static/images/sections/use-2.png',
			title: 'Personaliza',
			paragraphs: [{
				id: 1,
				text: '¿CÓMO EMPEZAR A USAR MI CASAMARKET?  Tu app es muy amigable y fácil de usar.'
			}, {
				id: 2,
				text: 'Personaliza tu aplicativo.',
				list: ['Logo', 'Imágenes de producto', 'Banners promocionales']
			}, {
				id: 3,
				text: 'No te preocupes si no tienes idea de cómo hacerlo, nosotros te asesoramos.'
			}]
		}, {
			id: 3,
			code: 'shareActive',
			image: '/static/images/sections/use-3.png',
			title: 'Comparte',
			paragraphs: [{
				id: 1,
				text: '¿CÓMO EMPEZAR A USAR CASAMARKET?  Tu app es muy amigable y fácil de usar.'
			}, {
				id: 2,
				text: 'Podrás decirle a tus clientes que se descarguen tu app.Comienza a generar pedidos con tu app.'
			}, {
				id: 3,
				text: 'Te ayudamos a compartir tu app con:',
				list: ['PlaySorte', 'Link generado', 'Código QR']
			}]
		}, {
			id: 4,
			code: 'sellActive',
			image: '/static/images/sections/use-4.png',
			title: 'Vende',
			span: 'LISTO:',
			text: 'INCREMENTA TUS VENTAS. RECIBIR Y ATENDER PEDIDOS ES MUY SENCILLO',
			paragraphs: [{
				id: 1,
				text: '¿CÓMO EMPEZAR A USAR MI CASAMARKET?  Tu app es muy amigable y fácil de usar'
			}]
		}],
		customActive: false,
		registerActive: true,
		shareActive: false,
		sellActive: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-how-to-user',
	created: created,
	data: data,
	methods: {
		activeStep: activeStep,
		restoreAll: restoreAll
	}
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function data() {
	return {
		slides: [{
			id: 2,
			actions: [{
				id: 1,
				text: 'Recibe en tu celular los pedidos que realicen tus clientes.'
			}, {
				id: 2,
				text: 'Mantén surtida tu app, y acompaña tus productos con fotos.'
			}, {
				id: 3,
				text: 'Conoce más a tus clientes: Historial de pedidos por fecha, hora, precio, frecuencia, etc.'
			}, {
				id: 4,
				text: 'Conoce más tu negocio: Descubre qué productos se venden más, la recurrencia, el ticket promedio etc.'
			}],
			alt: 'CasaMarket para ti',
			class: 'section-slider-slide-2',
			image: '/static/images/sliders/slide-2-CM.png',
			title: 'Para ti'
		}, {
			id: 1,
			actions: [{
				id: 1,
				text: 'Podrás agregar o eliminar productos, cambiar precios, y si no sabes cómo hacerlo, nosotros te ayudamos.'
			}, {
				id: 2,
				text: 'Podrás tener la base de datos de tus clientes:  Conoce sus hábitos de consumo y podrás comunicarle promociones.'
			}, {
				id: 3,
				text: 'Podrás agregar productos a través de un lector de códigos de barras.'
			}, {
				id: 4,
				text: 'Podrás ver los estados de los pedidos para organizarte mejor'
			}, {
				id: 6,
				text: 'Podrás acceder a un mapa.'
			}],
			alt: 'administrador mi casamarket',
			class: 'section-slider-slide-1',
			image: '/static/images/sliders/slide-1.png',
			title: 'Administrador'
		}, {
			id: 3,
			actions: [{
				id: 1,
				text: 'Tu cliente podrá realizar sus pedidos a través del celular.'
			}, {
				id: 2,
				text: 'Cuando el pedido esté listo, se le notificará para que recoja su pedido.'
			}, {
				id: 3,
				text: 'Podrá hacer comentarios adicionales a su pedido.'
			}, {
				id: 4,
				text: 'Podrá ver su historial de pedidos y el estado de su cuenta.'
			}, {
				id: 5,
				text: 'Podrá efectuar los pagos de manera online sin tener que ir al comercio.'
			}],
			alt: 'CasaMarket para tu cliente',
			class: 'section-slider-slide-3',
			image: '/static/images/sliders/slide-3.png',
			title: 'Para tu cliente'
		}],
		swiperOptions: {
			spaceBetween: 30,
			centeredSlides: true,
			autoplay: {
				delay: 100500,
				disableOnInteraction: true
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			}
		}
	};
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-slider',
	data: data
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function moveToIndex(index) {
	this.sliderIndex = index - 1;
}

function data() {
	return {
		items: [{
			id: 1,
			class: 'step-image-1',
			gif: 'https://media.giphy.com/media/ZBKbRBelpwg9LGlZAf/giphy.gif',
			image: '/static/images/sections/step-1.png',
			number: 1,
			position: true,
			text: 'A través de tu aplicativo tus clientes podrán hacer sus pedidos: así de fácil.',
			title: 'Tu cliente realiza el pedido',
			imageSecond: '/static/images/sections/how-1.png'
		}, {
			id: 2,
			class: 'step-image-2',
			gif: 'https://media.giphy.com/media/PhBSL6TvxLb9dqiltL/giphy.gif',
			image: '/static/images/sections/step-2.png',
			list: ['Por entregar', 'Listo para entrega', 'Entregado'],
			number: 2,
			position: false,
			text: 'Recibe notificaciones cuando tengas un nuevo pedido. Gestiona y filtra por estados:',
			title: 'Recibes el pedido de inmediato',
			imageSecond: '/static/images/sliders/slide-2-CM.png'
		}, {
			id: 3,
			class: 'step-image-3',
			gif: 'https://media.giphy.com/media/dsv0eAsC1naOjnc8Aj/giphy.gif',
			image: '/static/images/sections/step-3.png',
			list: ['Gestiona de una manera más ordenada los pedidos de tus clientes.', 'Alista el pedido y déjalo para entregar según la modalidad que el cliente elija: Recojo en tienda o Delivery.'],
			number: 3,
			position: true,
			title: 'Preparas tu pedido',
			imageSecond: '/static/images/sections/how-3.png'
		}, {
			id: 4,
			class: 'step-image-4',
			gif: 'https://media.giphy.com/media/SXIW01sfEu953X6FD6/giphy.gif',
			image: '/static/images/sections/step-4.png',
			number: 4,
			position: false,
			text: 'Entrega el pedido, y gestiónalo según el método de pago de tu preferencia. Cliente satisfecho.',
			title: 'Listo, confirmar para entrega',
			imageSecond: '/static/images/sections/how-4.png'
		}],
		sliderIndex: 0
	};
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-how-it-work-slider',
	data: data,
	methods: {
		moveToIndex: moveToIndex
	},
	props: {
		link: [String]
	}
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function openPlanDesktop() {
	this.urlImage = '/static/images/sections/plan-desktop.png';
	this.dialog = true;
}

function openPlanMobile(_ref) {
	var urlImage = _ref.urlImage;

	this.urlImage = urlImage;
	this.dialog = true;
}

function closeModal() {
	this.dialog = false;
}

function data() {
	return {
		items: [{
			id: 1,
			title: 'Plan Promocional',
			text: 'S/500.00',
			subtext: 'Licencia + Implementación',
			showAlert: false,
			urlImage: '/static/images/sections/plan-1.png'
		}, {
			id: 2,
			title: 'Plan básico',
			text: 'S/799.00',
			subtext: 'Licencia + Implementación',
			showAlert: false,
			urlImage: '/static/images/sections/plan-2.png'
		}, {
			id: 3,
			title: 'Plan Full',
			text: 'S/1,200.00',
			subtext: 'Licencia + Implementación',
			showAlert: true,
			urlImage: '/static/images/sections/plan-3.png'
		}, {
			id: 4,
			title: 'Plan MEGA',
			text: 'S/2,200.00',
			subtext: 'Licencia + Implementación',
			showAlert: false,
			urlImage: '/static/images/sections/plan-4.png'
		}, {
			id: 5,
			title: 'Plan MultiComercio',
			text: 'S/1,800.00',
			subtext: 'Licencia + Implementación',
			showAlert: false,
			urlImage: '/static/images/sections/plan-5.png'
		}, {
			id: 6,
			title: 'Plan MultiComercio Full',
			text: 'S/2,500.00',
			subtext: 'Licencia + Implementación',
			showAlert: true,
			urlImage: '/static/images/sections/plan-6.png'
		}],
		itemsEcu: [{
			id: 1,
			title: 'Plan Promocional',
			text: '$150',
			subtext: 'Licencia + Implementación',
			textInformation: 'Mensualidades de $8'
		}],
		dialog: false,
		urlImage: ''
	};
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-our-plans',
	data: data,
	methods: {
		closeModal: closeModal,
		openPlanDesktop: openPlanDesktop,
		openPlanMobile: openPlanMobile
	},
	props: {
		code: String
	}
});

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("0723f9ea", content, true, {});

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".container-iframe{position:relative}.container-iframe .btn__content{background:#fff!important;box-shadow:-2px 4px 9px 0 rgba(0,0,0,.14)}.container-close{position:absolute;right:10px;top:10px}.container-progrees{align-items:center;display:flex;justify-content:center;height:600px}", "", {"version":3,"sources":["/opt/build/repo/src/pages/page-home.vue"],"names":[],"mappings":"AACA,kBACE,iBAAmB,CACpB,AACD,gCACI,0BAA+B,AAC/B,yCAAiD,CACpD,AACD,iBACE,kBAAmB,AACnB,WAAY,AACZ,QAAU,CACX,AACD,oBACE,mBAAoB,AACpB,aAAc,AACd,uBAAwB,AACxB,YAAc,CACf","file":"page-home.vue","sourcesContent":["\n.container-iframe {\n  position: relative;\n}\n.container-iframe .btn__content {\n    background: #ffffff !important;\n    box-shadow: -2px 4px 9px 0px rgba(0, 0, 0, 0.14);\n}\n.container-close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.container-progrees {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 600px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_250f037b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__ = __webpack_require__(406);
function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-250f037b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_250f037b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(405);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("620c876a", content, true, {});

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".app-footer[data-v-250f037b]{background:#494949;color:#fff;line-height:24px;padding:70px 5%}@media (max-width:900px){.app-footer[data-v-250f037b]{padding:30px 3%}}.app-footer img[data-v-250f037b]{max-width:100%}.text-right[data-v-250f037b]{text-align:right}.title-footer[data-v-250f037b]{font-size:24px;line-height:30px;text-transform:uppercase}@media (max-width:900px){.title-footer[data-v-250f037b]{text-align:center}}.pa-16-desktop[data-v-250f037b]{padding:0 16px}.wrapper-text[data-v-250f037b]{font-size:16px}.btn-link[data-v-250f037b]{background-color:#02979b;border-radius:8px;color:#fff;display:inline-block;padding:15px 60px;text-align:center;text-decoration:none;text-transform:uppercase;width:100%}.btn-mobile[data-v-250f037b]{display:none}@media (max-width:900px){.btn-mobile[data-v-250f037b]{display:block}}@media (max-width:900px){.btn-desktop[data-v-250f037b]{display:none}}@media (max-width:900px){.wrapper-logos[data-v-250f037b]{margin-bottom:45px}}.pa-20-desktop[data-v-250f037b]{padding-right:20%}@media (max-width:900px){.pa-20-desktop[data-v-250f037b]{padding-right:0}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/app-footer.vue"],"names":[],"mappings":"AACA,6BACE,mBAAoB,AACpB,WAAe,AACf,iBAAkB,AAClB,eAAiB,CAClB,AACD,yBACA,6BACM,eAAiB,CACtB,CACA,AACD,iCACI,cAAgB,CACnB,AACD,6BACE,gBAAkB,CACnB,AACD,+BACE,eAAgB,AAChB,iBAAkB,AAClB,wBAA0B,CAC3B,AACD,yBACA,+BACM,iBAAmB,CACxB,CACA,AACD,gCACE,cAAgB,CACjB,AACD,+BACE,cAAgB,CACjB,AACD,2BACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,qBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,qBAAsB,AACtB,yBAA0B,AAC1B,UAAY,CACb,AACD,6BACE,YAAc,CACf,AACD,yBACA,6BACM,aAAe,CACpB,CACA,AACD,yBACA,8BACI,YAAc,CACjB,CACA,AACD,yBACA,gCACI,kBAAoB,CACvB,CACA,AACD,gCACE,iBAAmB,CACpB,AACD,yBACA,gCACM,eAAiB,CACtB,CACA","file":"app-footer.vue","sourcesContent":["\n.app-footer[data-v-250f037b] {\n  background: #494949;\n  color: #ffffff;\n  line-height: 24px;\n  padding: 70px 5%;\n}\n@media (max-width: 900px) {\n.app-footer[data-v-250f037b] {\n      padding: 30px 3%;\n}\n}\n.app-footer img[data-v-250f037b] {\n    max-width: 100%;\n}\n.text-right[data-v-250f037b] {\n  text-align: right;\n}\n.title-footer[data-v-250f037b] {\n  font-size: 24px;\n  line-height: 30px;\n  text-transform: uppercase;\n}\n@media (max-width: 900px) {\n.title-footer[data-v-250f037b] {\n      text-align: center;\n}\n}\n.pa-16-desktop[data-v-250f037b] {\n  padding: 0 16px;\n}\n.wrapper-text[data-v-250f037b] {\n  font-size: 16px;\n}\n.btn-link[data-v-250f037b] {\n  background-color: #02979b;\n  border-radius: 8px;\n  color: #ffffff;\n  display: inline-block;\n  padding: 15px 60px;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  width: 100%;\n}\n.btn-mobile[data-v-250f037b] {\n  display: none;\n}\n@media (max-width: 900px) {\n.btn-mobile[data-v-250f037b] {\n      display: block;\n}\n}\n@media (max-width: 900px) {\n.btn-desktop[data-v-250f037b] {\n    display: none;\n}\n}\n@media (max-width: 900px) {\n.wrapper-logos[data-v-250f037b] {\n    margin-bottom: 45px;\n}\n}\n.pa-20-desktop[data-v-250f037b] {\n  padding-right: 20%;\n}\n@media (max-width: 900px) {\n.pa-20-desktop[data-v-250f037b] {\n      padding-right: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_c('v-layout',{staticClass:"container",attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"wrapper-logos",attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('h2',{staticClass:"w-black title-footer pa-16-desktop"},[_vm._v("CASA MARKET llega gracias a Apprunn")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"w-black pa-16-desktop"},[_vm._v("Nuestros productos y  principales clientes/partnes:")])]),_vm._v(" "),_c('v-layout',{staticClass:"pa-20-desktop",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('a',{attrs:{"href":"https://feedbackinn.com/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images/logos/logo-feedbackinn.png","alt":"feedbackinn","height":"28"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('a',{attrs:{"href":"https://makipos.la/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images/logos/logo-maki.png","alt":"makipos","height":"28"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"text-right",attrs:{"xs4":"","pa-2":""}},[_c('a',{attrs:{"href":"https://fenixcorp.net/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images/logos/logo-fenix.png","alt":"fenix","height":"28"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"text-right",attrs:{"xs4":"","pa-2":""}},[_c('a',{attrs:{"href":"https://japisale.com/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images/logos/logo-japisale.png","alt":"japisale","height":"28"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"text-right",attrs:{"xs4":"","pa-2":""}},[_c('img',{attrs:{"src":"/static/images/logos/logo-praktiko.png","alt":"praktiko","height":"28"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"wrapper-text",attrs:{"xs12":"","md4":""}},[_c('p',[_vm._v("Apprun es un Product Studio que tiene como misión \n\t\t\t\tcrear productos que ayuden a mejorar la vida de la gente .\n\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"btn-desktop",attrs:{"xs12":"","mt-5":"","pl-2":""}},[_c('a',{staticClass:"btn-link",attrs:{"href":"https://apprunn.com/","target":"_blank"}},[_vm._v("Visita Apprunn.com")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"btn-mobile",attrs:{"xs12":"","mt-3":"","text-xs-center":""}},[_c('a',{staticClass:"btn-link",attrs:{"href":"https://apprunn.com/","target":"_blank"}},[_vm._v("Visita Apprunn.com")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e8dd95d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(410);
function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e8dd95d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e8dd95d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(409);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("ccdc22b8", content, true, {});

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".app-header[data-v-4e8dd95d]{left:0;padding:69px 0 10px;position:relative;right:0;transition:all .5s ease;top:0;width:100%;z-index:200}@media (min-width:1024px){.app-header[data-v-4e8dd95d]{padding:44px 4%;position:fixed}}@media (min-width:1090px){.app-header[data-v-4e8dd95d]{padding:44px 4%}}@media (min-width:1024px){.app-header-btn[data-v-4e8dd95d]{border-radius:8px;font-size:12px;font-weight:900;height:42px!important;text-transform:uppercase!important;width:100%!important}}@media (min-width:1090px){.app-header-btn[data-v-4e8dd95d]{font-size:13px}}@media (min-width:1190px){.app-header-btn[data-v-4e8dd95d]{font-size:14px}}@media (min-width:1024px){.app-header.scrolling[data-v-4e8dd95d]{background:#fff;box-shadow:-1px 1px 4px 4px #f9f9f9;-webkit-box-shadow:-1px 1px 4px 4px #f9f9f9;-moz-box-shadow:-1px 1px 4px 4px #f9f9f9;padding:30px 4%}}.app-header .text-decoration-none[data-v-4e8dd95d]{text-decoration:none}.app-header .image-logo-header[data-v-4e8dd95d]{height:33px}@media (min-width:1024px){.app-header .image-logo-header[data-v-4e8dd95d]{height:30px}}@media (min-width:1090px){.app-header .image-logo-header[data-v-4e8dd95d]{height:31.5px}}@media (min-width:1190px){.app-header .image-logo-header[data-v-4e8dd95d]{height:33px}}@media (min-width:1024px){.app-header-menu[data-v-4e8dd95d]{font-size:12px;font-weight:700;list-style:none;text-transform:uppercase}}@media (min-width:1090px){.app-header-menu[data-v-4e8dd95d]{font-size:13px}}@media (min-width:1190px){.app-header-menu[data-v-4e8dd95d]{font-size:14px}}.app-header-menu-item[data-v-4e8dd95d]:not(.app-header-menu-item-logo){background:#02979b;transition:all .5s ease;position:fixed;height:100vh;left:-100%;top:0;width:90%!important}@media (min-width:1024px){.app-header-menu-item[data-v-4e8dd95d]:not(.app-header-menu-item-logo){background:none;display:initial;position:relative;height:auto;left:auto;width:56%!important}}.app-header-menu-item:not(.app-header-menu-item-logo).open-menu[data-v-4e8dd95d]{left:0}@media (min-width:1024px){.app-header-menu-item[data-v-4e8dd95d]{padding:0 .5vw}}.app-header-menu-item-link[data-v-4e8dd95d]{color:#494949}@media (min-width:1024px){.app-header-menu-item-link[data-v-4e8dd95d]{text-decoration:none}}@media (max-width:1024px){.app-header-menu-item-link[data-v-4e8dd95d]{color:#fff;font-weight:600;text-align:left;text-decoration:none;padding:18px 0 18px 60px;width:100%}.app-header-menu-item-link[data-v-4e8dd95d]:nth-child(odd){background:#019195}}@media (max-width:1024px){.app-header-menu-item-logo[data-v-4e8dd95d]{text-align:center}}.app-header .link-text-container[data-v-4e8dd95d]{text-align:right;width:56%}.app-header .is-active[data-v-4e8dd95d]{color:#02979b;position:relative}.app-header .is-active[data-v-4e8dd95d]:before{border-bottom:3px solid #ff6e1c;bottom:-3px;content:\"\";left:0;margin-left:auto;position:absolute;top:0;right:0;width:80%;z-index:0}@media (max-width:1024px){.app-header .is-active[data-v-4e8dd95d]{color:#fff}.app-header .is-active[data-v-4e8dd95d]:before{width:100%}}.app-header .show-image[data-v-4e8dd95d]{display:inline-block}.app-header .show-not-image[data-v-4e8dd95d]{display:none}.app-header .text-logo[data-v-4e8dd95d]{font-size:12px;color:#02979b;text-transform:none}.app-header .logo-menu-mobile[data-v-4e8dd95d]{display:none;text-align:left;padding:0 0 17px 60px}@media (max-width:1024px){.app-header .logo-menu-mobile[data-v-4e8dd95d]{display:inline-block;width:100%}}.app-header .logo-close[data-v-4e8dd95d]{display:none;padding:24px 0 0 21px;text-align:left}@media (max-width:1024px){.app-header .logo-close[data-v-4e8dd95d]{display:inline-block;width:100%}}.app-header .li-logo[data-v-4e8dd95d]{background:none!important;padding:0}.app-header .app-header-mobile[data-v-4e8dd95d]{background:#fff;box-shadow:0 2px 7px 0 rgba(0,0,0,.22);padding:16px;position:fixed!important;top:0;width:100%}@media (min-width:1024px){.app-header .app-header-mobile[data-v-4e8dd95d]{display:none}}.app-header .btn-orange[data-v-4e8dd95d]{background:#ff6e1c;border-radius:8px;color:#fff;padding:6px 10px;text-decoration:none}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/app-header.vue"],"names":[],"mappings":"AACA,6BACE,OAAU,AACV,oBAAyB,AACzB,kBAAmB,AACnB,QAAW,AACX,wBAA0B,AAC1B,MAAS,AACT,WAAY,AACZ,WAAa,CACd,AACD,0BACA,6BACM,gBAAsB,AACtB,cAAgB,CACrB,CACA,AACD,0BACA,6BACM,eAAsB,CAC3B,CACA,AACD,0BACA,iCACM,kBAAmB,AACnB,eAAgB,AAChB,gBAAiB,AACjB,sBAAwB,AACxB,mCAAqC,AACrC,oBAAuB,CAC5B,CACA,AACD,0BACA,iCACM,cAAgB,CACrB,CACA,AACD,0BACA,iCACM,cAAgB,CACrB,CACA,AACD,0BACA,uCACM,gBAAoB,AACpB,oCAAqC,AACrC,4CAA6C,AAC7C,yCAA0C,AAC1C,eAAiB,CACtB,CACA,AACD,mDACI,oBAAsB,CACzB,AACD,gDACI,WAAa,CAChB,AACD,0BACA,gDACQ,WAAa,CACpB,CACA,AACD,0BACA,gDACQ,aAAe,CACtB,CACA,AACD,0BACA,gDACQ,WAAa,CACpB,CACA,AACD,0BACA,kCACM,eAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,wBAA0B,CAC/B,CACA,AACD,0BACA,kCACM,cAAgB,CACrB,CACA,AACD,0BACA,kCACM,cAAgB,CACrB,CACA,AACD,uEACI,mBAAoB,AACpB,wBAA0B,AAC1B,eAAgB,AAChB,aAAc,AACd,WAAY,AACZ,MAAO,AACP,mBAAsB,CACzB,AACD,0BACA,uEACQ,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,YAAa,AACb,UAAW,AACX,mBAAsB,CAC7B,CACA,AACD,iFACM,MAAQ,CACb,AACD,0BACA,uCACM,cAAmB,CACxB,CACA,AACD,4CACI,aAAe,CAClB,AACD,0BACA,4CACQ,oBAAsB,CAC7B,CACA,AACD,0BACA,4CACQ,WAAa,AACb,gBAAiB,AACjB,gBAAiB,AACjB,qBAAsB,AACtB,yBAA0B,AAC1B,UAAY,CACnB,AACD,2DACU,kBAAoB,CAC7B,CACA,AACD,0BACA,4CACM,iBAAmB,CACxB,CACA,AACD,kDACI,iBAAkB,AAClB,SAAW,CACd,AACD,wCACI,cAAe,AACf,iBAAmB,CACtB,AACD,+CACM,gCAAiC,AACjC,YAAa,AACb,WAAY,AACZ,OAAQ,AACR,iBAAkB,AAClB,kBAAmB,AACnB,MAAO,AACP,QAAS,AACT,UAAW,AACX,SAAW,CAChB,AACD,0BACA,wCACQ,UAAe,CACtB,AACD,+CACU,UAAY,CACrB,CACA,AACD,yCACI,oBAAsB,CACzB,AACD,6CACI,YAAc,CACjB,AACD,wCACI,eAAgB,AAChB,cAAe,AACf,mBAAqB,CACxB,AACD,+CACI,aAAc,AACd,gBAAiB,AACjB,qBAAuB,CAC1B,AACD,0BACA,+CACQ,qBAAsB,AACtB,UAAY,CACnB,CACA,AACD,yCACI,aAAc,AACd,sBAAuB,AACvB,eAAiB,CACpB,AACD,0BACA,yCACQ,qBAAsB,AACtB,UAAY,CACnB,CACA,AACD,sCACI,0BAA4B,AAC5B,SAAW,CACd,AACD,gDACI,gBAAoB,AACpB,uCAA4C,AAC5C,aAAc,AACd,yBAA2B,AAC3B,MAAO,AACP,UAAY,CACf,AACD,0BACA,gDACQ,YAAc,CACrB,CACA,AACD,yCACI,mBAAoB,AACpB,kBAAmB,AACnB,WAAe,AACf,iBAAkB,AAClB,oBAAsB,CACzB","file":"app-header.vue","sourcesContent":["\n.app-header[data-v-4e8dd95d] {\n  left: 0px;\n  padding: 69px 0px 10px 0;\n  position: relative;\n  right: 0px;\n  transition: all 0.5s ease;\n  top: 0px;\n  width: 100%;\n  z-index: 200;\n}\n@media (min-width: 1024px) {\n.app-header[data-v-4e8dd95d] {\n      padding: 44px 4% 44px;\n      position: fixed;\n}\n}\n@media (min-width: 1090px) {\n.app-header[data-v-4e8dd95d] {\n      padding: 44px 4% 44px;\n}\n}\n@media (min-width: 1024px) {\n.app-header-btn[data-v-4e8dd95d] {\n      border-radius: 8px;\n      font-size: 12px;\n      font-weight: 900;\n      height: 42px !important;\n      text-transform: uppercase !important;\n      width: 100% !important;\n}\n}\n@media (min-width: 1090px) {\n.app-header-btn[data-v-4e8dd95d] {\n      font-size: 13px;\n}\n}\n@media (min-width: 1190px) {\n.app-header-btn[data-v-4e8dd95d] {\n      font-size: 14px;\n}\n}\n@media (min-width: 1024px) {\n.app-header.scrolling[data-v-4e8dd95d] {\n      background: #ffffff;\n      box-shadow: -1px 1px 4px 4px #f9f9f9;\n      -webkit-box-shadow: -1px 1px 4px 4px #f9f9f9;\n      -moz-box-shadow: -1px 1px 4px 4px #f9f9f9;\n      padding: 30px 4%;\n}\n}\n.app-header .text-decoration-none[data-v-4e8dd95d] {\n    text-decoration: none;\n}\n.app-header .image-logo-header[data-v-4e8dd95d] {\n    height: 33px;\n}\n@media (min-width: 1024px) {\n.app-header .image-logo-header[data-v-4e8dd95d] {\n        height: 30px;\n}\n}\n@media (min-width: 1090px) {\n.app-header .image-logo-header[data-v-4e8dd95d] {\n        height: 31.5px;\n}\n}\n@media (min-width: 1190px) {\n.app-header .image-logo-header[data-v-4e8dd95d] {\n        height: 33px;\n}\n}\n@media (min-width: 1024px) {\n.app-header-menu[data-v-4e8dd95d] {\n      font-size: 12px;\n      font-weight: 700;\n      list-style: none;\n      text-transform: uppercase;\n}\n}\n@media (min-width: 1090px) {\n.app-header-menu[data-v-4e8dd95d] {\n      font-size: 13px;\n}\n}\n@media (min-width: 1190px) {\n.app-header-menu[data-v-4e8dd95d] {\n      font-size: 14px;\n}\n}\n.app-header-menu-item[data-v-4e8dd95d]:not(.app-header-menu-item-logo) {\n    background: #02979b;\n    transition: all 0.5s ease;\n    position: fixed;\n    height: 100vh;\n    left: -100%;\n    top: 0;\n    width: 90% !important;\n}\n@media (min-width: 1024px) {\n.app-header-menu-item[data-v-4e8dd95d]:not(.app-header-menu-item-logo) {\n        background: none;\n        display: initial;\n        position: relative;\n        height: auto;\n        left: auto;\n        width: 56% !important;\n}\n}\n.app-header-menu-item:not(.app-header-menu-item-logo).open-menu[data-v-4e8dd95d] {\n      left: 0;\n}\n@media (min-width: 1024px) {\n.app-header-menu-item[data-v-4e8dd95d] {\n      padding: 0px 0.5vw;\n}\n}\n.app-header-menu-item-link[data-v-4e8dd95d] {\n    color: #494949;\n}\n@media (min-width: 1024px) {\n.app-header-menu-item-link[data-v-4e8dd95d] {\n        text-decoration: none;\n}\n}\n@media (max-width: 1024px) {\n.app-header-menu-item-link[data-v-4e8dd95d] {\n        color: white;\n        font-weight: 600;\n        text-align: left;\n        text-decoration: none;\n        padding: 18px 0 18px 60px;\n        width: 100%;\n}\n.app-header-menu-item-link[data-v-4e8dd95d]:nth-child(odd) {\n          background: #019195;\n}\n}\n@media (max-width: 1024px) {\n.app-header-menu-item-logo[data-v-4e8dd95d] {\n      text-align: center;\n}\n}\n.app-header .link-text-container[data-v-4e8dd95d] {\n    text-align: right;\n    width: 56%;\n}\n.app-header .is-active[data-v-4e8dd95d] {\n    color: #02979b;\n    position: relative;\n}\n.app-header .is-active[data-v-4e8dd95d]::before {\n      border-bottom: 3px solid #ff6e1c;\n      bottom: -3px;\n      content: '';\n      left: 0;\n      margin-left: auto;\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 80%;\n      z-index: 0;\n}\n@media (max-width: 1024px) {\n.app-header .is-active[data-v-4e8dd95d] {\n        color: #ffffff;\n}\n.app-header .is-active[data-v-4e8dd95d]::before {\n          width: 100%;\n}\n}\n.app-header .show-image[data-v-4e8dd95d] {\n    display: inline-block;\n}\n.app-header .show-not-image[data-v-4e8dd95d] {\n    display: none;\n}\n.app-header .text-logo[data-v-4e8dd95d] {\n    font-size: 12px;\n    color: #02979b;\n    text-transform: none;\n}\n.app-header .logo-menu-mobile[data-v-4e8dd95d] {\n    display: none;\n    text-align: left;\n    padding: 0 0 17px 60px;\n}\n@media (max-width: 1024px) {\n.app-header .logo-menu-mobile[data-v-4e8dd95d] {\n        display: inline-block;\n        width: 100%;\n}\n}\n.app-header .logo-close[data-v-4e8dd95d] {\n    display: none;\n    padding: 24px 0 0 21px;\n    text-align: left;\n}\n@media (max-width: 1024px) {\n.app-header .logo-close[data-v-4e8dd95d] {\n        display: inline-block;\n        width: 100%;\n}\n}\n.app-header .li-logo[data-v-4e8dd95d] {\n    background: none !important;\n    padding: 0;\n}\n.app-header .app-header-mobile[data-v-4e8dd95d] {\n    background: #ffffff;\n    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.22);\n    padding: 16px;\n    position: fixed !important;\n    top: 0;\n    width: 100%;\n}\n@media (min-width: 1024px) {\n.app-header .app-header-mobile[data-v-4e8dd95d] {\n        display: none;\n}\n}\n.app-header .btn-orange[data-v-4e8dd95d] {\n    background: #ff6e1c;\n    border-radius: 8px;\n    color: #ffffff;\n    padding: 6px 10px;\n    text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header",class:{scrolling: _vm.scrolled}},[_c('v-layout',{staticClass:"app-header-mobile",attrs:{"justify-space-between":""}},[_c('div',[_c('button',{staticClass:"mr-3",on:{"click":_vm.openMenuMobile}},[_c('img',{attrs:{"src":"static/images/icons/menu.svg","alt":"menu","height":"20"}})])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"btn-orange",attrs:{"href":"#plans"}},[_vm._v("NUESTROS PLANES")])])]),_vm._v(" "),_c('ul',{staticClass:"layout app-header-menu align-center",class:{ 'open-menu' : true}},[_c('li',{staticClass:"flex app-header-menu-item app-header-menu-item-logo"},[_c('router-link',{staticClass:"app-header-menu-item-link li-logo",attrs:{"to":"/"}},[_c('img',{staticClass:"image-logo-header",class:{ 'show-image': !_vm.scrolled, 'show-not-image': _vm.scrolled },attrs:{"src":"/static/images/logos/logo-casa-market-orange.svg","alt":"logo mi bodega","height":"50px"}}),_vm._v(" "),_c('img',{staticClass:"image-logo-header",class:{ 'show-not-image' :_vm.scrolled, 'show-not-image': !_vm.scrolled },attrs:{"src":"/static/images/icons/favicon-casamarket.svg","alt":"logo mi bodega","height":"50px"}})]),_vm._v(" "),(!_vm.scrolled)?_c('div',[_vm._m(0)]):_vm._e()],1),_vm._v(" "),_c('ul',{staticClass:"link-text-container app-header-menu-item",class:{ 'open-menu' : _vm.openMobile }},[_c('li',{staticClass:"logo-close"},[_c('button',{on:{"click":_vm.closeMenuMobile}},[_c('img',{attrs:{"src":"/static/images/logos/close.svg","alt":"cerrar"}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('scrollactive',{staticClass:"layout wrap justify-space-between",attrs:{"offset":50}},_vm._l((_vm.menu),function(item){return _c('a',{key:item.id,staticClass:"app-header-menu-item-link scrollactive-item",attrs:{"href":item.href},on:{"click":_vm.closeMenuMobile}},[_vm._v("\n\t\t\t\t\t"+_vm._s(item.title)+"\n\t\t\t\t")])}))],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-0 text-logo"},[_vm._v("Tu app de pedidos para acercar de "),_c('br'),_vm._v(" manera segura a comercios y clientes")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"logo-menu-mobile"},[_c('img',{attrs:{"src":"/static/images/logos/casa-market-white.svg","alt":"logo"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528323ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_vue__ = __webpack_require__(418);
function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-528323ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528323ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(413);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("ee330386", content, true, {});

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".banner[data-v-528323ab]{background-image:url(\"/static/images/banners/banner-casa-market-mobile.png\");background-position:top;background-repeat:no-repeat;background-size:cover;color:#494949;justify-content:center;height:560px;padding:80px 17px 0;position:relative}@media (min-width:1024px){.banner[data-v-528323ab]{align-items:center;background-image:url(\"/static/images/banners/banner-casa-market.png\");height:56vw;justify-content:flex-end}}.banner-link[data-v-528323ab]{text-decoration:none}.banner-btn[data-v-528323ab]{border-radius:8px;font-size:20px;font-weight:900;height:60px!important;width:212px!important}@media (min-width:1024px){.banner-btn[data-v-528323ab]{width:271px!important}}.banner-image[data-v-528323ab]{max-width:100%;height:439px}@media (min-width:360px){.banner-image[data-v-528323ab]{height:450px}}.align-text[data-v-528323ab]{text-align:center}@media (min-width:1024px){.align-text[data-v-528323ab]{padding-right:7.5%;text-align:right}}.title-text[data-v-528323ab]{font-size:25px;font-weight:900;line-height:normal}@media (min-width:1024px){.title-text[data-v-528323ab]{font-size:30px}}@media (min-width:1280px){.title-text[data-v-528323ab]{font-size:40px}}.major-text[data-v-528323ab]{font-size:30px;font-weight:900;line-height:normal;text-transform:uppercase}@media (min-width:1280px){.major-text[data-v-528323ab]{font-size:40px}}.regular-text[data-v-528323ab]{color:#494949;font-size:20px;line-height:normal;margin:40px auto 30px;max-width:400px}@media (min-width:1024px){.regular-text[data-v-528323ab]{color:#02979b;background:rgba(141,205,208,.45);border-radius:8px;font-size:20px;padding:15px 0;text-align:center;margin:40px 0 30px auto;max-width:none;width:93%}}@media (min-width:1280px){.regular-text[data-v-528323ab]{font-size:20px}}.banner-image-container[data-v-528323ab]{bottom:165px;left:-9px;position:absolute;width:90%}@media (max-width:1024px){.banner-image-container[data-v-528323ab]{bottom:105px;left:0}}@media (max-width:450px){.banner-image-container[data-v-528323ab]{bottom:93px;text-align:center}}@media (max-width:1024px){.content-actions[data-v-528323ab]{bottom:37px;left:5px;position:absolute}}.text-orange[data-v-528323ab]{color:#ff6e1c}.banner-image-phone[data-v-528323ab]{bottom:3px;max-height:40vw;position:absolute}.container-desktop[data-v-528323ab]{display:none}@media (min-width:1024px){.container-desktop[data-v-528323ab]{display:block}}.text-number[data-v-528323ab]{color:#02979b;font-size:24px;font-weight:900}.container-btn-link[data-v-528323ab]{margin-left:auto;margin-top:30px;text-align:center;width:50%}.btn-link-d[data-v-528323ab]{color:#fff;background:#ff6e1c;border-radius:8px;display:inline-block;font-size:20px;text-decoration:none;padding:18px 50px}.btn-link-detail[data-v-528323ab]{color:#494949;border:1px solid #494949;border-radius:8px;text-decoration:none;padding:8px}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/banner.vue"],"names":[],"mappings":"AACA,yBACE,6EAA8E,AAC9E,wBAAgC,AAChC,4BAA6B,AAC7B,sBAAuB,AACvB,cAAe,AACf,uBAAwB,AACxB,aAAc,AACd,oBAAuB,AACvB,iBAAmB,CACpB,AACD,0BACA,yBACM,mBAAoB,AACpB,sEAAuE,AACvE,YAAa,AACb,wBAA0B,CAC/B,CACA,AACD,8BACI,oBAAsB,CACzB,AACD,6BACI,kBAAmB,AACnB,eAAgB,AAChB,gBAAiB,AACjB,sBAAwB,AACxB,qBAAwB,CAC3B,AACD,0BACA,6BACQ,qBAAwB,CAC/B,CACA,AACD,+BACI,eAAgB,AAChB,YAAc,CACjB,AACD,yBACA,+BACQ,YAAc,CACrB,CACA,AACD,6BACE,iBAAmB,CACpB,AACD,0BACA,6BACM,mBAAoB,AACpB,gBAAkB,CACvB,CACA,AACD,6BACE,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,0BACA,6BACM,cAAgB,CACrB,CACA,AACD,0BACA,6BACM,cAAgB,CACrB,CACA,AACD,6BACE,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,wBAA0B,CAC3B,AACD,0BACA,6BACM,cAAgB,CACrB,CACA,AACD,+BACE,cAAe,AACf,eAAgB,AAChB,mBAAoB,AACpB,sBAAuB,AACvB,eAAiB,CAClB,AACD,0BACA,+BACM,cAAe,AACf,iCAAsC,AACtC,kBAAmB,AACnB,eAAgB,AAChB,eAAgB,AAChB,kBAAmB,AACnB,wBAA2B,AAC3B,eAAgB,AAChB,SAAW,CAChB,CACA,AACD,0BACA,+BACM,cAAgB,CACrB,CACA,AACD,yCACE,aAAc,AACd,UAAW,AACX,kBAAmB,AACnB,SAAW,CACZ,AACD,0BACA,yCACM,aAAc,AACd,MAAQ,CACb,CACA,AACD,yBACA,yCACM,YAAa,AACb,iBAAmB,CACxB,CACA,AACD,0BACA,kCACI,YAAa,AACb,SAAU,AACV,iBAAmB,CACtB,CACA,AACD,8BACE,aAAe,CAChB,AACD,qCACE,WAAY,AACZ,gBAAiB,AACjB,iBAAmB,CACpB,AACD,oCACE,YAAc,CACf,AACD,0BACA,oCACM,aAAe,CACpB,CACA,AACD,8BACE,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,qCACE,iBAAkB,AAClB,gBAAiB,AACjB,kBAAmB,AACnB,SAAW,CACZ,AACD,6BACE,WAAa,AACb,mBAAoB,AACpB,kBAAmB,AACnB,qBAAsB,AACtB,eAAgB,AAChB,qBAAsB,AACtB,iBAAmB,CACpB,AACD,kCACE,cAAe,AACf,yBAA0B,AAC1B,kBAAmB,AACnB,qBAAsB,AACtB,WAAa,CACd","file":"banner.vue","sourcesContent":["\n.banner[data-v-528323ab] {\n  background-image: url(\"/static/images/banners/banner-casa-market-mobile.png\");\n  background-position: center top;\n  background-repeat: no-repeat;\n  background-size: cover;\n  color: #494949;\n  justify-content: center;\n  height: 560px;\n  padding: 80px 17px 0px;\n  position: relative;\n}\n@media (min-width: 1024px) {\n.banner[data-v-528323ab] {\n      align-items: center;\n      background-image: url(\"/static/images/banners/banner-casa-market.png\");\n      height: 56vw;\n      justify-content: flex-end;\n}\n}\n.banner-link[data-v-528323ab] {\n    text-decoration: none;\n}\n.banner-btn[data-v-528323ab] {\n    border-radius: 8px;\n    font-size: 20px;\n    font-weight: 900;\n    height: 60px !important;\n    width: 212px !important;\n}\n@media (min-width: 1024px) {\n.banner-btn[data-v-528323ab] {\n        width: 271px !important;\n}\n}\n.banner-image[data-v-528323ab] {\n    max-width: 100%;\n    height: 439px;\n}\n@media (min-width: 360px) {\n.banner-image[data-v-528323ab] {\n        height: 450px;\n}\n}\n.align-text[data-v-528323ab] {\n  text-align: center;\n}\n@media (min-width: 1024px) {\n.align-text[data-v-528323ab] {\n      padding-right: 7.5%;\n      text-align: right;\n}\n}\n.title-text[data-v-528323ab] {\n  font-size: 25px;\n  font-weight: 900;\n  line-height: normal;\n}\n@media (min-width: 1024px) {\n.title-text[data-v-528323ab] {\n      font-size: 30px;\n}\n}\n@media (min-width: 1280px) {\n.title-text[data-v-528323ab] {\n      font-size: 40px;\n}\n}\n.major-text[data-v-528323ab] {\n  font-size: 30px;\n  font-weight: 900;\n  line-height: normal;\n  text-transform: uppercase;\n}\n@media (min-width: 1280px) {\n.major-text[data-v-528323ab] {\n      font-size: 40px;\n}\n}\n.regular-text[data-v-528323ab] {\n  color: #494949;\n  font-size: 20px;\n  line-height: normal;\n  margin: 40px auto 30px;\n  max-width: 400px;\n}\n@media (min-width: 1024px) {\n.regular-text[data-v-528323ab] {\n      color: #02979b;\n      background: rgba(141, 205, 208, 0.45);\n      border-radius: 8px;\n      font-size: 20px;\n      padding: 15px 0;\n      text-align: center;\n      margin: 40px 0px 30px auto;\n      max-width: none;\n      width: 93%;\n}\n}\n@media (min-width: 1280px) {\n.regular-text[data-v-528323ab] {\n      font-size: 20px;\n}\n}\n.banner-image-container[data-v-528323ab] {\n  bottom: 165px;\n  left: -9px;\n  position: absolute;\n  width: 90%;\n}\n@media (max-width: 1024px) {\n.banner-image-container[data-v-528323ab] {\n      bottom: 105px;\n      left: 0;\n}\n}\n@media (max-width: 450px) {\n.banner-image-container[data-v-528323ab] {\n      bottom: 93px;\n      text-align: center;\n}\n}\n@media (max-width: 1024px) {\n.content-actions[data-v-528323ab] {\n    bottom: 37px;\n    left: 5px;\n    position: absolute;\n}\n}\n.text-orange[data-v-528323ab] {\n  color: #ff6e1c;\n}\n.banner-image-phone[data-v-528323ab] {\n  bottom: 3px;\n  max-height: 40vw;\n  position: absolute;\n}\n.container-desktop[data-v-528323ab] {\n  display: none;\n}\n@media (min-width: 1024px) {\n.container-desktop[data-v-528323ab] {\n      display: block;\n}\n}\n.text-number[data-v-528323ab] {\n  color: #02979b;\n  font-size: 24px;\n  font-weight: 900;\n}\n.container-btn-link[data-v-528323ab] {\n  margin-left: auto;\n  margin-top: 30px;\n  text-align: center;\n  width: 50%;\n}\n.btn-link-d[data-v-528323ab] {\n  color: white;\n  background: #ff6e1c;\n  border-radius: 8px;\n  display: inline-block;\n  font-size: 20px;\n  text-decoration: none;\n  padding: 18px 50px;\n}\n.btn-link-detail[data-v-528323ab] {\n  color: #494949;\n  border: 1px solid #494949;\n  border-radius: 8px;\n  text-decoration: none;\n  padding: 8px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btn_action_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6eb53c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btn_action_vue__ = __webpack_require__(417);
function injectStyle (ssrContext) {
  __webpack_require__(415)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c6eb53c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btn_action_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6eb53c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btn_action_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("7ecf28bb", content, true, {});

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".btn-action-image[data-v-7c6eb53c]{background-color:#fff;border:1px solid #02979b;border-radius:15px;color:#02979b;display:inline-block;text-decoration:none;margin-left:30px;max-height:230px;max-width:214px;padding:35px 42px;text-align:center}.btn-action-image p[data-v-7c6eb53c]{font-size:13px}.btn-action-image .text[data-v-7c6eb53c]{font-size:16px;margin:10px auto 0}.btn-action-image .image[data-v-7c6eb53c]{height:61px}@media (max-width:1024px){.btn-action-image .image[data-v-7c6eb53c]{height:50px}}.btn-action-image.btn-green[data-v-7c6eb53c]{background-color:#02979b;color:#fff}@media (max-width:1024px){.btn-action-image[data-v-7c6eb53c]{height:180px!important;margin-left:0;margin-bottom:10px;width:89%;padding:10px}}.btn-action-image .text-desktop[data-v-7c6eb53c]{font-weight:900}@media (max-width:1024px){.btn-action-image .text-desktop[data-v-7c6eb53c]{display:none}}.btn-action-image .text-mobile[data-v-7c6eb53c]{display:none}@media (max-width:1024px){.btn-action-image .text-mobile[data-v-7c6eb53c]{display:block;font-family:Lato;font-weight:900}}@media (max-width:1024px){.content-btn[data-v-7c6eb53c]{align-items:center;flex-direction:column}}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/btn-action.vue"],"names":[],"mappings":"AACA,mCACE,sBAA0B,AAC1B,yBAA0B,AAC1B,mBAAoB,AACpB,cAAe,AACf,qBAAsB,AACtB,qBAAsB,AACtB,iBAAkB,AAClB,iBAAkB,AAClB,gBAAiB,AACjB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,qCACI,cAAgB,CACnB,AACD,yCACI,eAAgB,AAChB,kBAAoB,CACvB,AACD,0CACI,WAAa,CAChB,AACD,0BACA,0CACQ,WAAa,CACpB,CACA,AACD,6CACI,yBAA0B,AAC1B,UAAe,CAClB,AACD,0BACA,mCACM,uBAAyB,AACzB,cAAiB,AACjB,mBAAoB,AACpB,UAAW,AACX,YAAc,CACnB,CACA,AACD,iDACI,eAAiB,CACpB,AACD,0BACA,iDACQ,YAAc,CACrB,CACA,AACD,gDACI,YAAc,CACjB,AACD,0BACA,gDACQ,cAAe,AACf,iBAAoB,AACpB,eAAiB,CACxB,CACA,AACD,0BACA,8BACI,mBAAoB,AACpB,qBAAuB,CAC1B,CACA","file":"btn-action.vue","sourcesContent":["\n.btn-action-image[data-v-7c6eb53c] {\n  background-color: #ffffff;\n  border: solid 1px #02979b;\n  border-radius: 15px;\n  color: #02979b;\n  display: inline-block;\n  text-decoration: none;\n  margin-left: 30px;\n  max-height: 230px;\n  max-width: 214px;\n  padding: 35px 42px;\n  text-align: center;\n}\n.btn-action-image p[data-v-7c6eb53c] {\n    font-size: 13px;\n}\n.btn-action-image .text[data-v-7c6eb53c] {\n    font-size: 16px;\n    margin: 10px auto 0;\n}\n.btn-action-image .image[data-v-7c6eb53c] {\n    height: 61px;\n}\n@media (max-width: 1024px) {\n.btn-action-image .image[data-v-7c6eb53c] {\n        height: 50px;\n}\n}\n.btn-action-image.btn-green[data-v-7c6eb53c] {\n    background-color: #02979b;\n    color: #ffffff;\n}\n@media (max-width: 1024px) {\n.btn-action-image[data-v-7c6eb53c] {\n      height: 180px !important;\n      margin-left: 0px;\n      margin-bottom: 10px;\n      width: 89%;\n      padding: 10px;\n}\n}\n.btn-action-image .text-desktop[data-v-7c6eb53c] {\n    font-weight: 900;\n}\n@media (max-width: 1024px) {\n.btn-action-image .text-desktop[data-v-7c6eb53c] {\n        display: none;\n}\n}\n.btn-action-image .text-mobile[data-v-7c6eb53c] {\n    display: none;\n}\n@media (max-width: 1024px) {\n.btn-action-image .text-mobile[data-v-7c6eb53c] {\n        display: block;\n        font-family: \"Lato\";\n        font-weight: 900;\n}\n}\n@media (max-width: 1024px) {\n.content-btn[data-v-7c6eb53c] {\n    align-items: center;\n    flex-direction: column;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-action-image",class:{'btn-green': _vm.action.green},on:{"click":function($event){_vm.$emit('open-modal')}}},[_c('v-layout',{staticClass:"content-btn",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-desktop",attrs:{"md12":""}},[_c('p',[_vm._v(_vm._s(_vm.action.title))])]),_vm._v(" "),_c('v-flex',{attrs:{"md12":"","xs4":""}},[_c('img',{staticClass:"image",attrs:{"src":_vm.action.image,"alt":_vm.action.title,"height":"61"}})]),_vm._v(" "),_c('v-flex',{staticClass:"text text-mobile",attrs:{"xs12":"","md8":"","sm12":""}},[_vm._v(_vm._s(_vm.action.title))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"banner",attrs:{"wrap":"","id":"home","background":""}},[_c('div',{staticClass:"container"},[_c('v-layout',{attrs:{"wrap":"","justify-end":""}},[_c('v-flex',{staticClass:"container-desktop",attrs:{"xs12":"","md6":""}},[_c('div',[_c('img',{staticClass:"banner-image-phone",attrs:{"src":"/static/images/sections/phone-hand.png","alt":"phone"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"align-text container-desktop",attrs:{"xs12":"","md6":""}},[_c('h3',{staticClass:"title-text"},[_vm._v("TUS CLIENTES "),_c('span',{staticClass:"text-orange"},[_vm._v("CERCA DE TI")])]),_vm._v(" "),_c('h2',{staticClass:"major-text"},[_vm._v("Sin que salgan de casa")]),_vm._v(" "),_c('p',{staticClass:"regular-text"},[_vm._v("Comienza a vender online desde "),_c('span',{staticClass:"text-number"},[_vm._v(_vm._s(_vm.numberMoney))])])]),_vm._v(" "),_c('v-flex',{staticClass:"banner-image-container",attrs:{"xs12":"","hidden-md-and-up":""}},[_c('img',{staticClass:"banner-image",attrs:{"src":"/static/images/sections/phone-hand-mobile.png","alt":"app mi bodega"}})]),_vm._v(" "),_c('v-flex',[_c('div',{staticClass:"layout justify-end content-actions align-text"},_vm._l((_vm.actions),function(action){return _c('div',{key:action.id,staticClass:"actions"},[_c('btn-action',{attrs:{"action":action},on:{"open-modal":function($event){_vm.openModal(action)}}})],1)}))]),_vm._v(" "),(_vm.code === 'PE')?_c('v-flex',{staticClass:"container-desktop",attrs:{"xs12":""}},[_c('div',{staticClass:"container-btn-link"},[_c('a',{staticClass:"btn-link-detail",attrs:{"href":"https://mibodega.s3-sa-east-1.amazonaws.com/planes-casa-market-nuevo.pdf","target":"_blank"}},[_vm._v("Ver Detalle de Planes")])])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"container-desktop",attrs:{"xs12":""}},[_c('div',{staticClass:"container-btn-link"},[_c('button',{staticClass:"btn-link-d",on:{"click":function($event){_vm.$emit('open-modal-btn')}}},[_vm._v("SOLICITA TU APP")])])])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('div',{staticClass:"container-image-plan"},[_c('v-btn',{staticClass:"image-plan-btn",attrs:{"depressed":"","flat":"","icon":""},on:{"click":_vm.closeModal}},[_c('img',{attrs:{"src":"/static/images/sections/close-white.svg","alt":"cerrar","height":"20"}})]),_vm._v(" "),_c('img',{staticClass:"image-plan",attrs:{"src":"/static/images/sections/plan-desktop.png","alt":"planes"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_about_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50648d3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_about_vue__ = __webpack_require__(426);
function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50648d3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50648d3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("19a03e68", content, true, {});

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-about[data-v-50648d3e]{margin-top:-22px;padding:60px 27px 72px}@media (min-width:1024px){.section-about[data-v-50648d3e]{padding:90px 0}}.section-about-image[data-v-50648d3e]{height:auto;max-width:100%}@media (min-width:768px){.section-about-image[data-v-50648d3e]{height:300px}}@media (min-width:1280px){.section-about-image[data-v-50648d3e]{height:310px}}@media (min-width:1340px){.section-about-image[data-v-50648d3e]{height:371px}}.section-about-right[data-v-50648d3e]{margin-top:31px;text-align:center;width:100%}@media (min-width:1280px){.section-about-right[data-v-50648d3e]{margin-top:0;padding-left:1%;text-align:left;max-width:47%}}.section-about-container[data-v-50648d3e]{text-align:center;width:100%}@media (min-width:1280px){.section-about-container[data-v-50648d3e]{max-width:53%;text-align:left}}.section-about-title[data-v-50648d3e]{font-size:38px;font-weight:900;line-height:1}@media (min-width:1024px){.section-about-title[data-v-50648d3e]{font-size:30px}}@media (min-width:1024px){.section-about-title-app[data-v-50648d3e]{font-size:38px}}.section-about-text[data-v-50648d3e]{font-size:16px;line-height:28px;margin-bottom:40px;margin-top:33px}@media (min-width:1024px){.section-about-text[data-v-50648d3e]{line-height:25px;margin:25px auto 40px;max-width:70%}}@media (min-width:1280px){.section-about-text[data-v-50648d3e]{max-width:65%;margin:25px 0 40px}}@media (min-width:1024px){.section-about-card[data-v-50648d3e]{margin:auto;max-width:70%}}@media (min-width:1280px){.section-about-card[data-v-50648d3e]{margin:auto;max-width:100%}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-about.vue"],"names":[],"mappings":"AACA,gCACE,iBAAkB,AAClB,sBAAwB,CACzB,AACD,0BACA,gCACM,cAAkB,CACvB,CACA,AACD,sCACI,YAAa,AACb,cAAgB,CACnB,AACD,yBACA,sCACQ,YAAc,CACrB,CACA,AACD,0BACA,sCACQ,YAAc,CACrB,CACA,AACD,0BACA,sCACQ,YAAc,CACrB,CACA,AACD,sCACI,gBAAiB,AACjB,kBAAmB,AACnB,UAAY,CACf,AACD,0BACA,sCACQ,aAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,aAAe,CACtB,CACA,AACD,0CACI,kBAAmB,AACnB,UAAY,CACf,AACD,0BACA,0CACQ,cAAe,AACf,eAAiB,CACxB,CACA,AACD,sCACI,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CAClB,AACD,0BACA,sCACQ,cAAgB,CACvB,CACA,AACD,0BACA,0CACQ,cAAgB,CACvB,CACA,AACD,qCACI,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,eAAiB,CACpB,AACD,0BACA,qCACQ,iBAAkB,AAClB,sBAAuB,AACvB,aAAe,CACtB,CACA,AACD,0BACA,qCACQ,cAAe,AACf,kBAAsB,CAC7B,CACA,AACD,0BACA,qCACM,YAAa,AACb,aAAe,CACpB,CACA,AACD,0BACA,qCACM,YAAa,AACb,cAAgB,CACrB,CACA","file":"section-about.vue","sourcesContent":["\n.section-about[data-v-50648d3e] {\n  margin-top: -22px;\n  padding: 60px 27px 72px;\n}\n@media (min-width: 1024px) {\n.section-about[data-v-50648d3e] {\n      padding: 90px 0px;\n}\n}\n.section-about-image[data-v-50648d3e] {\n    height: auto;\n    max-width: 100%;\n}\n@media (min-width: 768px) {\n.section-about-image[data-v-50648d3e] {\n        height: 300px;\n}\n}\n@media (min-width: 1280px) {\n.section-about-image[data-v-50648d3e] {\n        height: 310px;\n}\n}\n@media (min-width: 1340px) {\n.section-about-image[data-v-50648d3e] {\n        height: 371px;\n}\n}\n.section-about-right[data-v-50648d3e] {\n    margin-top: 31px;\n    text-align: center;\n    width: 100%;\n}\n@media (min-width: 1280px) {\n.section-about-right[data-v-50648d3e] {\n        margin-top: 0px;\n        padding-left: 1%;\n        text-align: left;\n        max-width: 47%;\n}\n}\n.section-about-container[data-v-50648d3e] {\n    text-align: center;\n    width: 100%;\n}\n@media (min-width: 1280px) {\n.section-about-container[data-v-50648d3e] {\n        max-width: 53%;\n        text-align: left;\n}\n}\n.section-about-title[data-v-50648d3e] {\n    font-size: 38px;\n    font-weight: 900;\n    line-height: 1;\n}\n@media (min-width: 1024px) {\n.section-about-title[data-v-50648d3e] {\n        font-size: 30px;\n}\n}\n@media (min-width: 1024px) {\n.section-about-title-app[data-v-50648d3e] {\n        font-size: 38px;\n}\n}\n.section-about-text[data-v-50648d3e] {\n    font-size: 16px;\n    line-height: 28px;\n    margin-bottom: 40px;\n    margin-top: 33px;\n}\n@media (min-width: 1024px) {\n.section-about-text[data-v-50648d3e] {\n        line-height: 25px;\n        margin: 25px auto 40px;\n        max-width: 70%;\n}\n}\n@media (min-width: 1280px) {\n.section-about-text[data-v-50648d3e] {\n        max-width: 65%;\n        margin: 25px 0px 40px;\n}\n}\n@media (min-width: 1024px) {\n.section-about-card[data-v-50648d3e] {\n      margin: auto;\n      max-width: 70%;\n}\n}\n@media (min-width: 1280px) {\n.section-about-card[data-v-50648d3e] {\n      margin: auto;\n      max-width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_icon_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c9b8b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_icon_vue__ = __webpack_require__(425);
function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47c9b8b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c9b8b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(424);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("20f5a4fa", content, true, {});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".card-icon[data-v-47c9b8b0]{border-radius:9px;box-shadow:0 2px 15px 0 rgba(0,0,0,.06);height:185px;margin:0 auto 26px;padding:25px 23px;width:198px}@media (min-width:1280px){.card-icon[data-v-47c9b8b0]{margin:0 13px 15px 0;width:188px}}@media (min-width:1400px){.card-icon[data-v-47c9b8b0]{margin:0 13px 15px 0;width:198px}}.card-icon-text[data-v-47c9b8b0]{margin:23px 0 0}@media (min-width:1280px){.card-icon-text[data-v-47c9b8b0]{font-size:13px}}@media (min-width:1400px){.card-icon-text[data-v-47c9b8b0]{font-size:14px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/card-icon.vue"],"names":[],"mappings":"AACA,4BACE,kBAAmB,AACnB,wCAA6C,AAC7C,aAAc,AACd,mBAAoB,AACpB,kBAAmB,AACnB,WAAa,CACd,AACD,0BACA,4BACM,qBAA0B,AAC1B,WAAa,CAClB,CACA,AACD,0BACA,4BACM,qBAA0B,AAC1B,WAAa,CAClB,CACA,AACD,iCACI,eAAqB,CACxB,AACD,0BACA,iCACQ,cAAgB,CACvB,CACA,AACD,0BACA,iCACQ,cAAgB,CACvB,CACA","file":"card-icon.vue","sourcesContent":["\n.card-icon[data-v-47c9b8b0] {\n  border-radius: 9px;\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.06);\n  height: 185px;\n  margin: 0 auto 26px;\n  padding: 25px 23px;\n  width: 198px;\n}\n@media (min-width: 1280px) {\n.card-icon[data-v-47c9b8b0] {\n      margin: 0px 13px 15px 0px;\n      width: 188px;\n}\n}\n@media (min-width: 1400px) {\n.card-icon[data-v-47c9b8b0] {\n      margin: 0px 13px 15px 0px;\n      width: 198px;\n}\n}\n.card-icon-text[data-v-47c9b8b0] {\n    margin: 23px 0px 0px;\n}\n@media (min-width: 1280px) {\n.card-icon-text[data-v-47c9b8b0] {\n        font-size: 13px;\n}\n}\n@media (min-width: 1400px) {\n.card-icon-text[data-v-47c9b8b0] {\n        font-size: 14px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-icon white text-xs-center"},[_c('img',{attrs:{"src":_vm.card.icon,"alt":_vm.card.alt,"height":"42"}}),_vm._v(" "),_c('p',{staticClass:"card-icon-text primary--text"},[_vm._v("\n\t\t"+_vm._s(_vm.card.text)+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-about",attrs:{"wrap":"","align-center":"","id":"about","background":""}},[_c('v-flex',{staticClass:"container",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{staticClass:"section-about-container"},[_c('h2',{staticClass:"section-about-title secondary--text"},[_vm._v("SOMOS LA SOLUCIÓN MÓVIL")]),_vm._v(" "),_c('h2',{staticClass:"section-about-title section-about-title-app info-black--text"},[_vm._v("PARA TU NEGOCIO")]),_vm._v(" "),_c('p',{staticClass:"section-about-text info--text"},[_vm._v("\n\t\t\t\t\tCasa Market nace de la coyuntura actual, con el \n\t\t\t\t\tpropósito de impactar positivamente en la comunidad de emprendedores.\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-about-card layout wrap justify-center",attrs:{"row":"","wrap":""}},_vm._l((_vm.cards),function(card){return _c('v-flex',{key:card.id,attrs:{"md4":""}},[_c('card-icon',{attrs:{"card":card}})],1)}))]),_vm._v(" "),_c('v-flex',{staticClass:"section-about-right"},[_c('img',{staticClass:"section-about-image",attrs:{"src":"/static/images/sections/section-1-CM.png","alt":"app mi bodega"}})])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_addresses_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63686f73_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_addresses_vue__ = __webpack_require__(430);
function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63686f73"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_addresses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63686f73_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_addresses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(429);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("7a102f2a", content, true, {});

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-addresses[data-v-63686f73]{padding:40px 5%}@media (min-width:360px){.section-addresses[data-v-63686f73]{padding:40px 8%}}@media (min-width:768px){.section-addresses[data-v-63686f73]{padding:40px 10%}}.country[data-v-63686f73]{font-size:24px;font-weight:800;margin-bottom:10px}.city[data-v-63686f73]{font-size:16px;font-weight:800;margin-bottom:10px}.text[data-v-63686f73]{margin:0;line-height:1}.two-line[data-v-63686f73]{margin-bottom:37px}@media (min-width:1024px){.two-line[data-v-63686f73]{margin-bottom:0}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-addresses.vue"],"names":[],"mappings":"AACA,oCACE,eAAiB,CAClB,AACD,yBACA,oCACM,eAAiB,CACtB,CACA,AACD,yBACA,oCACM,gBAAkB,CACvB,CACA,AACD,0BACE,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,uBACE,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,uBACE,SAAY,AACZ,aAAe,CAChB,AACD,2BACE,kBAAoB,CACrB,AACD,0BACA,2BACM,eAAmB,CACxB,CACA","file":"section-addresses.vue","sourcesContent":["\n.section-addresses[data-v-63686f73] {\n  padding: 40px 5%;\n}\n@media (min-width: 360px) {\n.section-addresses[data-v-63686f73] {\n      padding: 40px 8%;\n}\n}\n@media (min-width: 768px) {\n.section-addresses[data-v-63686f73] {\n      padding: 40px 10%;\n}\n}\n.country[data-v-63686f73] {\n  font-size: 24px;\n  font-weight: 800;\n  margin-bottom: 10px;\n}\n.city[data-v-63686f73] {\n  font-size: 16px;\n  font-weight: 800;\n  margin-bottom: 10px;\n}\n.text[data-v-63686f73] {\n  margin: 0px;\n  line-height: 1;\n}\n.two-line[data-v-63686f73] {\n  margin-bottom: 37px;\n}\n@media (min-width: 1024px) {\n.two-line[data-v-63686f73] {\n      margin-bottom: 0px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-addresses",attrs:{"row":"","wrap":"","align-center":"","white":"","primary--text":""}},[_c('v-flex',{staticClass:"container",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('h2',{staticClass:"country"},[_vm._v("Perú")]),_vm._v(" "),_c('h4',{staticClass:"city"},[_vm._v("Lima")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.phone))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Calle Independencia  106,  Piso 10")]),_vm._v(" "),_c('p',{staticClass:"text two-line"},[_vm._v("Miraflores")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('h2',{staticClass:"country"},[_vm._v("Ecuador")]),_vm._v(" "),_c('h4',{staticClass:"city"},[_vm._v("Latacunga")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.phoneEcu))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("AV. UNIDAD NACIONAL Y GABRIELA MISTRAL. EDIF. FENIX CORP. "),_c('br'),_vm._v(" \n\t\t\t\t\tMatríz Centro Tecnológico Latacunga.")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_app_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09c6233c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_app_vue__ = __webpack_require__(434);
function injectStyle (ssrContext) {
  __webpack_require__(432)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09c6233c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09c6233c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(433);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("3f8fbcea", content, true, {});

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-app[data-v-09c6233c]{background-color:#f2f6f7;padding:0 5% 40px}@media (min-width:360px){.section-app[data-v-09c6233c]{padding:0 12% 40px}}@media (min-width:1024px){.section-app[data-v-09c6233c]{padding:0 7% 116px}}.section-app-main-title[data-v-09c6233c]{color:#085f65;font-size:35px;font-weight:900;line-height:1;margin:93px 0 57px;text-align:center;text-transform:uppercase}@media (min-width:1024px){.section-app-main-title[data-v-09c6233c]{margin:90px 0 102px}}@media (min-width:1024px){.section-app-padding[data-v-09c6233c]{padding-right:2%}}@media (min-width:1024px){.section-app-padding[data-v-09c6233c]:first-of-type,.section-app-padding[data-v-09c6233c]:nth-child(2),.section-app-padding[data-v-09c6233c]:nth-child(3){margin-bottom:27px}}.section-app-reason[data-v-09c6233c]{padding-left:10px}.section-app-title[data-v-09c6233c]{color:#085f65;font-size:18px;font-weight:900;margin-bottom:10px}.section-app-text[data-v-09c6233c]{color:#8f8f8f;font-size:16px;margin-bottom:36px}@media (min-width:1024px){.section-app-text[data-v-09c6233c]{margin-bottom:0}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-app.vue"],"names":[],"mappings":"AACA,8BACE,yBAA0B,AAC1B,iBAAqB,CACtB,AACD,yBACA,8BACM,kBAAsB,CAC3B,CACA,AACD,0BACA,8BACM,kBAAsB,CAC3B,CACA,AACD,yCACI,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,mBAAsB,AACtB,kBAAmB,AACnB,wBAA0B,CAC7B,AACD,0BACA,yCACQ,mBAAuB,CAC9B,CACA,AACD,0BACA,sCACM,gBAAkB,CACvB,CACA,AAWD,0BACA,0JACM,kBAAoB,CACzB,CACA,AACD,qCACI,iBAAmB,CACtB,AACD,oCACI,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACvB,AACD,mCACI,cAAe,AACf,eAAgB,AAChB,kBAAoB,CACvB,AACD,0BACA,mCACQ,eAAmB,CAC1B,CACA","file":"section-app.vue","sourcesContent":["\n.section-app[data-v-09c6233c] {\n  background-color: #f2f6f7;\n  padding: 0px 5% 40px;\n}\n@media (min-width: 360px) {\n.section-app[data-v-09c6233c] {\n      padding: 0px 12% 40px;\n}\n}\n@media (min-width: 1024px) {\n.section-app[data-v-09c6233c] {\n      padding: 0px 7% 116px;\n}\n}\n.section-app-main-title[data-v-09c6233c] {\n    color: #085f65;\n    font-size: 35px;\n    font-weight: 900;\n    line-height: 1;\n    margin: 93px 0px 57px;\n    text-align: center;\n    text-transform: uppercase;\n}\n@media (min-width: 1024px) {\n.section-app-main-title[data-v-09c6233c] {\n        margin: 90px 0px 102px;\n}\n}\n@media (min-width: 1024px) {\n.section-app-padding[data-v-09c6233c] {\n      padding-right: 2%;\n}\n}\n@media (min-width: 1024px) {\n.section-app-padding[data-v-09c6233c]:first-of-type {\n      margin-bottom: 27px;\n}\n}\n@media (min-width: 1024px) {\n.section-app-padding[data-v-09c6233c]:nth-child(2) {\n      margin-bottom: 27px;\n}\n}\n@media (min-width: 1024px) {\n.section-app-padding[data-v-09c6233c]:nth-child(3) {\n      margin-bottom: 27px;\n}\n}\n.section-app-reason[data-v-09c6233c] {\n    padding-left: 10px;\n}\n.section-app-title[data-v-09c6233c] {\n    color: #085f65;\n    font-size: 18px;\n    font-weight: 900;\n    margin-bottom: 10px;\n}\n.section-app-text[data-v-09c6233c] {\n    color: #8f8f8f;\n    font-size: 16px;\n    margin-bottom: 36px;\n}\n@media (min-width: 1024px) {\n.section-app-text[data-v-09c6233c] {\n        margin-bottom: 0px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-app",attrs:{"row":"","wrap":"","white--text":"","id":"whycasamarket"}},[_c('v-flex',{staticClass:"container",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"section-app-main-title"},[_vm._v("¿Por qué debes ser parte de CASAMARKET?")])]),_vm._v(" "),_vm._l((_vm.reasons),function(reason){return _c('v-flex',{key:reason.id,staticClass:"section-app-padding",attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":"","text-xs-right":""}},[_c('img',{attrs:{"src":"/static/images/icons/icon-check-CM.svg","alt":"viñeta para título","height":"20"}})]),_vm._v(" "),_c('v-flex',{staticClass:"section-app-reason",attrs:{"xs11":""}},[_c('h3',{staticClass:"section-app-title"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(reason.title)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"section-app-text"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(reason.text)+"\n\t\t\t\t\t\t")])])],1)],1)})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_banner_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e2b9a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_banner_vue__ = __webpack_require__(438);
function injectStyle (ssrContext) {
  __webpack_require__(436)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42e2b9a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e2b9a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(437);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("37a449b6", content, true, {});

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-banner[data-v-42e2b9a2]{background-image:url(\"/static/images/banners/banner-cost-mobile-CM.png\");background-position:bottom;background-repeat:no-repeat;background-size:cover;height:590px;padding-top:164px}@media (min-width:1024px){.section-banner[data-v-42e2b9a2]{background-image:url(\"/static/images/banners/banner-section-CM.png\");background-position:50%;height:auto;padding-top:0}}.section-banner-right[data-v-42e2b9a2]{padding:0 2% 73px}@media (min-width:360px){.section-banner-right[data-v-42e2b9a2]{padding:0 5% 73px}}@media (min-width:768px){.section-banner-right[data-v-42e2b9a2]{padding:0 8% 73px}}@media (min-width:1024px){.section-banner-right[data-v-42e2b9a2]{padding:40px 0}}.section-banner-btn[data-v-42e2b9a2]{background-color:#ff6e1c!important;border-radius:8px;color:#fff;font-size:16px;font-weight:900;height:91px!important;width:100%!important}@media (min-width:1024px){.section-banner-btn[data-v-42e2b9a2]{height:60px!important}}.section-banner-title[data-v-42e2b9a2]{color:#02979b!important;font-size:25px;font-weight:600;margin:0 2%;text-align:center}@media (min-width:360px){.section-banner-title[data-v-42e2b9a2]{margin:0 4%}}@media (min-width:1024px){.section-banner-title[data-v-42e2b9a2]{font-size:30px;margin:0}}.section-banner-title .text-bold[data-v-42e2b9a2]{font-size:32px;font-weight:900;text-transform:uppercase}@media (min-width:1024px){.section-banner-title .text-bold[data-v-42e2b9a2]{font-size:30px}}.section-banner-subtitle[data-v-42e2b9a2]{color:#8f8f8f;font-size:18px;margin:38px auto 36px;text-align:center}@media (min-width:1024px){.section-banner-subtitle[data-v-42e2b9a2]{margin:25px auto 28px}}.section-banner-list[data-v-42e2b9a2]{padding:0 2%}@media (min-width:1024px){.section-banner-list[data-v-42e2b9a2]{padding:0 4%}}@media (min-width:1280px){.section-banner-list[data-v-42e2b9a2]{padding:0 8%}}@media (min-width:1400px){.section-banner-list[data-v-42e2b9a2]{padding:0 14%}}.section-banner-item[data-v-42e2b9a2]{color:#494949;font-size:25px;font-weight:600;margin-bottom:30px}@media (min-width:1024px){.section-banner-item[data-v-42e2b9a2]{margin-bottom:24px}}.text-decoration-none[data-v-42e2b9a2]{text-decoration:none}.btn-container[data-v-42e2b9a2]{padding:0 2%}@media (min-width:1024px){.btn-container[data-v-42e2b9a2]{padding:2px 4% 0}}@media (min-width:1280px){.btn-container[data-v-42e2b9a2]{padding:2px 8% 0}}@media (min-width:1400px){.btn-container[data-v-42e2b9a2]{padding:2px 14% 0}}.section-banner-title[data-v-42e2b9a2]{color:#b1dc03}.sub-text[data-v-42e2b9a2]{color:#02979b;text-align:center}@media (min-width:1024px){.sub-text[data-v-42e2b9a2]{padding:0 20%}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-banner.vue"],"names":[],"mappings":"AACA,iCACE,yEAA0E,AAC1E,2BAA4B,AAC5B,4BAA6B,AAC7B,sBAAuB,AACvB,aAAc,AACd,iBAAmB,CACpB,AACD,0BACA,iCACM,qEAAsE,AACtE,wBAA4B,AAC5B,YAAa,AACb,aAAiB,CACtB,CACA,AACD,uCACI,iBAAqB,CACxB,AACD,yBACA,uCACQ,iBAAqB,CAC5B,CACA,AACD,yBACA,uCACQ,iBAAqB,CAC5B,CACA,AACD,0BACA,uCACQ,cAAkB,CACzB,CACA,AACD,qCACI,mCAAqC,AACrC,kBAAmB,AACnB,WAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,sBAAwB,AACxB,oBAAuB,CAC1B,AACD,0BACA,qCACQ,qBAAwB,CAC/B,CACA,AACD,uCACI,wBAA0B,AAC1B,eAAgB,AAChB,gBAAiB,AACjB,YAAe,AACf,iBAAmB,CACtB,AACD,yBACA,uCACQ,WAAe,CACtB,CACA,AACD,0BACA,uCACQ,eAAgB,AAChB,QAAY,CACnB,CACA,AACD,kDACM,eAAgB,AAChB,gBAAiB,AACjB,wBAA0B,CAC/B,AACD,0BACA,kDACU,cAAgB,CACzB,CACA,AACD,0CACI,cAAe,AACf,eAAgB,AAChB,sBAAuB,AACvB,iBAAmB,CACtB,AACD,0BACA,0CACQ,qBAAuB,CAC9B,CACA,AACD,sCACI,YAAgB,CACnB,AACD,0BACA,sCACQ,YAAgB,CACvB,CACA,AACD,0BACA,sCACQ,YAAgB,CACvB,CACA,AACD,0BACA,sCACQ,aAAiB,CACxB,CACA,AACD,sCACI,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACvB,AACD,0BACA,sCACQ,kBAAoB,CAC3B,CACA,AACD,uCACE,oBAAsB,CACvB,AACD,gCACE,YAAoB,CACrB,AACD,0BACA,gCACM,gBAAoB,CACzB,CACA,AACD,0BACA,gCACM,gBAAoB,CACzB,CACA,AACD,0BACA,gCACM,iBAAqB,CAC1B,CACA,AACD,uCACE,aAAe,CAChB,AACD,2BACE,cAAe,AACf,iBAAmB,CACpB,AACD,0BACA,2BACM,aAAiB,CACtB,CACA","file":"section-banner.vue","sourcesContent":["\n.section-banner[data-v-42e2b9a2] {\n  background-image: url(\"/static/images/banners/banner-cost-mobile-CM.png\");\n  background-position: bottom;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 590px;\n  padding-top: 164px;\n}\n@media (min-width: 1024px) {\n.section-banner[data-v-42e2b9a2] {\n      background-image: url(\"/static/images/banners/banner-section-CM.png\");\n      background-position: center;\n      height: auto;\n      padding-top: 0px;\n}\n}\n.section-banner-right[data-v-42e2b9a2] {\n    padding: 0px 2% 73px;\n}\n@media (min-width: 360px) {\n.section-banner-right[data-v-42e2b9a2] {\n        padding: 0px 5% 73px;\n}\n}\n@media (min-width: 768px) {\n.section-banner-right[data-v-42e2b9a2] {\n        padding: 0px 8% 73px;\n}\n}\n@media (min-width: 1024px) {\n.section-banner-right[data-v-42e2b9a2] {\n        padding: 40px 0px;\n}\n}\n.section-banner-btn[data-v-42e2b9a2] {\n    background-color: #ff6e1c !important;\n    border-radius: 8px;\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 900;\n    height: 91px !important;\n    width: 100% !important;\n}\n@media (min-width: 1024px) {\n.section-banner-btn[data-v-42e2b9a2] {\n        height: 60px !important;\n}\n}\n.section-banner-title[data-v-42e2b9a2] {\n    color: #02979b !important;\n    font-size: 25px;\n    font-weight: 600;\n    margin: 0px 2%;\n    text-align: center;\n}\n@media (min-width: 360px) {\n.section-banner-title[data-v-42e2b9a2] {\n        margin: 0px 4%;\n}\n}\n@media (min-width: 1024px) {\n.section-banner-title[data-v-42e2b9a2] {\n        font-size: 30px;\n        margin: 0px;\n}\n}\n.section-banner-title .text-bold[data-v-42e2b9a2] {\n      font-size: 32px;\n      font-weight: 900;\n      text-transform: uppercase;\n}\n@media (min-width: 1024px) {\n.section-banner-title .text-bold[data-v-42e2b9a2] {\n          font-size: 30px;\n}\n}\n.section-banner-subtitle[data-v-42e2b9a2] {\n    color: #8f8f8f;\n    font-size: 18px;\n    margin: 38px auto 36px;\n    text-align: center;\n}\n@media (min-width: 1024px) {\n.section-banner-subtitle[data-v-42e2b9a2] {\n        margin: 25px auto 28px;\n}\n}\n.section-banner-list[data-v-42e2b9a2] {\n    padding: 0px 2%;\n}\n@media (min-width: 1024px) {\n.section-banner-list[data-v-42e2b9a2] {\n        padding: 0px 4%;\n}\n}\n@media (min-width: 1280px) {\n.section-banner-list[data-v-42e2b9a2] {\n        padding: 0px 8%;\n}\n}\n@media (min-width: 1400px) {\n.section-banner-list[data-v-42e2b9a2] {\n        padding: 0px 14%;\n}\n}\n.section-banner-item[data-v-42e2b9a2] {\n    color: #494949;\n    font-size: 25px;\n    font-weight: 600;\n    margin-bottom: 30px;\n}\n@media (min-width: 1024px) {\n.section-banner-item[data-v-42e2b9a2] {\n        margin-bottom: 24px;\n}\n}\n.text-decoration-none[data-v-42e2b9a2] {\n  text-decoration: none;\n}\n.btn-container[data-v-42e2b9a2] {\n  padding: 0px 2% 0px;\n}\n@media (min-width: 1024px) {\n.btn-container[data-v-42e2b9a2] {\n      padding: 2px 4% 0px;\n}\n}\n@media (min-width: 1280px) {\n.btn-container[data-v-42e2b9a2] {\n      padding: 2px 8% 0px;\n}\n}\n@media (min-width: 1400px) {\n.btn-container[data-v-42e2b9a2] {\n      padding: 2px 14% 0px;\n}\n}\n.section-banner-title[data-v-42e2b9a2] {\n  color: #b1dc03;\n}\n.sub-text[data-v-42e2b9a2] {\n  color: #02979b;\n  text-align: center;\n}\n@media (min-width: 1024px) {\n.sub-text[data-v-42e2b9a2] {\n      padding: 0px 20%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-banner",attrs:{"row":"","wrap":"","justify-end":"","id":"section-banner"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}}),_vm._v(" "),_c('v-flex',{staticClass:"section-banner-right",attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","success--text":""}},[_c('h2',{staticClass:"section-banner-title"},[_vm._v("\n\t\t\t\t\t\t\t¿Cuál es el costo de ser parte de "),_c('span',{staticClass:"text-bold"},[_vm._v("CASAMARKET?")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","white--text":""}},[_c('h3',{staticClass:"section-banner-subtitle"},[_vm._v("\n\t\t\t\t\t\t\tTen tu propia app de pedidos con una mínima inversión\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{staticClass:"btn-container",attrs:{"xs12":""}},[_c('a',{staticClass:"text-decoration-none",attrs:{"href":_vm.link,"target":"_blank"}},[_c('v-btn',{staticClass:"btn-action btn-auto section-banner-btn",attrs:{"depressed":""}},[_vm._v("\n\t\t\t\t\t\t\t\tTen Tu Propia App de Pedidos desde "+_vm._s(_vm.numberMoney)+"\n\t\t\t\t\t\t\t")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-3":""}},[_c('p',{staticClass:"mb-0 sub-text"},[_vm._v("Nuestra promoción incluye un regalo de S/300\n\t\t\t\t\t\t\tpara que tus primeros pedidos sean gratis.")])])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_benefits_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bba4ef8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_benefits_vue__ = __webpack_require__(442);
function injectStyle (ssrContext) {
  __webpack_require__(440)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bba4ef8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_benefits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bba4ef8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_benefits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(441);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("5a605940", content, true, {});

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-benefits[data-v-bba4ef8a]{padding:86px 2% 94px}@media (min-width:360px){.section-benefits[data-v-bba4ef8a]{padding:86px 5% 94px}}@media (min-width:768px){.section-benefits[data-v-bba4ef8a]{padding:86px 8% 94px}}@media (min-width:1024px){.section-benefits[data-v-bba4ef8a]{padding:103px 10%}}.section-benefits-card[data-v-bba4ef8a]{border-radius:18px;box-shadow:0 2px 20px 0 rgba(0,0,0,.06);padding:46px 2% 53px}@media (min-width:360px){.section-benefits-card[data-v-bba4ef8a]{padding:46px 5% 53px}}@media (min-width:768px){.section-benefits-card[data-v-bba4ef8a]{padding:46px 10% 53px}}@media (min-width:1024px){.section-benefits-card[data-v-bba4ef8a]{padding:85px 5% 68px}}.section-benefits-title[data-v-bba4ef8a]{font-size:24px;font-weight:900;line-height:normal;margin-bottom:72px}@media (min-width:1024px){.section-benefits-title[data-v-bba4ef8a]{font-size:30px;margin-bottom:44px;text-transform:uppercase}}.section-benefits-number[data-v-bba4ef8a]{border-radius:100%;font-size:18px;height:34px;line-height:34px;text-align:center;width:34px}.section-benefits-text[data-v-bba4ef8a]{font-size:20px;line-height:normal}.section-benefits-item[data-v-bba4ef8a]{margin-bottom:19px;margin-left:-19%}@media (min-width:768px){.section-benefits-item[data-v-bba4ef8a]{margin-bottom:21px;margin-top:19px;margin-left:-8.5%}}@media (min-width:1024px){.section-benefits-item[data-v-bba4ef8a]{align-items:center;margin-bottom:21px;margin-left:0}}.section-benefits-item-text[data-v-bba4ef8a]{font-size:18px;line-height:normal}.section-benefits-container[data-v-bba4ef8a]{margin-bottom:21px}@media (min-width:1024px){.section-benefits-container[data-v-bba4ef8a]{margin-bottom:25px}}@media (min-width:1280px){.section-benefits-right[data-v-bba4ef8a]{padding-left:5%}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-benefits.vue"],"names":[],"mappings":"AACA,mCACE,oBAAsB,CACvB,AACD,yBACA,mCACM,oBAAsB,CAC3B,CACA,AACD,yBACA,mCACM,oBAAsB,CAC3B,CACA,AACD,0BACA,mCACM,iBAAmB,CACxB,CACA,AACD,wCACI,mBAAoB,AACpB,wCAA6C,AAC7C,oBAAsB,CACzB,AACD,yBACA,wCACQ,oBAAsB,CAC7B,CACA,AACD,yBACA,wCACQ,qBAAuB,CAC9B,CACA,AACD,0BACA,wCACQ,oBAAsB,CAC7B,CACA,AACD,yCACI,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,kBAAoB,CACvB,AACD,0BACA,yCACQ,eAAgB,AAChB,mBAAoB,AACpB,wBAA0B,CACjC,CACA,AACD,0CACI,mBAAoB,AACpB,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,UAAY,CACf,AACD,wCACI,eAAgB,AAChB,kBAAoB,CACvB,AACD,wCACI,mBAAoB,AACpB,gBAAkB,CACrB,AACD,yBACA,wCACQ,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CAC1B,CACA,AACD,0BACA,wCACQ,mBAAoB,AACpB,mBAAoB,AACpB,aAAiB,CACxB,CACA,AACD,6CACM,eAAgB,AAChB,kBAAoB,CACzB,AACD,6CACI,kBAAoB,CACvB,AACD,0BACA,6CACQ,kBAAoB,CAC3B,CACA,AACD,0BACA,yCACM,eAAiB,CACtB,CACA","file":"section-benefits.vue","sourcesContent":["\n.section-benefits[data-v-bba4ef8a] {\n  padding: 86px 2% 94px;\n}\n@media (min-width: 360px) {\n.section-benefits[data-v-bba4ef8a] {\n      padding: 86px 5% 94px;\n}\n}\n@media (min-width: 768px) {\n.section-benefits[data-v-bba4ef8a] {\n      padding: 86px 8% 94px;\n}\n}\n@media (min-width: 1024px) {\n.section-benefits[data-v-bba4ef8a] {\n      padding: 103px 10%;\n}\n}\n.section-benefits-card[data-v-bba4ef8a] {\n    border-radius: 18px;\n    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.06);\n    padding: 46px 2% 53px;\n}\n@media (min-width: 360px) {\n.section-benefits-card[data-v-bba4ef8a] {\n        padding: 46px 5% 53px;\n}\n}\n@media (min-width: 768px) {\n.section-benefits-card[data-v-bba4ef8a] {\n        padding: 46px 10% 53px;\n}\n}\n@media (min-width: 1024px) {\n.section-benefits-card[data-v-bba4ef8a] {\n        padding: 85px 5% 68px;\n}\n}\n.section-benefits-title[data-v-bba4ef8a] {\n    font-size: 24px;\n    font-weight: 900;\n    line-height: normal;\n    margin-bottom: 72px;\n}\n@media (min-width: 1024px) {\n.section-benefits-title[data-v-bba4ef8a] {\n        font-size: 30px;\n        margin-bottom: 44px;\n        text-transform: uppercase;\n}\n}\n.section-benefits-number[data-v-bba4ef8a] {\n    border-radius: 100%;\n    font-size: 18px;\n    height: 34px;\n    line-height: 34px;\n    text-align: center;\n    width: 34px;\n}\n.section-benefits-text[data-v-bba4ef8a] {\n    font-size: 20px;\n    line-height: normal;\n}\n.section-benefits-item[data-v-bba4ef8a] {\n    margin-bottom: 19px;\n    margin-left: -19%;\n}\n@media (min-width: 768px) {\n.section-benefits-item[data-v-bba4ef8a] {\n        margin-bottom: 21px;\n        margin-top: 19px;\n        margin-left: -8.5%;\n}\n}\n@media (min-width: 1024px) {\n.section-benefits-item[data-v-bba4ef8a] {\n        align-items: center;\n        margin-bottom: 21px;\n        margin-left: 0px;\n}\n}\n.section-benefits-item-text[data-v-bba4ef8a] {\n      font-size: 18px;\n      line-height: normal;\n}\n.section-benefits-container[data-v-bba4ef8a] {\n    margin-bottom: 21px;\n}\n@media (min-width: 1024px) {\n.section-benefits-container[data-v-bba4ef8a] {\n        margin-bottom: 25px;\n}\n}\n@media (min-width: 1280px) {\n.section-benefits-right[data-v-bba4ef8a] {\n      padding-left: 5%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-benefits",attrs:{"row":"","wrap":"","accent":"","id":"benefits"}},[_c('v-flex',{staticClass:"container",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","secondary--text":"","text-xs-center":""}},[_c('h2',{staticClass:"section-benefits-title"},[_vm._v("Sé parte de nuestra red de bodegueros afiliados")])]),_vm._v(" "),_c('v-flex',{staticClass:"section-benefits-card",attrs:{"xs12":"","white":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","info--text":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},_vm._l((_vm.benefitsLeft),function(benefit){return _c('v-layout',{key:benefit.id,staticClass:"section-benefits-container",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs2":"","sm1":"","md2":"","lg1":"","secondary--text":""}},[_c('div',{staticClass:"section-benefits-number success"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(benefit.number)+"\n\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm11":"","md10":"","lg11":""}},[_c('div',{staticClass:"section-benefits-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(benefit.text)+"\n\t\t\t\t\t\t\t\t")])])],1)})),_vm._v(" "),_c('v-flex',{staticClass:"section-benefits-right",attrs:{"xs12":"","md6":""}},_vm._l((_vm.benefitsRight),function(benefit){return _c('v-layout',{key:benefit.id,attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm1":"","md2":"","lg1":"","secondary--text":""}},[_c('div',{staticClass:"section-benefits-number success"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(benefit.number)+"\n\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm11":"","md10":"","lg11":""}},[_c('div',{staticClass:"section-benefits-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(benefit.text)+"\n\t\t\t\t\t\t\t\t\t"),(benefit.id === 7)?_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v("Aqui")]):_vm._e()]),_vm._v(" "),_vm._l((benefit.list),function(item,index){return _c('v-layout',{key:index,staticClass:"section-benefits-item",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm1":"","md2":"","lg1":""}},[_c('img',{attrs:{"src":"/static/images/icons/icon-check.svg","alt":"viñeta para beneficio","height":"29"}})]),_vm._v(" "),_c('v-flex',{staticClass:"section-benefits-item-text",attrs:{"xs10":"","sm11":"","md10":"","lg11":""}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(item)+"\n\t\t\t\t\t\t\t\t\t")])],1)})],2)],1)}))],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_brand_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b5f8124_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_brand_vue__ = __webpack_require__(446);
function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b5f8124"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_brand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b5f8124_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_brand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(445);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("71e71da5", content, true, {});

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-brand[data-v-2b5f8124]{padding:40px 3%}@media (min-width:360px){.section-brand[data-v-2b5f8124]{padding:40px 5%}}@media (min-width:1024px){.section-brand[data-v-2b5f8124]{padding:40px 10%}}@media (min-width:1280px){.section-brand[data-v-2b5f8124]{padding:40px 11%}}@media (min-width:1400px){.section-brand[data-v-2b5f8124]{padding:40px 13%}}.section-brand-left[data-v-2b5f8124]{margin-bottom:53px;text-align:center}@media (min-width:1024px){.section-brand-left[data-v-2b5f8124]{margin-bottom:0;text-align:left}}.section-brand-right[data-v-2b5f8124]{text-align:center}@media (min-width:1024px){.section-brand-right[data-v-2b5f8124]{text-align:right}}.section-brand-image[data-v-2b5f8124]{height:auto;max-width:100%}@media (min-width:1024px){.section-brand-image[data-v-2b5f8124]{height:89px}}.section-brand .image-facebook[data-v-2b5f8124]{margin-right:28px}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-brand.vue"],"names":[],"mappings":"AACA,gCACE,eAAiB,CAClB,AACD,yBACA,gCACM,eAAiB,CACtB,CACA,AACD,0BACA,gCACM,gBAAkB,CACvB,CACA,AACD,0BACA,gCACM,gBAAkB,CACvB,CACA,AACD,0BACA,gCACM,gBAAkB,CACvB,CACA,AACD,qCACI,mBAAoB,AACpB,iBAAmB,CACtB,AACD,0BACA,qCACQ,gBAAmB,AACnB,eAAiB,CACxB,CACA,AACD,sCACI,iBAAmB,CACtB,AACD,0BACA,sCACQ,gBAAkB,CACzB,CACA,AACD,sCACI,YAAa,AACb,cAAgB,CACnB,AACD,0BACA,sCACQ,WAAa,CACpB,CACA,AACD,gDACI,iBAAmB,CACtB","file":"section-brand.vue","sourcesContent":["\n.section-brand[data-v-2b5f8124] {\n  padding: 40px 3%;\n}\n@media (min-width: 360px) {\n.section-brand[data-v-2b5f8124] {\n      padding: 40px 5%;\n}\n}\n@media (min-width: 1024px) {\n.section-brand[data-v-2b5f8124] {\n      padding: 40px 10%;\n}\n}\n@media (min-width: 1280px) {\n.section-brand[data-v-2b5f8124] {\n      padding: 40px 11%;\n}\n}\n@media (min-width: 1400px) {\n.section-brand[data-v-2b5f8124] {\n      padding: 40px 13%;\n}\n}\n.section-brand-left[data-v-2b5f8124] {\n    margin-bottom: 53px;\n    text-align: center;\n}\n@media (min-width: 1024px) {\n.section-brand-left[data-v-2b5f8124] {\n        margin-bottom: 0px;\n        text-align: left;\n}\n}\n.section-brand-right[data-v-2b5f8124] {\n    text-align: center;\n}\n@media (min-width: 1024px) {\n.section-brand-right[data-v-2b5f8124] {\n        text-align: right;\n}\n}\n.section-brand-image[data-v-2b5f8124] {\n    height: auto;\n    max-width: 100%;\n}\n@media (min-width: 1024px) {\n.section-brand-image[data-v-2b5f8124] {\n        height: 89px;\n}\n}\n.section-brand .image-facebook[data-v-2b5f8124] {\n    margin-right: 28px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-brand",attrs:{"row":"","wrap":"","align-center":"","background":""}},[_c('div',{staticClass:"container"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"section-brand-left",attrs:{"xs12":"","md6":""}},[_c('a',{attrs:{"href":_vm.landingLink,"target":"_blank"}},[_c('img',{staticClass:"section-brand-image",attrs:{"src":"/static/images/logos/logo-casa-market-orange.svg","alt":"logo CasaMarket"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"section-brand-right",attrs:{"xs12":"","md6":""}},[_c('a',{staticClass:"btn-image image-facebook",attrs:{"href":_vm.facebookUrl,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images/logos/logo-facebook.svg","alt":"facebook mi bodega","height":"54"}})]),_vm._v(" "),_c('a',{staticClass:"btn-image image-instagram",attrs:{"href":_vm.instagramUrl,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images/logos/logo-instagram.svg","alt":"instagram mi bodega","height":"54"}})])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_faq_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab5e66a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_faq_vue__ = __webpack_require__(450);
function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ab5e66a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab5e66a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(449);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("26b0a2e1", content, true, {});

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-faq[data-v-6ab5e66a]{padding:50px 10% 66px;text-align:center}@media (min-width:1024px){.section-faq[data-v-6ab5e66a]{text-align:left}}.section-faq-title[data-v-6ab5e66a]{font-size:30px;font-weight:900;margin-bottom:64px}.section-faq-item-title[data-v-6ab5e66a]{background-color:#f2f6f7;color:#085f65;font-weight:600;padding:8px 13px;margin-bottom:15px}@media (min-width:1024px){.section-faq-item-title[data-v-6ab5e66a]{font-size:16px}}.section-faq-item-text[data-v-6ab5e66a]{margin-bottom:15px;padding:8px 13px}@media (min-width:1024px){.section-faq-right[data-v-6ab5e66a]{padding-left:8%}}.section-faq .btn-link[data-v-6ab5e66a]{border-bottom:1px solid #02979b;color:#02979b}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-faq.vue"],"names":[],"mappings":"AACA,8BACE,sBAAuB,AACvB,iBAAmB,CACpB,AACD,0BACA,8BACM,eAAiB,CACtB,CACA,AACD,oCACI,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACvB,AACD,yCACI,yBAA0B,AAC1B,cAAe,AACf,gBAAiB,AACjB,iBAAkB,AAClB,kBAAoB,CACvB,AACD,0BACA,yCACQ,cAAgB,CACvB,CACA,AACD,wCACI,mBAAoB,AACpB,gBAAkB,CACrB,AACD,0BACA,oCACM,eAAiB,CACtB,CACA,AACD,wCACI,gCAAiC,AACjC,aAAe,CAClB","file":"section-faq.vue","sourcesContent":["\n.section-faq[data-v-6ab5e66a] {\n  padding: 50px 10% 66px;\n  text-align: center;\n}\n@media (min-width: 1024px) {\n.section-faq[data-v-6ab5e66a] {\n      text-align: left;\n}\n}\n.section-faq-title[data-v-6ab5e66a] {\n    font-size: 30px;\n    font-weight: 900;\n    margin-bottom: 64px;\n}\n.section-faq-item-title[data-v-6ab5e66a] {\n    background-color: #f2f6f7;\n    color: #085f65;\n    font-weight: 600;\n    padding: 8px 13px;\n    margin-bottom: 15px;\n}\n@media (min-width: 1024px) {\n.section-faq-item-title[data-v-6ab5e66a] {\n        font-size: 16px;\n}\n}\n.section-faq-item-text[data-v-6ab5e66a] {\n    margin-bottom: 15px;\n    padding: 8px 13px;\n}\n@media (min-width: 1024px) {\n.section-faq-right[data-v-6ab5e66a] {\n      padding-left: 8%;\n}\n}\n.section-faq .btn-link[data-v-6ab5e66a] {\n    border-bottom: 1px solid #02979b;\n    color: #02979b;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-faq",attrs:{"row":"","wrap":"","white":"","info--text":"","id":"question"}},[_c('div',{staticClass:"container"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm2":"","md1":""}},[_c('img',{attrs:{"src":"/static/images/icons/favicon-casamarket.svg","alt":"mi bodega","height":"58"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","sm10":"","md11":""}},[_c('h2',{staticClass:"section-faq-title secondary--text"},[_vm._v("PREGUNTAS FRECUENTES")])]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-container",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"section-faq-item",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿Cuál es el costo de tener mi propio Aplicativo?\t\t\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tTen tu propia app de pedidos con una mínima inversión. Déjanos tus datos\n\t\t\t\t\t\t\t\t"),_c('button',{staticClass:"btn-link",on:{"click":function($event){_vm.$emit('open-register')}}},[_vm._v("aquí")]),_vm._v(" para que un asesor de ventas\n\t\t\t\t\t\t\t\tse comunique contigo y pueda darte todo el detalle del servicio.\n\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-right",attrs:{"xs12":"","md8":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿Qué puedo vender con CasaMarket?\t\t\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tPuedes vender lo que quieras en el rubro que desees, recuerda que es tu negocio y hemos creado un aplicativo que se adapta a ti.\n\t\t\t\t\t\t\t")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"section-faq-item",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿El servicio es a nivel nacional?\t\t\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tSi, puedes contratar nuestro servicio a nivel nacional.\n\t\t\t\t\t\t\t\tCasaMarket funciona en todo el país.\n\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-right",attrs:{"xs12":"","md8":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿Qué pasa si no cuente con el servicio de delivery?\t\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tNo hay problema, CasaMarket se adapta a tu negocio y \n\t\t\t\t\t\t\t\tsolo ofrecerás el servicio de \"recojo en tienda\". \n\t\t\t\t\t\t\t\tEn el momento que decidas incluir el servicio de delivery \n\t\t\t\t\t\t\t\tlo incluiremos en tu aplicativo, ya que estamos \n\t\t\t\t\t\t\t\tpreparados para ofrecerlo.\n\t\t\t\t\t\t\t")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"section-faq-item",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿Qué pasa si tengo más de un local?\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tExcelente, con CasaMarket puedes gestionar todas las tiendas \n\t\t\t\t\t\t\t\tque tengas. Déjanos tus datos "),_c('button',{staticClass:"btn-link",on:{"click":function($event){_vm.$emit('open-register')}}},[_vm._v("aquí")]),_vm._v(" \n\t\t\t\t\t\t\t\tpara que un asesor de ventas se comunique contigo y pueda darte todo el detalle del servicio.\n\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-right",attrs:{"xs12":"","md8":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿Qué pasa si no cuento con el servicio de pago online?\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tNo hay problema, CasaMarket se adapta a tu negocio y \n\t\t\t\t\t\t\t\tsolo ofrecerás el servicio de \"pago en efectivo\". \n\t\t\t\t\t\t\t\tEn el momento que decidas incluir el servicio de pago online \n\t\t\t\t\t\t\t\tlo incluimos en tu aplicativo, ya que estamos preparados \n\t\t\t\t\t\t\t\tpara ofrecerlo. El contrato con las plataformas de pago \n\t\t\t\t\t\t\t\tonline es directamente con el dueño cada negocio.\n\t\t\t\t\t\t\t")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"section-faq-item",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿En cuánto tiempo me entregan el aplicativo?\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tDepende cuán rápido efectúes el pago y coordinemos toda la información de tu negocio,\n\t\t\t\t\t\t\t\tpero es un promedio de 2 semanas como máximo.\n\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-right",attrs:{"xs12":"","md8":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿Cómo funcionan los Pedicréditos?\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tEs muy sencillo y hemos pensado la manera más conveniente para tu negocio.\n\t\t\t\t\t\t\t\tSólo debes precargar tu aplicativo con el monto que deseas y éste se\n\t\t\t\t\t\t\t\tdescontará de cada pedido generado. Por ejemplo, si recargas S/1 de \"Pedicréditos\"\n\t\t\t\t\t\t\t\tese dinero te alcanza para la comisión de 5 pedidos de S/0.2 "+_vm._s(_vm.money)+" cada uno.\n\t\t\t\t\t\t\t\tEn el caso que no hayas hecho la recarga de \"Pedicréditos\" y un cliente haga un pedido,\n\t\t\t\t\t\t\t\tte avisamos para que recargues y no pierdas la venta. El monto mínimo de recarga es de S/20.\n\t\t\t\t\t\t\t")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"section-faq-item",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿Quién determina el precio del producto?\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tTú, como dueño de tu negocio. Es muy sencillo de hacerlo:\n\t\t\t\t\t\t\t\tSolo ingresas a tu administrador y podrás determinar los precios\n\t\t\t\t\t\t\t\tde tus productos.\n\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-right",attrs:{"xs12":"","md8":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-faq-item-title",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\t¿CasaMarket trabaja con otro tipo de negocios, como restaurantes o lavanderías?\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"section-faq-item-text",attrs:{"xs12":""}},[_vm._v("\n\t\t\t\t\t\t\t\tSí, ponemos a disposición de otras industrias el aplicativo para que puedan hacer\n\t\t\t\t\t\t\t\tcrecer su negocio. En caso desees más información, déjanos tus datos "),_c('button',{staticClass:"btn-link",on:{"click":function($event){_vm.$emit('open-register')}}},[_vm._v("aquí")]),_vm._v(" para que\n\t\t\t\t\t\t\t\tun asesor de ventas se comunique contigo y pueda darte todo el detalle del servicio.\n\t\t\t\t\t\t\t")])],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_features_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731c4c62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_features_vue__ = __webpack_require__(454);
function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-731c4c62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_features_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731c4c62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_features_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(453);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("165090bc", content, true, {});

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-features[data-v-731c4c62]{padding:48px 5%}@media (min-width:360px){.section-features[data-v-731c4c62]{padding:48px 10%}}@media (min-width:1024px){.section-features[data-v-731c4c62]{padding:127px 19%}}.section-features-title[data-v-731c4c62]{font-size:20px;font-weight:900;line-height:normal;text-transform:uppercase}@media (min-width:1024px){.section-features-title[data-v-731c4c62]{font-size:30px}}.section-features-title-big[data-v-731c4c62]{font-size:25px;margin-bottom:48px}@media (min-width:1024px){.section-features-title-big[data-v-731c4c62]{font-size:39px}}.section-features-feature[data-v-731c4c62]{font-size:16px;font-weight:700}.section-features-number[data-v-731c4c62]{color:#ff6e1c;font-size:30px;font-weight:900;margin-top:15px;margin-bottom:0}.section-features-image[data-v-731c4c62]{padding-top:30px;text-align:center}@media (min-width:1024px){.section-features-image[data-v-731c4c62]{padding-top:0;text-align:right}}.section-features-text[data-v-731c4c62]{text-align:center}@media (min-width:1024px){.section-features-text[data-v-731c4c62]{text-align:left}}.section-features-btn[data-v-731c4c62]{background-color:#ff6e1c!important;border-radius:8px;box-shadow:none;color:#fff!important;display:inline-block;height:auto!important;margin:30px 0 0;text-align:center;text-decoration:none;width:80%}@media (min-width:1024px){.section-features .container-mobile[data-v-731c4c62]{display:none}}.section-features .container-desktop[data-v-731c4c62]{display:none}@media (min-width:1024px){.section-features .container-desktop[data-v-731c4c62]{display:block}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-features.vue"],"names":[],"mappings":"AACA,mCACE,eAAiB,CAClB,AACD,yBACA,mCACM,gBAAkB,CACvB,CACA,AACD,0BACA,mCACM,iBAAmB,CACxB,CACA,AACD,yCACI,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,wBAA0B,CAC7B,AACD,0BACA,yCACQ,cAAgB,CACvB,CACA,AACD,6CACM,eAAgB,AAChB,kBAAoB,CACzB,AACD,0BACA,6CACU,cAAgB,CACzB,CACA,AACD,2CACI,eAAgB,AAChB,eAAiB,CACpB,AACD,0CACI,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,eAAmB,CACtB,AACD,yCACI,iBAAkB,AAClB,iBAAmB,CACtB,AACD,0BACA,yCACQ,cAAiB,AACjB,gBAAkB,CACzB,CACA,AACD,wCACI,iBAAmB,CACtB,AACD,0BACA,wCACQ,eAAiB,CACxB,CACA,AACD,uCACI,mCAAqC,AACrC,kBAAmB,AACnB,gBAAiB,AACjB,qBAA0B,AAC1B,qBAAsB,AACtB,sBAAwB,AACxB,gBAAmB,AACnB,kBAAmB,AACnB,qBAAsB,AACtB,SAAW,CACd,AACD,0BACA,qDACM,YAAc,CACnB,CACA,AACD,sDACI,YAAc,CACjB,AACD,0BACA,sDACQ,aAAe,CACtB,CACA","file":"section-features.vue","sourcesContent":["\n.section-features[data-v-731c4c62] {\n  padding: 48px 5%;\n}\n@media (min-width: 360px) {\n.section-features[data-v-731c4c62] {\n      padding: 48px 10%;\n}\n}\n@media (min-width: 1024px) {\n.section-features[data-v-731c4c62] {\n      padding: 127px 19%;\n}\n}\n.section-features-title[data-v-731c4c62] {\n    font-size: 20px;\n    font-weight: 900;\n    line-height: normal;\n    text-transform: uppercase;\n}\n@media (min-width: 1024px) {\n.section-features-title[data-v-731c4c62] {\n        font-size: 30px;\n}\n}\n.section-features-title-big[data-v-731c4c62] {\n      font-size: 25px;\n      margin-bottom: 48px;\n}\n@media (min-width: 1024px) {\n.section-features-title-big[data-v-731c4c62] {\n          font-size: 39px;\n}\n}\n.section-features-feature[data-v-731c4c62] {\n    font-size: 16px;\n    font-weight: 700;\n}\n.section-features-number[data-v-731c4c62] {\n    color: #ff6e1c;\n    font-size: 30px;\n    font-weight: 900;\n    margin-top: 15px;\n    margin-bottom: 0px;\n}\n.section-features-image[data-v-731c4c62] {\n    padding-top: 30px;\n    text-align: center;\n}\n@media (min-width: 1024px) {\n.section-features-image[data-v-731c4c62] {\n        padding-top: 0px;\n        text-align: right;\n}\n}\n.section-features-text[data-v-731c4c62] {\n    text-align: center;\n}\n@media (min-width: 1024px) {\n.section-features-text[data-v-731c4c62] {\n        text-align: left;\n}\n}\n.section-features-btn[data-v-731c4c62] {\n    background-color: #ff6e1c !important;\n    border-radius: 8px;\n    box-shadow: none;\n    color: #ffffff !important;\n    display: inline-block;\n    height: auto !important;\n    margin: 30px 0 0 0;\n    text-align: center;\n    text-decoration: none;\n    width: 80%;\n}\n@media (min-width: 1024px) {\n.section-features .container-mobile[data-v-731c4c62] {\n      display: none;\n}\n}\n.section-features .container-desktop[data-v-731c4c62] {\n    display: none;\n}\n@media (min-width: 1024px) {\n.section-features .container-desktop[data-v-731c4c62] {\n        display: block;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-features",attrs:{"row":"","wrap":"","white":"","id":"features"}},[_c('v-flex',{staticClass:"section-features-text",attrs:{"xs12":"","md7":"","secondary--text":""}},[_c('h3',{staticClass:"section-features-title"},[_vm._v("¿Por qué debes aprovechar")]),_vm._v(" "),_c('h3',{staticClass:"section-features-title section-features-title-big"},[_vm._v("Esta Oportunidad?")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","secondary--text":""}},[_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('img',{attrs:{"src":"/static/images/icons/icon-6.svg","height":"42"}}),_vm._v(" "),_c('p',{staticClass:"section-features-feature"},[_vm._v("CONTRIBUYES AL AISLAMIENTO OBLIGATORIO")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('img',{attrs:{"src":"/static/images/icons/icon-1-CM.svg","height":"42"}}),_vm._v(" "),_c('p',{staticClass:"section-features-feature"},[_vm._v("TU TIENDA DISPONIBLE 24/7")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"section-features-number"},[_vm._v("95%")]),_vm._v(" "),_c('p',{staticClass:"section-features-feature"},[_vm._v("DE TUS CLIENTES TIENE UN SMARTPHONE")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"section-features-number"},[_vm._v("80%")]),_vm._v(" "),_c('p',{staticClass:"section-features-feature"},[_vm._v("DE TUS CLIENTES USAN APLICATIVOS PARA COMPRAR")])]),_vm._v(" "),_c('v-flex',{staticClass:"container-desktop",attrs:{"xs12":""}},[_c('button',{staticClass:"section-features-btn py-3",on:{"click":function($event){_vm.$emit('open-modal-btn')}}},[_c('p',{staticClass:"mb-0"},[_vm._v("DESEO CONOCER LA PROMOCIÓN DE LANZAMIENTO")])])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"section-features-image",attrs:{"xs12":"","md4":""}},[_c('img',{attrs:{"src":"/static/images/sections/feature-1.png","height":"590","alt":"app mi bodega"}})]),_vm._v(" "),_c('v-flex',{staticClass:"container-mobile",attrs:{"xs12":"","text-xs-center":""}},[_c('button',{staticClass:"section-features-btn pa-2",on:{"click":function($event){_vm.$emit('open-modal-btn')}}},[_c('p',{staticClass:"mb-0"},[_vm._v("DESEO CONOCER LA PROMOCIÓN "),_c('br'),_vm._v(" DE LANZAMIENTO")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_mobile_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b56b20a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_mobile_vue__ = __webpack_require__(458);
function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b56b20a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_mobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b56b20a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_mobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(457);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("6276b512", content, true, {});

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".background-white[data-v-b56b20a8]{background-color:#fff}@media (min-width:1024px){.section-mobile[data-v-b56b20a8]{display:none}}.online-mobile[data-v-b56b20a8]{border-radius:8px;background-color:rgba(141,205,208,.45);color:#02979b;font-family:Lato;font-size:20px;font-weight:500;height:76px!important;padding:14px 9px;width:232px}.sub-title-mobile[data-v-b56b20a8]{color:#494949;font-family:Lato;font-size:30px;font-weight:900}.btn-request-app[data-v-b56b20a8]{border-radius:8px;font-family:Lato;font-size:20px;font-weight:900;height:60px!important;width:271px!important}.text-orange[data-v-b56b20a8]{color:#ff6e1c}.ft-24[data-v-b56b20a8]{font-size:24px}.text-decoration-none[data-v-b56b20a8]{text-decoration:none}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-mobile.vue"],"names":[],"mappings":"AACA,mCACE,qBAAwB,CACzB,AACD,0BACA,iCACI,YAAc,CACjB,CACA,AACD,gCACE,kBAAmB,AACnB,uCAA4C,AAC5C,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,sBAAwB,AACxB,iBAAkB,AAClB,WAAa,CACd,AACD,mCACE,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,eAAiB,CAClB,AACD,kCACE,kBAAmB,AACnB,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,sBAAwB,AACxB,qBAAwB,CACzB,AACD,8BACE,aAAe,CAChB,AACD,wBACE,cAAgB,CACjB,AACD,uCACE,oBAAsB,CACvB","file":"section-mobile.vue","sourcesContent":["\n.background-white[data-v-b56b20a8] {\n  background-color: white;\n}\n@media (min-width: 1024px) {\n.section-mobile[data-v-b56b20a8] {\n    display: none;\n}\n}\n.online-mobile[data-v-b56b20a8] {\n  border-radius: 8px;\n  background-color: rgba(141, 205, 208, 0.45);\n  color: #02979b;\n  font-family: \"Lato\";\n  font-size: 20px;\n  font-weight: 500;\n  height: 76px !important;\n  padding: 14px 9px;\n  width: 232px;\n}\n.sub-title-mobile[data-v-b56b20a8] {\n  color: #494949;\n  font-family: \"Lato\";\n  font-size: 30px;\n  font-weight: 900;\n}\n.btn-request-app[data-v-b56b20a8] {\n  border-radius: 8px;\n  font-family: \"Lato\";\n  font-size: 20px;\n  font-weight: 900;\n  height: 60px !important;\n  width: 271px !important;\n}\n.text-orange[data-v-b56b20a8] {\n  color: #ff6e1c;\n}\n.ft-24[data-v-b56b20a8] {\n  font-size: 24px;\n}\n.text-decoration-none[data-v-b56b20a8] {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-white pt-3 pb-5 section-mobile"},[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('v-flex',{staticClass:"online-mobile",attrs:{"xs6":"","text-xs-center":""}},[_vm._v("\n\t\t\t\tComienza a vender "),_c('br'),_vm._v(" online desde "),_c('span',{staticClass:"bold ft-24"},[_vm._v(" S/500 ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-4":""}},[_c('v-btn',{staticClass:"btn-action btn-auto btn-request-app white--text",attrs:{"color":"orange","depressed":""},on:{"click":function($event){_vm.$emit('open-modal-btn')}}},[_vm._v("\n\t\t\t\t\tSOLICITA TU APP\n\t\t\t\t")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_how_it_work_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_894ad1a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_how_it_work_vue__ = __webpack_require__(462);
function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-894ad1a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_how_it_work_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_894ad1a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_how_it_work_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(461);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("0c8c28b7", content, true, {});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-how-it-work[data-v-894ad1a6]{padding:49px 2% 81px;text-align:center}@media (min-width:1024px){.section-how-it-work[data-v-894ad1a6]{padding:66px 8% 74px;text-align:left}}@media (min-width:1280px){.section-how-it-work[data-v-894ad1a6]{padding:66px 10% 74px}}.section-how-it-work-title[data-v-894ad1a6]{line-height:1}@media (min-width:1024px){.section-how-it-work-title[data-v-894ad1a6]{border-right:2px solid #085f65;padding-right:28px;text-align:right}}.section-how-it-work-title h3[data-v-894ad1a6]{font-size:30px;font-weight:900;text-transform:uppercase}.section-how-it-work-title h2[data-v-894ad1a6]{font-size:47px;font-weight:900}.section-how-it-work-subtext p[data-v-894ad1a6]{font-size:18px;line-height:23px;margin:47px auto 72px;max-width:287px}@media (min-width:1024px){.section-how-it-work-subtext p[data-v-894ad1a6]{margin:15px 0 0 38px;max-width:none}}.section-how-it-work-btn[data-v-894ad1a6]{border-radius:8px;font-size:20px;font-weight:600;height:60px!important;width:271px!important}.step-image-container[data-v-894ad1a6]{margin:auto;position:relative;width:fit-content;width:-moz-fit-content;width:-webkit-fit-content}.step-gif[data-v-894ad1a6]{border-radius:16px;height:539px;left:0;margin:auto;position:absolute;right:0;top:15px;width:258px}.step-image-1[data-v-894ad1a6]{height:195px;margin-bottom:31px}@media (min-width:1024px){.step-image-1[data-v-894ad1a6]{height:239px;margin-bottom:26px;margin-top:267px}}.step-image-2[data-v-894ad1a6]{height:196px;margin-bottom:31px}@media (min-width:1024px){.step-image-2[data-v-894ad1a6]{height:241px;margin-bottom:26px;margin-top:207px}}.step-image-3[data-v-894ad1a6]{height:194px;margin-bottom:31px}@media (min-width:1024px){.step-image-3[data-v-894ad1a6]{height:243px;margin-bottom:26px;margin-top:207px}}.step-image-4[data-v-894ad1a6]{height:196px;margin-bottom:31px}@media (min-width:1024px){.step-image-4[data-v-894ad1a6]{height:243px;margin-bottom:26px;margin-top:207px}}.step-title[data-v-894ad1a6]{border-bottom:3px solid #b1dc03;font-size:20px;font-weight:900;padding-bottom:12px;text-align:left}@media (min-width:1024px){.step-title[data-v-894ad1a6]{font-size:25px}}.step-text[data-v-894ad1a6]{font-size:16px;font-weight:600;line-height:1;margin-bottom:65px;margin-top:21px;text-align:left}.step-text.no-margin[data-v-894ad1a6]{margin-bottom:20px}@media (min-width:1024px){.step-text[data-v-894ad1a6]{font-size:18px}}.step-list[data-v-894ad1a6]{font-size:16px;font-weight:600;margin-bottom:0;text-align:left}.step-list:last-of-type.margin[data-v-894ad1a6]{margin-bottom:65px}.step-number-secondary[data-v-894ad1a6]{font-size:60px;font-weight:900;line-height:normal}@media (min-width:1024px){.step-number-secondary[data-v-894ad1a6]{font-size:77px;line-height:.8}}.step-number[data-v-894ad1a6]{display:none}@media (min-width:1024px){.step-number[data-v-894ad1a6]{color:rgba(177,220,3,.1);display:initial;font-size:400px;font-weight:900;left:-59%;position:absolute;z-index:1}}.component-desktop[data-v-894ad1a6]{display:none}@media (min-width:1024px){.component-desktop[data-v-894ad1a6]{display:initial}}.steps-container .step-image-container[data-v-894ad1a6]{margin-bottom:107px}@media (min-width:1024px){.steps-container .step-image-container[data-v-894ad1a6]{margin-top:166px}}@media (min-width:1024px){.steps-container:nth-child(3) .step-image-container[data-v-894ad1a6]{margin-top:106px}}@media (min-width:1024px){.steps-container:nth-child(3) .step-number[data-v-894ad1a6]{left:auto;right:-50%}}@media (min-width:1024px){.steps-container:nth-child(4) .step-image-container[data-v-894ad1a6]{margin-top:106px}}.steps-container:nth-child(5) .step-image-container[data-v-894ad1a6]{margin-bottom:0}@media (min-width:1024px){.steps-container:nth-child(5) .step-image-container[data-v-894ad1a6]{margin-bottom:175px;margin-top:106px}}@media (min-width:1024px){.steps-container:nth-child(5) .step-number[data-v-894ad1a6]{left:auto;right:-50%}}@media (min-width:768px){.step-title-container[data-v-894ad1a6]{margin:auto;max-width:60%}}@media (min-width:1024px){.step-title-container[data-v-894ad1a6]{margin:0;max-width:none}}@media (min-width:1024px){.container-step-image[data-v-894ad1a6]{text-align:center}}.text-decoration-none[data-v-894ad1a6]{text-decoration:none}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-how-it-work.vue"],"names":[],"mappings":"AACA,sCACE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,0BACA,sCACM,qBAAsB,AACtB,eAAiB,CACtB,CACA,AACD,0BACA,sCACM,qBAAuB,CAC5B,CACA,AACD,4CACI,aAAe,CAClB,AACD,0BACA,4CACQ,+BAAgC,AAChC,mBAAoB,AACpB,gBAAkB,CACzB,CACA,AACD,+CACM,eAAgB,AAChB,gBAAiB,AACjB,wBAA0B,CAC/B,AACD,+CACM,eAAgB,AAChB,eAAiB,CACtB,AACD,gDACI,eAAgB,AAChB,iBAAkB,AAClB,sBAAuB,AACvB,eAAiB,CACpB,AACD,0BACA,gDACQ,qBAA0B,AAC1B,cAAgB,CACvB,CACA,AACD,0CACI,kBAAmB,AACnB,eAAgB,AAChB,gBAAiB,AACjB,sBAAwB,AACxB,qBAAwB,CAC3B,AACD,uCACE,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,uBAAwB,AACxB,yBAA2B,CAC5B,AACD,2BACE,mBAAoB,AACpB,aAAc,AACd,OAAU,AACV,YAAa,AACb,kBAAmB,AACnB,QAAW,AACX,SAAU,AACV,WAAa,CACd,AACD,+BACE,aAAc,AACd,kBAAoB,CACrB,AACD,0BACA,+BACM,aAAc,AACd,mBAAoB,AACpB,gBAAkB,CACvB,CACA,AACD,+BACE,aAAc,AACd,kBAAoB,CACrB,AACD,0BACA,+BACM,aAAc,AACd,mBAAoB,AACpB,gBAAkB,CACvB,CACA,AACD,+BACE,aAAc,AACd,kBAAoB,CACrB,AACD,0BACA,+BACM,aAAc,AACd,mBAAoB,AACpB,gBAAkB,CACvB,CACA,AACD,+BACE,aAAc,AACd,kBAAoB,CACrB,AACD,0BACA,+BACM,aAAc,AACd,mBAAoB,AACpB,gBAAkB,CACvB,CACA,AACD,6BACE,gCAAiC,AACjC,eAAgB,AAChB,gBAAiB,AACjB,oBAAqB,AACrB,eAAiB,CAClB,AACD,0BACA,6BACM,cAAgB,CACrB,CACA,AACD,4BACE,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,eAAiB,CAClB,AACD,sCACI,kBAAoB,CACvB,AACD,0BACA,4BACM,cAAgB,CACrB,CACA,AACD,4BACE,eAAgB,AAChB,gBAAiB,AACjB,gBAAmB,AACnB,eAAiB,CAClB,AACD,gDACI,kBAAoB,CACvB,AACD,wCACE,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,0BACA,wCACM,eAAgB,AAChB,cAAiB,CACtB,CACA,AACD,8BACE,YAAc,CACf,AACD,0BACA,8BACM,yBAA8B,AAC9B,gBAAiB,AACjB,gBAAiB,AACjB,gBAAiB,AACjB,UAAW,AACX,kBAAmB,AACnB,SAAW,CAChB,CACA,AACD,oCACE,YAAc,CACf,AACD,0BACA,oCACM,eAAiB,CACtB,CACA,AACD,wDACE,mBAAqB,CACtB,AACD,0BACA,wDACM,gBAAkB,CACvB,CACA,AACD,0BACA,qEACI,gBAAkB,CACrB,CACA,AACD,0BACA,4DACI,UAAW,AACX,UAAY,CACf,CACA,AACD,0BACA,qEACI,gBAAkB,CACrB,CACA,AACD,qEACE,eAAmB,CACpB,AACD,0BACA,qEACM,oBAAqB,AACrB,gBAAkB,CACvB,CACA,AACD,0BACA,4DACI,UAAW,AACX,UAAY,CACf,CACA,AACD,yBACA,uCACI,YAAa,AACb,aAAe,CAClB,CACA,AACD,0BACA,uCACI,SAAU,AACV,cAAgB,CACnB,CACA,AACD,0BACA,uCACI,iBAAmB,CACtB,CACA,AACD,uCACE,oBAAsB,CACvB","file":"section-how-it-work.vue","sourcesContent":["\n.section-how-it-work[data-v-894ad1a6] {\n  padding: 49px 2% 81px;\n  text-align: center;\n}\n@media (min-width: 1024px) {\n.section-how-it-work[data-v-894ad1a6] {\n      padding: 66px 8% 74px;\n      text-align: left;\n}\n}\n@media (min-width: 1280px) {\n.section-how-it-work[data-v-894ad1a6] {\n      padding: 66px 10% 74px;\n}\n}\n.section-how-it-work-title[data-v-894ad1a6] {\n    line-height: 1;\n}\n@media (min-width: 1024px) {\n.section-how-it-work-title[data-v-894ad1a6] {\n        border-right: 2px solid #085f65;\n        padding-right: 28px;\n        text-align: right;\n}\n}\n.section-how-it-work-title h3[data-v-894ad1a6] {\n      font-size: 30px;\n      font-weight: 900;\n      text-transform: uppercase;\n}\n.section-how-it-work-title h2[data-v-894ad1a6] {\n      font-size: 47px;\n      font-weight: 900;\n}\n.section-how-it-work-subtext p[data-v-894ad1a6] {\n    font-size: 18px;\n    line-height: 23px;\n    margin: 47px auto 72px;\n    max-width: 287px;\n}\n@media (min-width: 1024px) {\n.section-how-it-work-subtext p[data-v-894ad1a6] {\n        margin: 15px 0px 0px 38px;\n        max-width: none;\n}\n}\n.section-how-it-work-btn[data-v-894ad1a6] {\n    border-radius: 8px;\n    font-size: 20px;\n    font-weight: 600;\n    height: 60px !important;\n    width: 271px !important;\n}\n.step-image-container[data-v-894ad1a6] {\n  margin: auto;\n  position: relative;\n  width: fit-content;\n  width: -moz-fit-content;\n  width: -webkit-fit-content;\n}\n.step-gif[data-v-894ad1a6] {\n  border-radius: 16px;\n  height: 539px;\n  left: 0px;\n  margin: auto;\n  position: absolute;\n  right: 0px;\n  top: 15px;\n  width: 258px;\n}\n.step-image-1[data-v-894ad1a6] {\n  height: 195px;\n  margin-bottom: 31px;\n}\n@media (min-width: 1024px) {\n.step-image-1[data-v-894ad1a6] {\n      height: 239px;\n      margin-bottom: 26px;\n      margin-top: 267px;\n}\n}\n.step-image-2[data-v-894ad1a6] {\n  height: 196px;\n  margin-bottom: 31px;\n}\n@media (min-width: 1024px) {\n.step-image-2[data-v-894ad1a6] {\n      height: 241px;\n      margin-bottom: 26px;\n      margin-top: 207px;\n}\n}\n.step-image-3[data-v-894ad1a6] {\n  height: 194px;\n  margin-bottom: 31px;\n}\n@media (min-width: 1024px) {\n.step-image-3[data-v-894ad1a6] {\n      height: 243px;\n      margin-bottom: 26px;\n      margin-top: 207px;\n}\n}\n.step-image-4[data-v-894ad1a6] {\n  height: 196px;\n  margin-bottom: 31px;\n}\n@media (min-width: 1024px) {\n.step-image-4[data-v-894ad1a6] {\n      height: 243px;\n      margin-bottom: 26px;\n      margin-top: 207px;\n}\n}\n.step-title[data-v-894ad1a6] {\n  border-bottom: 3px solid #b1dc03;\n  font-size: 20px;\n  font-weight: 900;\n  padding-bottom: 12px;\n  text-align: left;\n}\n@media (min-width: 1024px) {\n.step-title[data-v-894ad1a6] {\n      font-size: 25px;\n}\n}\n.step-text[data-v-894ad1a6] {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1;\n  margin-bottom: 65px;\n  margin-top: 21px;\n  text-align: left;\n}\n.step-text.no-margin[data-v-894ad1a6] {\n    margin-bottom: 20px;\n}\n@media (min-width: 1024px) {\n.step-text[data-v-894ad1a6] {\n      font-size: 18px;\n}\n}\n.step-list[data-v-894ad1a6] {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 0px;\n  text-align: left;\n}\n.step-list:last-of-type.margin[data-v-894ad1a6] {\n    margin-bottom: 65px;\n}\n.step-number-secondary[data-v-894ad1a6] {\n  font-size: 60px;\n  font-weight: 900;\n  line-height: normal;\n}\n@media (min-width: 1024px) {\n.step-number-secondary[data-v-894ad1a6] {\n      font-size: 77px;\n      line-height: 0.8;\n}\n}\n.step-number[data-v-894ad1a6] {\n  display: none;\n}\n@media (min-width: 1024px) {\n.step-number[data-v-894ad1a6] {\n      color: rgba(177, 220, 3, 0.1);\n      display: initial;\n      font-size: 400px;\n      font-weight: 900;\n      left: -59%;\n      position: absolute;\n      z-index: 1;\n}\n}\n.component-desktop[data-v-894ad1a6] {\n  display: none;\n}\n@media (min-width: 1024px) {\n.component-desktop[data-v-894ad1a6] {\n      display: initial;\n}\n}\n.steps-container .step-image-container[data-v-894ad1a6] {\n  margin-bottom: 107px;\n}\n@media (min-width: 1024px) {\n.steps-container .step-image-container[data-v-894ad1a6] {\n      margin-top: 166px;\n}\n}\n@media (min-width: 1024px) {\n.steps-container:nth-child(3) .step-image-container[data-v-894ad1a6] {\n    margin-top: 106px;\n}\n}\n@media (min-width: 1024px) {\n.steps-container:nth-child(3) .step-number[data-v-894ad1a6] {\n    left: auto;\n    right: -50%;\n}\n}\n@media (min-width: 1024px) {\n.steps-container:nth-child(4) .step-image-container[data-v-894ad1a6] {\n    margin-top: 106px;\n}\n}\n.steps-container:nth-child(5) .step-image-container[data-v-894ad1a6] {\n  margin-bottom: 0px;\n}\n@media (min-width: 1024px) {\n.steps-container:nth-child(5) .step-image-container[data-v-894ad1a6] {\n      margin-bottom: 175px;\n      margin-top: 106px;\n}\n}\n@media (min-width: 1024px) {\n.steps-container:nth-child(5) .step-number[data-v-894ad1a6] {\n    left: auto;\n    right: -50%;\n}\n}\n@media (min-width: 768px) {\n.step-title-container[data-v-894ad1a6] {\n    margin: auto;\n    max-width: 60%;\n}\n}\n@media (min-width: 1024px) {\n.step-title-container[data-v-894ad1a6] {\n    margin: 0;\n    max-width: none;\n}\n}\n@media (min-width: 1024px) {\n.container-step-image[data-v-894ad1a6] {\n    text-align: center;\n}\n}\n.text-decoration-none[data-v-894ad1a6] {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-how-it-work",attrs:{"row":"","wrap":"","white":"","id":"stepbystep"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-how-it-work-title",attrs:{"xs12":"","md6":"","secondary--text":""}},[_c('h3',[_vm._v("¿Cómo funciona")]),_vm._v(" "),_c('h2',[_vm._v("CASAMARKET?")])]),_vm._v(" "),_c('v-flex',{staticClass:"section-how-it-work-subtext",attrs:{"xs12":"","md6":"","info--text":""}},[_c('p',[_vm._v("\n\t\t\t\t\tAmigo bodeguero, te queremos mostrar lo sencillo que es usar CasaMarket;\n\t\t\t\t\tprepárate para añadir a tu negocio una potente herramienta de tecnología:\n\t\t\t\t")])])],1),_vm._v(" "),_vm._l((_vm.steps),function(step){return _c('v-layout',{key:step.id,staticClass:"steps-container",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"container-step-image",class:{ 'order-md6': step.position },attrs:{"xs12":"","md6":""}},[_c('img',{class:step.class,attrs:{"src":step.image}}),_vm._v(" "),_c('v-layout',{staticClass:"step-title-container",attrs:{"row":"","wrap":"","primary--text":""}},[_c('v-flex',{staticClass:"step-number-secondary",attrs:{"xs2":""}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(step.number)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('h3',{staticClass:"step-title"},[_vm._v(_vm._s(step.title))]),_vm._v(" "),(step.text)?[_c('p',{staticClass:"step-text info--text",class:{ 'no-margin': step.list }},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(step.text)+"\n\t\t\t\t\t\t\t")])]:_vm._e(),_vm._v(" "),(step.list)?[_vm._l((step.list),function(item,index){return [_c('p',{key:index,staticClass:"step-list info--text",class:{ 'margin': step.list }},[_vm._v("\n\t\t\t\t\t\t\t\t\t- "+_vm._s(item)+"\n\t\t\t\t\t\t\t\t")])]})]:_vm._e()],2)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('div',{staticClass:"step-image-container"},[_c('div',{staticClass:"step-number"},[_vm._v(_vm._s(step.number))]),_vm._v(" "),_c('img',{staticClass:"step-gif",attrs:{"src":step.gif,"alt":"tu cliente realiza el pedido","height":"588"}}),_vm._v(" "),_c('img',{staticClass:"step-image-cel",attrs:{"src":"/static/images/sections/step-cel.png","alt":"tu cliente realiza el pedido","height":"592"}})])])],1)}),_vm._v(" "),_c('v-layout',{staticClass:"component-desktop",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('a',{staticClass:"text-decoration-none",attrs:{"href":_vm.landingLink,"target":"_blank"}},[_c('v-btn',{staticClass:"btn-action btn-auto section-how-it-work-btn white--text",attrs:{"color":"primary","depressed":""}},[_vm._v("\n\t\t\t\t\t\tSOLICITA TU APP\n\t\t\t\t\t")])],1)])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_how_to_use_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a85f640_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_how_to_use_vue__ = __webpack_require__(466);
function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a85f640"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_how_to_use_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a85f640_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_how_to_use_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(465);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("036a2ada", content, true, {});

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, "@media (min-width:1400px){.section-use[data-v-3a85f640]{padding:0 10%}}.section-use-title[data-v-3a85f640]{font-size:30px;font-weight:900;line-height:1;padding:50px 6% 22px}@media (min-width:360px){.section-use-title[data-v-3a85f640]{padding:50px 13% 22px}}@media (min-width:1024px){.section-use-title[data-v-3a85f640]{padding:50px 0 24px}}.section-use-caption[data-v-3a85f640]{font-size:18px}.section-use-btn[data-v-3a85f640]{background-color:transparent!important;background-image:url(\"/static/images/icons/rectangle-CM.svg\");background-position:50%;background-repeat:no-repeat;background-size:auto;font-size:16px;font-weight:600;height:46px!important;margin-top:23px;width:135px!important}@media (min-width:1024px){.section-use-btn[data-v-3a85f640]{background-size:cover;height:37px!important;margin-top:0}}.section-use-btn.active[data-v-3a85f640]{background-image:url(\"/static/images/icons/rectangle-active-CM.svg\");font-weight:900}.section-use-card[data-v-3a85f640]{background-image:url(\"/static/images/banners/background-content.svg\");background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:18px;box-shadow:0 2px 20px 0 rgba(0,0,0,.5);margin-top:22px;padding-bottom:282px}@media (min-width:1024px){.section-use-card[data-v-3a85f640]{height:389px;padding-bottom:0}}.btn-container[data-v-3a85f640]{padding:0 9%}@media (min-width:360px){.btn-container[data-v-3a85f640]{padding:0 7%}}@media (min-width:1024px){.btn-container[data-v-3a85f640]{margin-top:55px;padding:0 3%}}@media (min-width:1280px){.btn-container[data-v-3a85f640]{padding:0 8%}}@media (min-width:1400px){.btn-container[data-v-3a85f640]{padding:0 0 0 11%}}.card-container[data-v-3a85f640]{padding:13px 2% 378px}@media (min-width:360px){.card-container[data-v-3a85f640]{padding:13px 5% 345px}}@media (min-width:768px){.card-container[data-v-3a85f640]{padding:13px 8% 345px}}@media (min-width:1024px){.card-container[data-v-3a85f640]{padding:13px 8% 150px}}@media (min-width:1280px){.card-container[data-v-3a85f640]{padding:13px 10% 150px}}.image-absolute[data-v-3a85f640]{left:0;margin:auto;position:absolute;right:0}@media (min-width:1024px){.image-absolute[data-v-3a85f640]{bottom:0;top:0}}.position-relative[data-v-3a85f640]{position:relative}.active-title[data-v-3a85f640]{font-size:25px;font-weight:900;padding:62px 0 33px;text-align:center;text-transform:uppercase}@media (min-width:1024px){.active-title[data-v-3a85f640]{padding:0 10% 24px;text-align:left}}.active-paragraph[data-v-3a85f640]{font-size:16px;line-height:1.4;padding:0 5% 15px;text-align:center}@media (min-width:360px){.active-paragraph[data-v-3a85f640]{padding:0 8% 15px}}@media (min-width:1024px){.active-paragraph[data-v-3a85f640]{padding:0 10% 10px;text-align:left}}.active-item[data-v-3a85f640]{font-size:16px;margin:0 auto 10px;max-width:55%}@media (min-width:1024px){.active-item[data-v-3a85f640]{margin:0;max-width:none;padding:0 10% 10px}}.image-check[data-v-3a85f640]{margin-right:10px}.active-span[data-v-3a85f640]{font-size:18px;font-weight:800}@media (min-width:1024px){.active-span[data-v-3a85f640]{font-size:26px;font-weight:900}}.active-text[data-v-3a85f640]{font-size:18px;font-weight:800;text-align:center;padding:0 6% 15px}@media (min-width:360px){.active-text[data-v-3a85f640]{padding:0 10% 15px}}@media (min-width:1024px){.active-text[data-v-3a85f640]{font-weight:900;text-align:left}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-how-to-use.vue"],"names":[],"mappings":"AACA,0BACA,8BACI,aAAiB,CACpB,CACA,AACD,oCACE,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,oBAAsB,CACvB,AACD,yBACA,oCACM,qBAAuB,CAC5B,CACA,AACD,0BACA,oCACM,mBAAqB,CAC1B,CACA,AACD,sCACE,cAAgB,CACjB,AACD,kCACE,uCAAyC,AACzC,8DAA+D,AAC/D,wBAA4B,AAC5B,4BAA6B,AAC7B,qBAAsB,AACtB,eAAgB,AAChB,gBAAiB,AACjB,sBAAwB,AACxB,gBAAiB,AACjB,qBAAwB,CACzB,AACD,0BACA,kCACM,sBAAuB,AACvB,sBAAwB,AACxB,YAAgB,CACrB,CACA,AACD,yCACI,qEAAsE,AACtE,eAAiB,CACpB,AACD,mCACE,sEAAuE,AACvE,wBAA4B,AAC5B,4BAA6B,AAC7B,sBAAuB,AACvB,mBAAoB,AACpB,uCAA4C,AAC5C,gBAAiB,AACjB,oBAAsB,CACvB,AACD,0BACA,mCACM,aAAc,AACd,gBAAoB,CACzB,CACA,AACD,gCACE,YAAgB,CACjB,AACD,yBACA,gCACM,YAAgB,CACrB,CACA,AACD,0BACA,gCACM,gBAAiB,AACjB,YAAgB,CACrB,CACA,AACD,0BACA,gCACM,YAAgB,CACrB,CACA,AACD,0BACA,gCACM,iBAAyB,CAC9B,CACA,AACD,iCACE,qBAAuB,CACxB,AACD,yBACA,iCACM,qBAAuB,CAC5B,CACA,AACD,yBACA,iCACM,qBAAuB,CAC5B,CACA,AACD,0BACA,iCACM,qBAAuB,CAC5B,CACA,AACD,0BACA,iCACM,sBAAwB,CAC7B,CACA,AACD,iCACE,OAAQ,AACR,YAAa,AACb,kBAAmB,AACnB,OAAS,CACV,AACD,0BACA,iCACM,SAAU,AACV,KAAO,CACZ,CACA,AACD,oCACE,iBAAmB,CACpB,AACD,+BACE,eAAgB,AAChB,gBAAiB,AACjB,oBAAuB,AACvB,kBAAmB,AACnB,wBAA0B,CAC3B,AACD,0BACA,+BACM,mBAAsB,AACtB,eAAiB,CACtB,CACA,AACD,mCACE,eAAgB,AAChB,gBAAiB,AACjB,kBAAqB,AACrB,iBAAmB,CACpB,AACD,yBACA,mCACM,iBAAqB,CAC1B,CACA,AACD,0BACA,mCACM,mBAAsB,AACtB,eAAiB,CACtB,CACA,AACD,8BACE,eAAgB,AAChB,mBAAsB,AACtB,aAAe,CAChB,AACD,0BACA,8BACM,SAAY,AACZ,eAAgB,AAChB,kBAAsB,CAC3B,CACA,AACD,8BACE,iBAAmB,CACpB,AACD,8BACE,eAAgB,AAChB,eAAiB,CAClB,AACD,0BACA,8BACM,eAAgB,AAChB,eAAiB,CACtB,CACA,AACD,8BACE,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,iBAAqB,CACtB,AACD,yBACA,8BACM,kBAAsB,CAC3B,CACA,AACD,0BACA,8BACM,gBAAiB,AACjB,eAAiB,CACtB,CACA","file":"section-how-to-use.vue","sourcesContent":["\n@media (min-width: 1400px) {\n.section-use[data-v-3a85f640] {\n    padding: 0px 10%;\n}\n}\n.section-use-title[data-v-3a85f640] {\n  font-size: 30px;\n  font-weight: 900;\n  line-height: 1;\n  padding: 50px 6% 22px;\n}\n@media (min-width: 360px) {\n.section-use-title[data-v-3a85f640] {\n      padding: 50px 13% 22px;\n}\n}\n@media (min-width: 1024px) {\n.section-use-title[data-v-3a85f640] {\n      padding: 50px 0 24px;\n}\n}\n.section-use-caption[data-v-3a85f640] {\n  font-size: 18px;\n}\n.section-use-btn[data-v-3a85f640] {\n  background-color: transparent !important;\n  background-image: url(\"/static/images/icons/rectangle-CM.svg\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: auto;\n  font-size: 16px;\n  font-weight: 600;\n  height: 46px !important;\n  margin-top: 23px;\n  width: 135px !important;\n}\n@media (min-width: 1024px) {\n.section-use-btn[data-v-3a85f640] {\n      background-size: cover;\n      height: 37px !important;\n      margin-top: 0px;\n}\n}\n.section-use-btn.active[data-v-3a85f640] {\n    background-image: url(\"/static/images/icons/rectangle-active-CM.svg\");\n    font-weight: 900;\n}\n.section-use-card[data-v-3a85f640] {\n  background-image: url(\"/static/images/banners/background-content.svg\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-radius: 18px;\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.5);\n  margin-top: 22px;\n  padding-bottom: 282px;\n}\n@media (min-width: 1024px) {\n.section-use-card[data-v-3a85f640] {\n      height: 389px;\n      padding-bottom: 0px;\n}\n}\n.btn-container[data-v-3a85f640] {\n  padding: 0px 9%;\n}\n@media (min-width: 360px) {\n.btn-container[data-v-3a85f640] {\n      padding: 0px 7%;\n}\n}\n@media (min-width: 1024px) {\n.btn-container[data-v-3a85f640] {\n      margin-top: 55px;\n      padding: 0px 3%;\n}\n}\n@media (min-width: 1280px) {\n.btn-container[data-v-3a85f640] {\n      padding: 0px 8%;\n}\n}\n@media (min-width: 1400px) {\n.btn-container[data-v-3a85f640] {\n      padding: 0px 0px 0px 11%;\n}\n}\n.card-container[data-v-3a85f640] {\n  padding: 13px 2% 378px;\n}\n@media (min-width: 360px) {\n.card-container[data-v-3a85f640] {\n      padding: 13px 5% 345px;\n}\n}\n@media (min-width: 768px) {\n.card-container[data-v-3a85f640] {\n      padding: 13px 8% 345px;\n}\n}\n@media (min-width: 1024px) {\n.card-container[data-v-3a85f640] {\n      padding: 13px 8% 150px;\n}\n}\n@media (min-width: 1280px) {\n.card-container[data-v-3a85f640] {\n      padding: 13px 10% 150px;\n}\n}\n.image-absolute[data-v-3a85f640] {\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n}\n@media (min-width: 1024px) {\n.image-absolute[data-v-3a85f640] {\n      bottom: 0;\n      top: 0;\n}\n}\n.position-relative[data-v-3a85f640] {\n  position: relative;\n}\n.active-title[data-v-3a85f640] {\n  font-size: 25px;\n  font-weight: 900;\n  padding: 62px 0px 33px;\n  text-align: center;\n  text-transform: uppercase;\n}\n@media (min-width: 1024px) {\n.active-title[data-v-3a85f640] {\n      padding: 0px 10% 24px;\n      text-align: left;\n}\n}\n.active-paragraph[data-v-3a85f640] {\n  font-size: 16px;\n  line-height: 1.4;\n  padding: 0px 5% 15px;\n  text-align: center;\n}\n@media (min-width: 360px) {\n.active-paragraph[data-v-3a85f640] {\n      padding: 0px 8% 15px;\n}\n}\n@media (min-width: 1024px) {\n.active-paragraph[data-v-3a85f640] {\n      padding: 0px 10% 10px;\n      text-align: left;\n}\n}\n.active-item[data-v-3a85f640] {\n  font-size: 16px;\n  margin: 0px auto 10px;\n  max-width: 55%;\n}\n@media (min-width: 1024px) {\n.active-item[data-v-3a85f640] {\n      margin: 0px;\n      max-width: none;\n      padding: 0px 10% 10px;\n}\n}\n.image-check[data-v-3a85f640] {\n  margin-right: 10px;\n}\n.active-span[data-v-3a85f640] {\n  font-size: 18px;\n  font-weight: 800;\n}\n@media (min-width: 1024px) {\n.active-span[data-v-3a85f640] {\n      font-size: 26px;\n      font-weight: 900;\n}\n}\n.active-text[data-v-3a85f640] {\n  font-size: 18px;\n  font-weight: 800;\n  text-align: center;\n  padding: 0px 6% 15px;\n}\n@media (min-width: 360px) {\n.active-text[data-v-3a85f640] {\n      padding: 0px 10% 15px;\n}\n}\n@media (min-width: 1024px) {\n.active-text[data-v-3a85f640] {\n      font-weight: 900;\n      text-align: left;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-use",attrs:{"row":"","wrap":"","primary":"","white--text":"","id":"sectionuse"}},[_c('v-flex',{staticClass:"container",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('h2',{staticClass:"section-use-title"},[_vm._v("¿CÓMO EMPEZAR A USAR MI APLICATIVO CASAMARKET?")]),_vm._v(" "),_c('p',{staticClass:"section-use-caption"},[_vm._v("Muy sencillo de usar")])]),_vm._v(" "),_c('v-flex',{staticClass:"btn-container",attrs:{"xs12":"","md7":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs6":"","sm3":""}},[_c('v-btn',{staticClass:"btn-action btn-auto section-use-btn active white--text",attrs:{"depressed":""},on:{"click":_vm.restoreAll}},[_vm._v("\n\t\t\t\t\t\t\tRegístrate\n\t\t\t\t\t\t")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":""}},[_c('v-btn',{staticClass:"btn-action btn-auto section-use-btn",class:_vm.customActive ? 'active white--text' : 'primary--text',attrs:{"depressed":""},on:{"click":function($event){_vm.activeStep('customActive')}}},[_vm._v("\n\t\t\t\t\t\t\tPersonaliza\n\t\t\t\t\t\t")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":""}},[_c('v-btn',{staticClass:"btn-action btn-auto section-use-btn",class:_vm.shareActive ? 'active white--text' : 'primary--text',attrs:{"depressed":""},on:{"click":function($event){_vm.activeStep('shareActive')}}},[_vm._v("\n\t\t\t\t\t\t\tComparte\n\t\t\t\t\t\t")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":""}},[_c('v-btn',{staticClass:"btn-action btn-auto section-use-btn",class:_vm.sellActive ? 'active white--text' : 'primary--text',attrs:{"depressed":""},on:{"click":function($event){_vm.activeStep('sellActive')}}},[_vm._v("\n\t\t\t\t\t\t\tVende\n\t\t\t\t\t\t")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"card-container",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"section-use-card",attrs:{"row":"","wrap":"","align-center":"","white":""}},[_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('h3',{staticClass:"active-title primary--text"},[_vm._v(_vm._s(_vm.active.title))]),_vm._v(" "),(_vm.active.paragraphs)?[_vm._l((_vm.active.paragraphs),function(paragraph){return [_c('p',{key:paragraph.id,staticClass:"active-paragraph info--text",domProps:{"innerHTML":_vm._s(paragraph.text)}}),_vm._v(" "),(paragraph.list)?[_vm._l((paragraph.list),function(item,index){return [_c('p',{key:index,staticClass:"active-item info--text"},[_c('img',{staticClass:"image-check",attrs:{"src":"/static/images/icons/icon-check-CM.svg","alt":"viñeta para text","height":"20"}}),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(item)+"\n\t\t\t\t\t\t\t\t\t\t")])]})]:_vm._e()]})]:_vm._e(),_vm._v(" "),(_vm.active.span && _vm.active.text)?[_c('p',{staticClass:"active-text info--text"},[_c('span',{staticClass:"active-span secondary--text"},[_vm._v(_vm._s(_vm.active.span))]),_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.active.text)+"\n\t\t\t\t\t\t\t")])]:_vm._e()],2),_vm._v(" "),_c('v-flex',{staticClass:"position-relative",attrs:{"xs12":"","md5":"","text-xs-center":""}},[_c('img',{class:((_vm.active.class) + " image-absolute"),attrs:{"src":_vm.active.image,"alt":_vm.active.title,"height":"592"}})])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_slider_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84d89f66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_slider_vue__ = __webpack_require__(470);
function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84d89f66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(469);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("8fc364fe", content, true, {});

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-slider{padding:36px 1% 48px}@media (min-width:1024px){.section-slider{padding:0 0 121px}}.section-slider-title{font-size:30px;font-weight:900;padding:103px 0 71px;text-align:center}.section-slider-slide{border-radius:19px;box-shadow:0 0 15px 0 rgba(0,0,0,.06);height:100%}.section-slider-slide-title{font-size:30px;font-weight:900;line-height:1;text-align:center}@media (min-width:1024px){.section-slider-slide-title{font-size:38px;text-align:left}}.section-slider-slide-title:not(.section-slider-slide-title-big){padding:48px 0 0}@media (min-width:1024px){.section-slider-slide-title:not(.section-slider-slide-title-big){padding:56px 0 0}}.section-slider-slide-title-big{font-size:32px;padding:0 0 28px}@media (min-width:1024px){.section-slider-slide-title-big{font-size:44px;padding:0 0 30px}}.section-slider-slide-action{border:1px solid #ff6e1c;border-radius:10px;line-height:1;margin:0 auto 12px;max-height:88px;max-width:320px;min-height:56px;padding:4px 0 4px 3%;width:90%}.section-slider-slide-action:last-of-type{margin:0 auto}@media (min-width:1024px){.section-slider-slide-action:last-of-type{margin:0 0 12px;max-height:66px}}@media (min-width:1024px){.section-slider-slide-action{margin:0 0 23px;max-height:66px}}.section-slider-slide-1{height:224px}@media (min-width:1024px){.section-slider-slide-1{height:242px;margin-top:190px}}@media (min-width:1400px){.section-slider-slide-1{height:371px;margin-top:106px}}.section-slider-slide-2{height:352px;margin-top:0}@media (min-width:1024px){.section-slider-slide-2{height:452px;margin-top:106px}}.section-slider-slide-3{height:352px;margin-top:0}@media (min-width:1024px){.section-slider-slide-3{height:452px;margin-top:106px}}.section-slider-slide-left{height:45%}@media (min-width:1024px){.section-slider-slide-left{height:100%;padding-left:10%}}.section-slider-slide-right{text-align:center}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-slider.vue"],"names":[],"mappings":"AACA,gBACE,oBAAsB,CACvB,AACD,0BACA,gBACM,iBAAuB,CAC5B,CACA,AACD,sBACE,eAAgB,AAChB,gBAAiB,AACjB,qBAAwB,AACxB,iBAAmB,CACpB,AACD,sBACE,mBAAoB,AACpB,sCAA2C,AAC3C,WAAa,CACd,AACD,4BACI,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,iBAAmB,CACtB,AACD,0BACA,4BACQ,eAAgB,AAChB,eAAiB,CACxB,CACA,AACD,iEACM,gBAAsB,CAC3B,AACD,0BACA,iEACU,gBAAsB,CAC/B,CACA,AACD,gCACM,eAAgB,AAChB,gBAAsB,CAC3B,AACD,0BACA,gCACU,eAAgB,AAChB,gBAAsB,CAC/B,CACA,AACD,6BACI,yBAA0B,AAC1B,mBAAoB,AACpB,cAAe,AACf,mBAAsB,AACtB,gBAAiB,AACjB,gBAAiB,AACjB,gBAAiB,AACjB,qBAAwB,AACxB,SAAW,CACd,AACD,0CACM,aAAqB,CAC1B,AACD,0BACA,0CACU,gBAAqB,AACrB,eAAiB,CAC1B,CACA,AACD,0BACA,6BACQ,gBAAqB,AACrB,eAAiB,CACxB,CACA,AACD,wBACI,YAAc,CACjB,AACD,0BACA,wBACQ,aAAc,AACd,gBAAkB,CACzB,CACA,AACD,0BACA,wBACQ,aAAc,AACd,gBAAkB,CACzB,CACA,AACD,wBACI,aAAc,AACd,YAAgB,CACnB,AACD,0BACA,wBACQ,aAAc,AACd,gBAAkB,CACzB,CACA,AACD,wBACI,aAAc,AACd,YAAgB,CACnB,AACD,0BACA,wBACQ,aAAc,AACd,gBAAkB,CACzB,CACA,AACD,2BACI,UAAY,CACf,AACD,0BACA,2BACQ,YAAa,AACb,gBAAkB,CACzB,CACA,AACD,4BACI,iBAAmB,CACtB","file":"section-slider.vue","sourcesContent":["\n.section-slider {\n  padding: 36px 1% 48px;\n}\n@media (min-width: 1024px) {\n.section-slider {\n      padding: 0px 0px 121px;\n}\n}\n.section-slider-title {\n  font-size: 30px;\n  font-weight: 900;\n  padding: 103px 0px 71px;\n  text-align: center;\n}\n.section-slider-slide {\n  border-radius: 19px;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.06);\n  height: 100%;\n}\n.section-slider-slide-title {\n    font-size: 30px;\n    font-weight: 900;\n    line-height: 1;\n    text-align: center;\n}\n@media (min-width: 1024px) {\n.section-slider-slide-title {\n        font-size: 38px;\n        text-align: left;\n}\n}\n.section-slider-slide-title:not(.section-slider-slide-title-big) {\n      padding: 48px 0px 0px;\n}\n@media (min-width: 1024px) {\n.section-slider-slide-title:not(.section-slider-slide-title-big) {\n          padding: 56px 0px 0px;\n}\n}\n.section-slider-slide-title-big {\n      font-size: 32px;\n      padding: 0px 0px 28px;\n}\n@media (min-width: 1024px) {\n.section-slider-slide-title-big {\n          font-size: 44px;\n          padding: 0px 0px 30px;\n}\n}\n.section-slider-slide-action {\n    border: 1px solid #ff6e1c;\n    border-radius: 10px;\n    line-height: 1;\n    margin: 0px auto 12px;\n    max-height: 88px;\n    max-width: 320px;\n    min-height: 56px;\n    padding: 4px 0px 4px 3%;\n    width: 90%;\n}\n.section-slider-slide-action:last-of-type {\n      margin: 0px auto 0px;\n}\n@media (min-width: 1024px) {\n.section-slider-slide-action:last-of-type {\n          margin: 0px 0px 12px;\n          max-height: 66px;\n}\n}\n@media (min-width: 1024px) {\n.section-slider-slide-action {\n        margin: 0px 0px 23px;\n        max-height: 66px;\n}\n}\n.section-slider-slide-1 {\n    height: 224px;\n}\n@media (min-width: 1024px) {\n.section-slider-slide-1 {\n        height: 242px;\n        margin-top: 190px;\n}\n}\n@media (min-width: 1400px) {\n.section-slider-slide-1 {\n        height: 371px;\n        margin-top: 106px;\n}\n}\n.section-slider-slide-2 {\n    height: 352px;\n    margin-top: 0px;\n}\n@media (min-width: 1024px) {\n.section-slider-slide-2 {\n        height: 452px;\n        margin-top: 106px;\n}\n}\n.section-slider-slide-3 {\n    height: 352px;\n    margin-top: 0px;\n}\n@media (min-width: 1024px) {\n.section-slider-slide-3 {\n        height: 452px;\n        margin-top: 106px;\n}\n}\n.section-slider-slide-left {\n    height: 45%;\n}\n@media (min-width: 1024px) {\n.section-slider-slide-left {\n        height: 100%;\n        padding-left: 10%;\n}\n}\n.section-slider-slide-right {\n    text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-slider",attrs:{"row":"","wrap":"","background":"","id":"sectionslider"}},[_c('v-flex',{attrs:{"xs12":"","hidden-sm-and-down":""}},[_c('h2',{staticClass:"section-slider-title secondary--text"},[_vm._v("TU APLICATIVO CASAMARKET INCLUYE 3 MÓDULOS")])]),_vm._v(" "),_c('v-flex',{staticClass:"container",attrs:{"xs12":""}},[_c('slider',{staticClass:"section-slider-slides",attrs:{"animation":"fade","speed":2000,"interval":6000,"stop-on-hover":true,"touch":false,"height":"100%"}},_vm._l((_vm.slides),function(slide){return _c('slider-item',{key:slide.id},[_c('v-layout',{staticClass:"section-slider-slide",attrs:{"row":"","wrap":"","white":""}},[_c('v-flex',{staticClass:"section-slider-slide-left",attrs:{"xs12":"","md6":"","secondary--text":""}},[_c('h3',{staticClass:"section-slider-slide-title"},[_vm._v(_vm._s(slide.title))]),_vm._v(" "),_c('h1',{staticClass:"section-slider-slide-title section-slider-slide-title-big"},[_vm._v("CASAMARKET APP")]),_vm._v(" "),_vm._l((slide.actions),function(action){return _c('v-layout',{key:action.id,staticClass:"section-slider-slide-action",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('img',{attrs:{"src":"/static/images/icons/icon-check-CM.svg","alt":"viñeta para texto","height":"20"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(action.text)+"\n\t\t\t\t\t\t\t")])],1)})],2),_vm._v(" "),_c('v-flex',{staticClass:"section-slider-slide-right",attrs:{"xs12":"","md6":""}},[_c('img',{class:slide.class,attrs:{"src":slide.image,"alt":slide.alt}})])],1)],1)}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_how_it_work_slider_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79071494_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_how_it_work_slider_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_how_it_work_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79071494_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_how_it_work_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("1e7d4f52", content, true, {});

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-how-it-work-slider{padding:90px 13%;font-size:16px;text-align:center}.section-how-it-work-slider-title{line-height:1}@media (min-width:1024px){.section-how-it-work-slider-title{border-right:2px solid #085f65;padding-right:28px;text-align:right}}.section-how-it-work-slider-title h3{font-size:30px;font-weight:900;text-transform:uppercase}@media (max-width:1024px){.section-how-it-work-slider-title h3{font-size:25px}}.section-how-it-work-slider-title h2{font-size:47px;font-weight:900}@media (max-width:1024px){.section-how-it-work-slider-title h2{font-size:30px}}.section-how-it-work-slider-subtext p{font-size:18px;line-height:23px;margin:47px auto 72px;max-width:287px}@media (min-width:1024px){.section-how-it-work-slider-subtext p{margin:15px 0 0 38px;max-width:none;text-align:left}}.section-how-it-work-slider-steps{margin:80px auto;position:relative;width:70%}@media (max-width:1024px){.section-how-it-work-slider-steps{display:none}}.section-how-it-work-slider-line{border:1px solid #02979b;left:7%;position:absolute;top:50%;width:86%}.section-how-it-work-slider-btn{border-radius:8px;font-size:18px;font-weight:600;height:48px!important;width:206px!important}.section-how-it-work-slider .container-step{align-items:center;background-color:#fff;border:1px solid #02979b;border-radius:50%;color:#02979b;display:flex;font-size:37px;font-weight:600;justify-content:center;height:98px;position:relative;margin:0 auto;width:98px;z-index:1}.section-how-it-work-slider .container-step.select{border-color:#ff6e1c;background:#ff6e1c;color:#fff}.section-how-it-work-slider .container-sliders{height:510px;min-height:510px}@media (max-width:1024px){.section-how-it-work-slider .container-sliders{height:800px}}.section-how-it-work-slider .slider-image-container{padding:0 10%;position:relative}@media (max-width:1024px){.section-how-it-work-slider .slider-image-container{padding:0}}.section-how-it-work-slider .slider-number{color:rgba(255,110,28,.1);display:initial;font-size:400px;font-weight:900;left:12%;line-height:1.3;position:absolute;z-index:1}@media (max-width:1024px){.section-how-it-work-slider .slider-number{display:none}}.section-how-it-work-slider .container-phones{margin-left:auto;position:relative;width:284px}@media (max-width:1024px){.section-how-it-work-slider .container-phones{margin:auto}}.section-how-it-work-slider .step-image-cel{height:510px;width:243px}.section-how-it-work-slider .step-image-gif{border-radius:20px;left:31px;position:absolute;top:12px}.section-how-it-work-slider .slider-indicators-center{display:none}.section-how-it-work-slider .slider-btn{background:#02979b!important;border-radius:50%;height:58px!important;top:50%!important;width:58px!important}@media (max-width:1024px){.section-how-it-work-slider .slider-btn{top:auto!important}}@media (max-width:1024px){.section-how-it-work-slider .slider-btn.slider-btn-right{right:10px!important}}@media (max-width:1024px){.section-how-it-work-slider .slider-btn.slider-btn-left{left:10px!important}}.section-how-it-work-slider .slider-icon{border-left:4px solid #fff!important;border-bottom:4px solid #fff!important}.section-how-it-work-slider .step-number{color:#02979b;font-size:77px;font-weight:600;line-height:.8}@media (max-width:1024px){.section-how-it-work-slider .step-number{font-size:60px}}.section-how-it-work-slider .container-text{padding:0 25px;text-align:left}@media (max-width:1024px){.section-how-it-work-slider .container-text{padding:0 0 0 10px;width:100%}}.section-how-it-work-slider .container-information{padding:0 80px 0 10px}@media (max-width:1024px){.section-how-it-work-slider .container-information{padding:0 0 0 10px}}.section-how-it-work-slider .slider-title{border-bottom:3px solid #ff6e1c;color:#02979b;font-size:25px;margin-bottom:20px}@media (max-width:1024px){.section-how-it-work-slider .slider-title{font-size:20px}}.section-how-it-work-slider .container-image{padding:0 80px 0 10px}@media (max-width:1024px){.section-how-it-work-slider .container-image{order:1}}.section-how-it-work-slider .step-text{font-size:16px;line-height:1.7;margin-bottom:65px;margin-top:21px;text-align:left}.section-how-it-work-slider .step-text.no-margin{margin-bottom:20px}@media (max-width:1024px){.section-how-it-work-slider .step-text{margin-bottom:45px;padding:0 10px 0 0}}.section-how-it-work-slider .step-list{font-size:16px;margin-bottom:8px;text-align:left}.section-how-it-work-slider .step-list:last-of-type.margin{margin-bottom:65px}@media (max-width:1024px){.section-how-it-work-slider .step-list{padding-right:10px}}@media (max-width:1024px){.section-how-it-work-slider{padding:70px 0}}@media (max-width:1024px){.section-how-it-work-slider .order-1-mobile{order:1}}@media (max-width:1024px){.section-how-it-work-slider .order-2-mobile{order:2}}@media (max-width:1024px){.section-how-it-work-slider .container-desktop{display:none}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-how-it-work-slider.vue"],"names":[],"mappings":"AACA,4BACE,iBAAkB,AAClB,eAAgB,AAChB,iBAAmB,CACpB,AACD,kCACI,aAAe,CAClB,AACD,0BACA,kCACQ,+BAAgC,AAChC,mBAAoB,AACpB,gBAAkB,CACzB,CACA,AACD,qCACM,eAAgB,AAChB,gBAAiB,AACjB,wBAA0B,CAC/B,AACD,0BACA,qCACU,cAAgB,CACzB,CACA,AACD,qCACM,eAAgB,AAChB,eAAiB,CACtB,AACD,0BACA,qCACU,cAAgB,CACzB,CACA,AACD,sCACI,eAAgB,AAChB,iBAAkB,AAClB,sBAAuB,AACvB,eAAiB,CACpB,AACD,0BACA,sCACQ,qBAA0B,AAC1B,eAAgB,AAChB,eAAiB,CACxB,CACA,AACD,kCACI,iBAAkB,AAClB,kBAAmB,AACnB,SAAW,CACd,AACD,0BACA,kCACQ,YAAc,CACrB,CACA,AACD,iCACI,yBAA0B,AAC1B,QAAS,AACT,kBAAmB,AACnB,QAAS,AACT,SAAW,CACd,AACD,gCACI,kBAAmB,AACnB,eAAgB,AAChB,gBAAiB,AACjB,sBAAwB,AACxB,qBAAwB,CAC3B,AACD,4CACI,mBAAoB,AACpB,sBAA0B,AAC1B,yBAA0B,AAC1B,kBAAmB,AACnB,cAAe,AACf,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,uBAAwB,AACxB,YAAa,AACb,kBAAmB,AACnB,cAAe,AACf,WAAY,AACZ,SAAW,CACd,AACD,mDACM,qBAAsB,AACtB,mBAAoB,AACpB,UAAe,CACpB,AACD,+CACI,aAAc,AACd,gBAAkB,CACrB,AACD,0BACA,+CACQ,YAAc,CACrB,CACA,AACD,oDACI,cAAe,AACf,iBAAmB,CACtB,AACD,0BACA,oDACQ,SAAW,CAClB,CACA,AACD,2CACI,0BAA+B,AAC/B,gBAAiB,AACjB,gBAAiB,AACjB,gBAAiB,AACjB,SAAU,AACV,gBAAiB,AACjB,kBAAmB,AACnB,SAAW,CACd,AACD,0BACA,2CACQ,YAAc,CACrB,CACA,AACD,8CACI,iBAAkB,AAClB,kBAAmB,AACnB,WAAa,CAChB,AACD,0BACA,8CACQ,WAAa,CACpB,CACA,AACD,4CACI,aAAc,AACd,WAAa,CAChB,AACD,4CACI,mBAAoB,AACpB,UAAW,AACX,kBAAmB,AACnB,QAAU,CACb,AACD,sDACI,YAAc,CACjB,AACD,wCACI,6BAA+B,AAC/B,kBAAmB,AACnB,sBAAwB,AACxB,kBAAoB,AACpB,oBAAuB,CAC1B,AACD,0BACA,wCACQ,kBAAqB,CAC5B,CACA,AACD,0BACA,yDACQ,oBAAuB,CAC9B,CACA,AACD,0BACA,wDACQ,mBAAsB,CAC7B,CACA,AACD,yCACI,qCAA0C,AAC1C,sCAA4C,CAC/C,AACD,yCACI,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,cAAiB,CACpB,AACD,0BACA,yCACQ,cAAgB,CACvB,CACA,AACD,4CACI,eAAgB,AAChB,eAAiB,CACpB,AACD,0BACA,4CACQ,mBAAoB,AACpB,UAAY,CACnB,CACA,AACD,mDACI,qBAAuB,CAC1B,AACD,0BACA,mDACQ,kBAAoB,CAC3B,CACA,AACD,0CACI,gCAAiC,AACjC,cAAe,AACf,eAAgB,AAChB,kBAAoB,CACvB,AACD,0BACA,0CACQ,cAAgB,CACvB,CACA,AACD,6CACI,qBAAuB,CAC1B,AACD,0BACA,6CACQ,OAAS,CAChB,CACA,AACD,uCACI,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,gBAAiB,AACjB,eAAiB,CACpB,AACD,iDACM,kBAAoB,CACzB,AACD,0BACA,uCACQ,mBAAoB,AACpB,kBAAoB,CAC3B,CACA,AACD,uCACI,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CACpB,AACD,2DACM,kBAAoB,CACzB,AACD,0BACA,uCACQ,kBAAoB,CAC3B,CACA,AACD,0BACA,4BACM,cAAkB,CACvB,CACA,AACD,0BACA,4CACM,OAAS,CACd,CACA,AACD,0BACA,4CACM,OAAS,CACd,CACA,AACD,0BACA,+CACM,YAAc,CACnB,CACA","file":"section-how-it-work-slider.vue","sourcesContent":["\n.section-how-it-work-slider {\n  padding: 90px 13%;\n  font-size: 16px;\n  text-align: center;\n}\n.section-how-it-work-slider-title {\n    line-height: 1;\n}\n@media (min-width: 1024px) {\n.section-how-it-work-slider-title {\n        border-right: 2px solid #085f65;\n        padding-right: 28px;\n        text-align: right;\n}\n}\n.section-how-it-work-slider-title h3 {\n      font-size: 30px;\n      font-weight: 900;\n      text-transform: uppercase;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider-title h3 {\n          font-size: 25px;\n}\n}\n.section-how-it-work-slider-title h2 {\n      font-size: 47px;\n      font-weight: 900;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider-title h2 {\n          font-size: 30px;\n}\n}\n.section-how-it-work-slider-subtext p {\n    font-size: 18px;\n    line-height: 23px;\n    margin: 47px auto 72px;\n    max-width: 287px;\n}\n@media (min-width: 1024px) {\n.section-how-it-work-slider-subtext p {\n        margin: 15px 0px 0px 38px;\n        max-width: none;\n        text-align: left;\n}\n}\n.section-how-it-work-slider-steps {\n    margin: 80px auto;\n    position: relative;\n    width: 70%;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider-steps {\n        display: none;\n}\n}\n.section-how-it-work-slider-line {\n    border: 1px solid #02979b;\n    left: 7%;\n    position: absolute;\n    top: 50%;\n    width: 86%;\n}\n.section-how-it-work-slider-btn {\n    border-radius: 8px;\n    font-size: 18px;\n    font-weight: 600;\n    height: 48px !important;\n    width: 206px !important;\n}\n.section-how-it-work-slider .container-step {\n    align-items: center;\n    background-color: #ffffff;\n    border: 1px solid #02979b;\n    border-radius: 50%;\n    color: #02979b;\n    display: flex;\n    font-size: 37px;\n    font-weight: 600;\n    justify-content: center;\n    height: 98px;\n    position: relative;\n    margin: 0 auto;\n    width: 98px;\n    z-index: 1;\n}\n.section-how-it-work-slider .container-step.select {\n      border-color: #ff6e1c;\n      background: #ff6e1c;\n      color: #ffffff;\n}\n.section-how-it-work-slider .container-sliders {\n    height: 510px;\n    min-height: 510px;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .container-sliders {\n        height: 800px;\n}\n}\n.section-how-it-work-slider .slider-image-container {\n    padding: 0 10%;\n    position: relative;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .slider-image-container {\n        padding: 0;\n}\n}\n.section-how-it-work-slider .slider-number {\n    color: rgba(255, 110, 28, 0.1);\n    display: initial;\n    font-size: 400px;\n    font-weight: 900;\n    left: 12%;\n    line-height: 1.3;\n    position: absolute;\n    z-index: 1;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .slider-number {\n        display: none;\n}\n}\n.section-how-it-work-slider .container-phones {\n    margin-left: auto;\n    position: relative;\n    width: 284px;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .container-phones {\n        margin: auto;\n}\n}\n.section-how-it-work-slider .step-image-cel {\n    height: 510px;\n    width: 243px;\n}\n.section-how-it-work-slider .step-image-gif {\n    border-radius: 20px;\n    left: 31px;\n    position: absolute;\n    top: 12px;\n}\n.section-how-it-work-slider .slider-indicators-center {\n    display: none;\n}\n.section-how-it-work-slider .slider-btn {\n    background: #02979b !important;\n    border-radius: 50%;\n    height: 58px !important;\n    top: 50% !important;\n    width: 58px !important;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .slider-btn {\n        top: auto !important;\n}\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .slider-btn.slider-btn-right {\n        right: 10px !important;\n}\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .slider-btn.slider-btn-left {\n        left: 10px !important;\n}\n}\n.section-how-it-work-slider .slider-icon {\n    border-left: 4px solid #ffffff !important;\n    border-bottom: 4px solid #ffffff !important;\n}\n.section-how-it-work-slider .step-number {\n    color: #02979b;\n    font-size: 77px;\n    font-weight: 600;\n    line-height: 0.8;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .step-number {\n        font-size: 60px;\n}\n}\n.section-how-it-work-slider .container-text {\n    padding: 0 25px;\n    text-align: left;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .container-text {\n        padding: 0 0 0 10px;\n        width: 100%;\n}\n}\n.section-how-it-work-slider .container-information {\n    padding: 0 80px 0 10px;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .container-information {\n        padding: 0 0 0 10px;\n}\n}\n.section-how-it-work-slider .slider-title {\n    border-bottom: 3px solid #ff6e1c;\n    color: #02979b;\n    font-size: 25px;\n    margin-bottom: 20px;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .slider-title {\n        font-size: 20px;\n}\n}\n.section-how-it-work-slider .container-image {\n    padding: 0 80px 0 10px;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .container-image {\n        order: 1;\n}\n}\n.section-how-it-work-slider .step-text {\n    font-size: 16px;\n    line-height: 1.7;\n    margin-bottom: 65px;\n    margin-top: 21px;\n    text-align: left;\n}\n.section-how-it-work-slider .step-text.no-margin {\n      margin-bottom: 20px;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .step-text {\n        margin-bottom: 45px;\n        padding: 0 10px 0 0;\n}\n}\n.section-how-it-work-slider .step-list {\n    font-size: 16px;\n    margin-bottom: 8px;\n    text-align: left;\n}\n.section-how-it-work-slider .step-list:last-of-type.margin {\n      margin-bottom: 65px;\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .step-list {\n        padding-right: 10px;\n}\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider {\n      padding: 70px 0px;\n}\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .order-1-mobile {\n      order: 1;\n}\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .order-2-mobile {\n      order: 2;\n}\n}\n@media (max-width: 1024px) {\n.section-how-it-work-slider .container-desktop {\n      display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-how-it-work-slider",attrs:{"id":"stepbystep"}},[_c('div',{staticClass:"container"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"section-how-it-work-slider-title",attrs:{"xs12":"","md5":"","secondary--text":""}},[_c('h3',[_vm._v("¿Cómo funciona")]),_vm._v(" "),_c('h2',[_vm._v("CASAMARKET?")])]),_vm._v(" "),_c('v-flex',{staticClass:"section-how-it-work-slider-subtext",attrs:{"xs12":"","md5":"","info--text":""}},[_c('p',[_vm._v("\n\t\t\t\t\tAñade a tu negocio una potente herramienta de tecnología.\n\t\t\t\t\tTe queremos mostrar lo sencillo que es usar CasaMarket\n\t\t\t\t")])])],1),_vm._v(" "),_c('div',{staticClass:"section-how-it-work-slider-steps"},[_c('v-layout',_vm._l((_vm.items),function(item){return _c('v-flex',{key:item.id},[_c('button',{staticClass:"container-step",class:{ 'select' : item.number - 1 === _vm.sliderIndex},on:{"click":function($event){_vm.moveToIndex(item.number)}}},[_vm._v(_vm._s(item.id))])])})),_vm._v(" "),_c('hr',{staticClass:"section-how-it-work-slider-line"})],1),_vm._v(" "),_c('div',{staticClass:"container-sliders"},[_c('slider',{attrs:{"animation":"fade","speed":2000,"stop-on-hover":true,"autoplay":false,"touch":false,"height":"100%"},model:{value:(_vm.sliderIndex),callback:function ($$v) {_vm.sliderIndex=$$v},expression:"sliderIndex"}},_vm._l((_vm.items),function(item){return _c('slider-item',{key:item.id},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"order-2-mobile",attrs:{"md6":"","xs12":""}},[_c('div',{staticClass:"slider-image-container"},[_c('div',{staticClass:"slider-number"},[_vm._v(_vm._s(item.number))]),_vm._v(" "),_c('div',{staticClass:"container-phones"},[_c('img',{staticClass:"step-image-cel",attrs:{"src":item.imageSecond,"alt":"tu cliente realiza el pedido","height":"592"}})])])]),_vm._v(" "),_c('v-flex',{staticClass:"layout order-1-mobile",attrs:{"md6":"","xs12":""}},[_c('v-layout',{attrs:{"wrap":"","align-content-end":""}},[_c('v-flex',{staticClass:"container-image",attrs:{"xs12":"","mb-3":""}},[_c('img',{staticClass:"container-desktop",attrs:{"src":item.image,"alt":item.title,"height":"150"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"layout container-information"},[_c('div',{staticClass:"step-number"},[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('div',{staticClass:"container-text"},[_c('h3',{staticClass:"slider-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(item.text)?[_c('p',{staticClass:"step-text info--text",class:{ 'no-margin': item.list }},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.text)+"\n\t\t\t\t\t\t\t\t\t\t\t\t")])]:_vm._e(),_vm._v(" "),(item.list)?[_vm._l((item.list),function(li,index){return [_c('p',{key:index,staticClass:"step-list info--text",class:{ 'margin': li.list }},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t- "+_vm._s(li)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3 container-desktop"},[_c('v-btn',{staticClass:"btn-action btn-auto section-how-it-work-slider-btn white--text",attrs:{"color":"primary","depressed":""},on:{"click":function($event){_vm.$emit('open-modal-btn')}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tSOLICITA TU APP\n\t\t\t\t\t\t\t\t\t\t\t\t")])],1)],2)])])],1)],1)],1)],1)}))],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_our_plans_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac475b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_our_plans_vue__ = __webpack_require__(478);
function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var normalizeComponent = __webpack_require__(127)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_our_plans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac475b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_our_plans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(477);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("0f92a8bc", content, true, {});

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-our-plans{background:#f5fbfb;padding:80px 10%}.section-our-plans-title{color:#085f65;font-size:30px;font-weight:900;text-align:center}.section-our-plans-container{background:#085f65;border-radius:17px;color:#fff;font-size:16px;margin:0 auto 35px;max-width:288px;padding:0 0 40px;position:relative;text-align:center;width:90%}.section-our-plans-btn{background:#ff6e1c;border-radius:8px;color:#fff;display:inline-block;font-size:20px;font-weight:900;padding:18px 0;text-decoration:none;width:259px}@media (max-width:960px){.section-our-plans-btn{display:none}}.section-our-plans-btn-mobile{background:#ff6e1c;border-radius:5px;display:none;color:#fff;font-size:14px;font-weight:900;padding:7px 18px}@media (max-width:960px){.section-our-plans-btn-mobile{display:inline-block}}.section-our-plans .text-title{font-weight:600;text-transform:uppercase}.section-our-plans .text-number{font-size:26px;font-weight:900}.section-our-plans .subtext{font-size:18px;font-weight:600}.section-our-plans .text-alert{background:#ff6e1c;border-radius:0 17px 0 17px;font-size:12px;padding:8px;position:absolute;top:0;right:0}.section-our-plans .h-40{height:40px}.image-plan{max-width:100%}.dialog{box-shadow:none!important}.container-image-plan{position:relative}.image-plan-btn{position:absolute;right:10px;top:10px}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/section-our-plans.vue"],"names":[],"mappings":"AACA,mBACE,mBAAoB,AACpB,gBAAkB,CACnB,AACD,yBACI,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,6BACI,mBAAoB,AACpB,mBAAoB,AACpB,WAAe,AACf,eAAgB,AAChB,mBAAyB,AACzB,gBAAiB,AACjB,iBAAoB,AACpB,kBAAmB,AACnB,kBAAmB,AACnB,SAAW,CACd,AACD,uBACI,mBAAoB,AACpB,kBAAmB,AACnB,WAAe,AACf,qBAAsB,AACtB,eAAgB,AAChB,gBAAiB,AACjB,eAAgB,AAChB,qBAAsB,AACtB,WAAa,CAChB,AACD,yBACA,uBACQ,YAAc,CACrB,CACA,AACD,8BACI,mBAAoB,AACpB,kBAAmB,AACnB,aAAc,AACd,WAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,gBAAkB,CACrB,AACD,yBACA,8BACQ,oBAAsB,CAC7B,CACA,AACD,+BACI,gBAAiB,AACjB,wBAA0B,CAC7B,AACD,gCACI,eAAgB,AAChB,eAAiB,CACpB,AACD,4BACI,eAAgB,AAChB,eAAiB,CACpB,AACD,+BACI,mBAAoB,AACpB,4BAA6B,AAC7B,eAAgB,AAChB,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAS,CACZ,AACD,yBACI,WAAa,CAChB,AACD,YACE,cAAgB,CACjB,AACD,QACE,yBAA4B,CAC7B,AACD,sBACE,iBAAmB,CACpB,AACD,gBACE,kBAAmB,AACnB,WAAY,AACZ,QAAU,CACX","file":"section-our-plans.vue","sourcesContent":["\n.section-our-plans {\n  background: #f5fbfb;\n  padding: 80px 10%;\n}\n.section-our-plans-title {\n    color: #085f65;\n    font-size: 30px;\n    font-weight: 900;\n    text-align: center;\n}\n.section-our-plans-container {\n    background: #085f65;\n    border-radius: 17px;\n    color: #ffffff;\n    font-size: 16px;\n    margin: 0 auto 35px auto;\n    max-width: 288px;\n    padding: 0 0 40px 0;\n    position: relative;\n    text-align: center;\n    width: 90%;\n}\n.section-our-plans-btn {\n    background: #ff6e1c;\n    border-radius: 8px;\n    color: #ffffff;\n    display: inline-block;\n    font-size: 20px;\n    font-weight: 900;\n    padding: 18px 0;\n    text-decoration: none;\n    width: 259px;\n}\n@media (max-width: 960px) {\n.section-our-plans-btn {\n        display: none;\n}\n}\n.section-our-plans-btn-mobile {\n    background: #ff6e1c;\n    border-radius: 5px;\n    display: none;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 900;\n    padding: 7px 18px;\n}\n@media (max-width: 960px) {\n.section-our-plans-btn-mobile {\n        display: inline-block;\n}\n}\n.section-our-plans .text-title {\n    font-weight: 600;\n    text-transform: uppercase;\n}\n.section-our-plans .text-number {\n    font-size: 26px;\n    font-weight: 900;\n}\n.section-our-plans .subtext {\n    font-size: 18px;\n    font-weight: 600;\n}\n.section-our-plans .text-alert {\n    background: #ff6e1c;\n    border-radius: 0 17px 0 17px;\n    font-size: 12px;\n    padding: 8px;\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n.section-our-plans .h-40 {\n    height: 40px;\n}\n.image-plan {\n  max-width: 100%;\n}\n.dialog {\n  box-shadow: none !important;\n}\n.container-image-plan {\n  position: relative;\n}\n.image-plan-btn {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-our-plans",attrs:{"id":"plans"}},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"section-our-plans-title mb-5"},[_vm._v("NUESTROS PLANES")]),_vm._v(" "),(_vm.code === 'PE')?_c('div',[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.items),function(item){return _c('v-flex',{key:item.id,attrs:{"md4":"","xs12":""}},[_c('div',{staticClass:"section-our-plans-container"},[(item.showAlert)?_c('div',{staticClass:"text-alert"},[_vm._v("\n\t\t\t\t\t\t\tRECOMENDADO\n\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"h-40"}),_vm._v(" "),_c('p',{staticClass:"mb-2 text-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"mb-2 text-number"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('p',{staticClass:"mb-2 subtext"},[_vm._v(_vm._s(item.subtext))]),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('button',{staticClass:"section-our-plans-btn-mobile",on:{"click":function($event){_vm.openPlanMobile(item)}}},[_vm._v("Ver detalle")])])])])})),_vm._v(" "),_vm._m(0)],1):_c('div',[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},_vm._l((_vm.itemsEcu),function(item){return _c('v-flex',{key:item.id,attrs:{"md4":"","xs12":""}},[_c('div',{staticClass:"section-our-plans-container"},[_c('div',{staticClass:"h-40"}),_vm._v(" "),_c('p',{staticClass:"mb-2 text-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"mb-2 text-number"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('p',{staticClass:"mb-2 subtext"},[_vm._v(_vm._s(item.subtext))]),_vm._v(" "),_c('p',{staticClass:"mb-2 subtext"},[_vm._v(_vm._s(item.textInformation))])])])}))],1)]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('div',{staticClass:"container-image-plan"},[_c('v-btn',{staticClass:"image-plan-btn",attrs:{"depressed":"","flat":"","icon":""},on:{"click":_vm.closeModal}},[_c('img',{attrs:{"src":"/static/images/sections/close-white.svg","alt":"cerrar","height":"20"}})]),_vm._v(" "),_c('img',{staticClass:"image-plan",attrs:{"src":_vm.urlImage,"alt":"planes"}})],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('a',{staticClass:"section-our-plans-btn",attrs:{"href":"https://mibodega.s3-sa-east-1.amazonaws.com/planes-casa-market-nuevo.pdf","target":"_blank"}},[_vm._v("VER DETALLE")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-home"},[_c('app-header',{attrs:{"link":_vm.landingLink}}),_vm._v(" "),_c('banner',{attrs:{"number-money":_vm.numberMoney,"code":_vm.countryCode,"link":_vm.landingLink,"lat":_vm.lat,"lon":_vm.lon},on:{"open-modal":_vm.openRegisterBanner,"open-modal-btn":_vm.openRegister}}),_vm._v(" "),_c('section-mobile',{on:{"open-modal-btn":_vm.openRegister}}),_vm._v(" "),_c('section-about'),_vm._v(" "),_c('section-how-it-work-slider',{attrs:{"link":_vm.landingLink},on:{"open-modal-btn":_vm.openRegister}}),_vm._v(" "),_c('section-slider'),_vm._v(" "),_c('section-features',{on:{"open-modal-btn":_vm.openRegister}}),_vm._v(" "),_c('section-our-plans',{attrs:{"code":_vm.countryCode}}),_vm._v(" "),_c('section-banner',{attrs:{"link":_vm.landingLink,"number-money":_vm.numberMoney,"discount-money":_vm.discountMoney}}),_vm._v(" "),_c('section-faq',{attrs:{"landing-link":_vm.landingLink,"code":_vm.countryCode},on:{"open-register":_vm.openRegister}}),_vm._v(" "),_c('section-brand'),_vm._v(" "),_c('section-addresses'),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.closeModal($event)}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"container-iframe"},[_c('div',{staticClass:"container-close"},[_c('v-btn',{attrs:{"depressed":"","flat":"","icon":""},on:{"click":_vm.closeModal}},[_c('img',{attrs:{"src":"/static/images/sections/close.svg","alt":"cerrar","height":"20"}})])],1),_vm._v(" "),_c('iframe',{staticStyle:{"border":"0px #ffffff none"},attrs:{"src":_vm.linkPageIFrame,"name":"myiFrame","scrolling":"no","frameborder":"1","marginheight":"0px","marginwidth":"0px","height":"600","width":"100%","allow":"geolocation","allowfullscreen":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"container-progrees"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"indeterminate":"","color":"teal darken-1"}})],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]));


// WEBPACK FOOTER //
// static/js/0.b45b3eeb0820226fba56.js